<template>
  <div class="create-live-wrapper">
    <b-container fluid>
      <b-form
        @submit.prevent="handleSubmit"
        @reset="onReset"
        ref="form"
        class="needs-validation"
        :class="{ 'was-validated': $v.form.$anyDirty, 'not-ready': isEditMode && !ready }"
        novalidate
      >
        <div class="text-right mb-2 d-lg-none">
          <b-button variant="light" type="button" class="mr-2" @click="goToListLive">{{
            $t('button.cancel')
          }}</b-button>
          <b-button
            variant="primary"
            type="submit"
            @mousedown="submitForm"
            :disabled="$v.form.$error || btnDisabled || (!confirmClicked && imageIsPicked)"
            >{{ $t('button.save') }}</b-button
          >
        </div>
        <div class="tabs-wrapper">
          <b-tabs v-if="isEmpreinteClient" content-class="mt-3" :noKeyNav="true">
            <b-tab active>
              <template slot="title">
                <div>
                  <font-awesome-icon icon="pen" />
                </div>
                <div class="d-none d-md-block ml-2">{{ $t('form_live.tabs.general.title') }}</div>
              </template>
              <div class="settings-section collapsible-section">
<div class="section-header" @click="toggleSection('general')">
<label class="primary">{{ $t('button.infos') }}</label>
<font-awesome-icon :icon="sections.general ? 'chevron-up' : 'chevron-down'" />
</div>
<b-collapse :visible="sections.general" id="collapse-general" >
           <div class="collapse-content">
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group
                    :description="$t('form_live.tabs.general.form.description_image')"
                    :label="$t('form_live.tabs.general.form.add_image')"
                    label-for="live-thumbnail"
                    label-class="primary"
                  >
                  <thumbnail-cropper
  :crop-img="form.thumbnail"
  @thumbnailUpdated="handleThumbnailUpdated"
/>
                  </b-form-group>
                </b-col>
                <b-col md="8" sm="12">
                  <div class="form-group">
                    <label for="title" class="required primary">{{
                      $t('form_live.tabs.general.form.title')
                    }}</label>
                    <input
                      :placeholder="$t('form_live.tabs.general.form.title')"
                      type="text"
                      v-model="form.title"
                      id="title"
                      name="title"
                      class="form-control"
                      required
                    />
                    <div v-if="!$v.form.title.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="description" class="required primary">{{
                      $t('form_live.tabs.general.form.description')
                    }}</label>
                    <textarea
                      v-model="form.description"
                      class="form-control "
                      id="description"
                      :placeholder="$t('form_live.tabs.general.form.description')"
                      required
                      rows="3"
                    ></textarea>
                    <div v-if="!$v.form.description.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                  </div>
                  <div class="form-group" v-has-permission="'lives_type'" has-permission="lives_type">
                    <label class="primary">{{ $t('form_live.tabs.general.form.types') }}</label>
                    <multiselect
                      v-model="form.types"
                      :options="liveTypesOptions"
                      :multiple="false"
                      track-by="id"
                      label="title"
                      :close-on-select="false"
                      placeholder=""
                      :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                      :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                      :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
            
                    >
                      <span slot="noResult">{{
                        $t('form_live.tabs.advanced.contributors.no_result')
                      }}</span>
                      <span slot="noOptions">{{
                        $t('form_live.tabs.advanced.contributors.no_options')
                      }}</span>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.title }}</strong>
                      </template>

                      <template slot="option" slot-scope="{ option }">
                        <div :style="{ 'margin-left': option.index + 'em' }">
                          {{ option.title }}
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <div
                    class="form-group"
                    :class="{ 'is-invalid__custom': $v.form.startDate.$invalid }"
                  >
                    <label class="required primary">{{
                      $t('form_live.tabs.general.form.start_date')
                    }}</label>
                    <div id="filter-date" class="input_css input filter-date ">
                      <datepicker
                        id="start-date"
                        v-model="form.startDate"
                        input-class="form-control selectedDate"
                        wrapper-class="start-date-picker"
                        :bootstrap-styling="true"
                        :calendar-button="true"
                        :required="true"
                        :lang="$i18n.locale"
                        :disabled-days="disabledDate"
                        :format="'YYYY-MM-DD'"
                        value-type="format"
                        :active-color="getActiveColor"
                        :clearable="false"
                        :editable="false"
                      >
                        <template slot="calendar-icon">
                          <font-awesome-icon
                            class="calendar-icon "
                            :icon="{ prefix: 'fas', iconName: 'calendar-alt' }"
                          />
                        </template>
                      </datepicker>
                    </div>

                    <div v-if="!$v.form.startDate.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div v-else-if="!$v.form.startDate.minValue" class="invalid-feedback">
                      {{ $t('form_live.tabs.general.form.invalid_date') }}
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div
                    class="form-group"
                    :class="{ 'is-invalid__custom': $v.form.startTime.$invalid }"
                  >
                    <label for="start-time" class="required primary">{{
                      $t('form_live.tabs.general.form.start_hour')
                    }}</label>
                    <vue-clock-picker
                      id="start-time"
                      v-model="form.startTime"
                      input-class="form-control"
                      :active-color="getActiveColor"
                      :required="false"
                      :cancel-text="$t('button.cancel')"
                      :done-text="$t('button.done')"
                      :close-on-overlay="closeOnOverlay"
                      @close="closeModal"
                      @beforeOpen="handleBeforeOpen"
                    >
                    </vue-clock-picker>
                    <div v-if="!$v.form.startTime.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div v-else-if="!$v.form.startTime.minValue" class="invalid-feedback">
                      {{ $t('form_live.tabs.general.form.invalid_hour') }}
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div
                    class="form-group"
                    :class="{ 'is-invalid__custom': $v.form.endTime.$invalid }"
                  >
                    <label for="end-time" class="required primary">{{
                      $t('form_live.tabs.general.form.end_hour')
                    }}</label>
                    <vue-clock-picker
                      id="end-time"
                      v-model="form.endTime"
                      input-class="form-control"
                      :active-color="getActiveColor"
                      :required="false"
                      :cancel-text="$t('button.cancel')"
                      :done-text="$t('button.done')"
                      :close-on-overlay="closeOnOverlay"
                      @close="closeModal"
                      @beforeOpen="handleBeforeOpen"
                    >
                    </vue-clock-picker>
                    <div v-if="!$v.form.endTime.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div v-else-if="!$v.form.endTime.minValue" class="invalid-feedback">
                      {{ $t('form_live.tabs.general.form.invalid_hour') }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <div class="form-group">
                    <label class="primary">{{ $t('form_live.tabs.general.form.tags') }}</label>
                    <input-tag v-model="form.tags"
                    @input="handleAddInputTags"
                    :add-tag-on-keys=[13,32]
                    ></input-tag>
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="form-group">
                    <label class="primary">{{ $t('form_live.tabs.general.form.themes') }}</label>
                    <multiselect
                      v-model="form.themes"
                      :options="themesOptions"
                      :multiple="true"
                      track-by="id"
                      label="title"
                      :close-on-select="true"
                      placeholder=""
                      :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                      :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                      :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                    >
                      <span slot="noResult">{{
                        $t('form_live.tabs.advanced.contributors.no_result')
                      }}</span>
                      <span slot="noOptions">{{
                        $t('form_live.tabs.advanced.contributors.no_options')
                      }}</span>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.title }}</strong>
                      </template>

                      <template slot="option" slot-scope="{ option }">
                        <div :style="{ 'margin-left': option.index + 'em' }">
                          {{ option.title }}
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </b-col>
              </b-row>
              </div>
              </b-collapse>
              </div>
            
            </b-tab>
            <b-tab>
              <template slot="title">
                <div>                     
                <font-awesome-icon icon="cog" />
                </div>
                <div class="d-none d-md-block ml-2">{{ $t('form_live.tabs.advanced.title') }}</div>
              </template>
               <div  v-has-permission="'lives_type_no_api'" has-permission="lives_type_no_api" class="settings-section collapsible-section">
    <div  class="section-header" @click="toggleSection('diffusion')">
      <label v-has-permission="getDifferentDiffusionPermission" class="primary mb-0">
        {{ $t('form_live.tabs.advanced.type.title') }}
      </label>
      <i class="fa" :class="sections.diffusion ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  <font-awesome-icon :icon="sections.diffusion ? 'chevron-up' : 'chevron-down'" />

    </div>
    <b-collapse :visible="sections.diffusion" id="collapse-diffusion">
              <div class="form-group collapse-content" v-has-permission="'lives_type_no_api'" has-permission="lives_type_no_api">
                <label class="primary">{{  $t('form_live.tabs.advanced.type.title') }}</label>
                <b-form-radio-group v-model="form.isCdn" name="type">
                  <b-form-radio :value="false">{{
                    $t('form_live.tabs.advanced.type.intranet')
                  }}</b-form-radio>
                  <b-form-radio :value="true">{{
                    $t('form_live.tabs.advanced.type.internet')
                  }}</b-form-radio>
                </b-form-radio-group>
              </div>
             
    </b-collapse>
    </div>
              <div
                class="form-group settings-section collapsible-section"
                v-has-permission="getDifferentDiffusionPermission"
              >
              <div class="section-header" @click="toggleSection('sources')">

                <label class="primary">{{$t('form_live.tabs.advanced.diffusion.title_empreinte')}}</label>
                 <i class="fa" :class="sections.sources ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  <font-awesome-icon :icon="sections.sources ? 'chevron-up' : 'chevron-down'" />
                  </div>
                  <b-collapse  :visible="sections.sources" id="collapse-source"  :key="'sources-' + form.diffusion">
                    <div class="collapse-content">
                <b-form-radio-group v-model="form.diffusion" name="diffusion" @input="handleDiffusionTypeChanged('diffusion')">
                  <b-row>
                    <template>
  <b-col
    xl="4"
    lg="4"
    md="4"
    sm="12"
    class="order-1 order-md-0"
    v-has-permission="'lives_webinar_no_api'"
  >
                      <b-form-radio value="webinar" @change="onWebinarChange">
                        <font-awesome-icon
  class="actionIcons btn-icons video-icon"
  :icon="{ prefix: 'fas', iconName: 'video' }"
/>

                        {{
                       $t('form_live.tabs.advanced.diffusion.webinar_empreinte')
                      }}
                      </b-form-radio>
	                    </b-col>
                    </template>
<b-col xl="4" lg="4" md="4" sm="12">
	  <b-form-radio 
	    :value="'isPearl'"
	    class="radio-check-white"
	    v-has-permission="'lives_encoder_no_api'" 
	    has-permission="lives_encoder_no_api"
	  >
	  <font-awesome-icon
  class="actionIcons btn-icons server-icon"
  :icon="{ prefix: 'fas', iconName: 'server' }"
/>
    {{$t('form_live.tabs.advanced.diffusion.encodeur_empreinte')}}
  </b-form-radio>
    <div v-if="form.diffusion === 'isPearl'" class="encoder-options mt-3 ml-3">
    <b-form-radio-group 
      v-model="form.isAuto" 
      name="encoder-type-group"
      @input="handleEncoderTypeChange"
    >
      <b-form-radio
        :value="false"
        v-has-permission="'lives_encoder_no_api'"
        has-permission="lives_encoder_no_api"
      >

        {{ $t('form_live.tabs.advanced.diffusion.encoding') }}
      </b-form-radio>
      <b-form-radio
      v-if="hasPermission('lives_encoder_external_no_api')"
      :value="true"
        v-has-permission="'lives_encoder_external_no_api'"
        has-permission="lives_encoder_external_no_api"
      >
        {{ $t('form_live.tabs.advanced.diffusion.encodeur_automatique') }}
      </b-form-radio>
    </b-form-radio-group>
    <!-- <div v-if="form.encoderType === 'manual'" class="mt-3">
      <div class="mb-2">
        <label for="manual-station-select" class="font-weight-bold">
          {{ $t('form_live.tabs.advanced.diffusion.select_station') }}
        </label>
        <b-form-select
          id="manual-station-select"
          v-model="form.selectedManualStation"
          :options="manualStations"
          :disabled="loadingManualStations"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              {{ loadingManualStations ? $t('form_live.tabs.advanced.diffusion.loading_stations') : $t('form_live.tabs.advanced.diffusion.select_station') }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </div>
    </div> -->

    <div v-if="form.isAuto" class="mt-3">
      <div class="mb-2">
        <label for="automatic-station-select" class="required primary">
          {{ $t('form_live.tabs.advanced.diffusion.select_station') }}
        </label>
        <b-form-select
  id="automatic-station-select"
  v-model="form.stationId"
  :options="automaticStations"
  value-field="id"
  text-field="name"
  :disabled="loadingAutomaticStations"
  @change="onStationChange"
  required
>
  <template #first>
    <option :value="null" disabled>
      {{ loadingAutomaticStations
        ? $t('form_live.tabs.advanced.diffusion.loading_stations')
        : $t('form_live.tabs.advanced.diffusion.select_station') }}
    </option>
  </template>
</b-form-select>
      </div>
    </div>
        <div v-if="form.isAuto" class="mt-3">
      <b-row>
        <b-col cols="6" class="mb-2">
          <label for="encoder-input-1" class="form-label">
            {{ $t('form_live.tabs.advanced.diffusion.index_video_port') }} :
          </label>
          <b-form-input
            id="encoder-input-1"
            v-model="form.videoPortIndex"
            type="number"
            min="0"
            placeholder="0"
            :readonly="isUnescoClient"
          ></b-form-input>
          <small v-if="isUnescoClient" class="text-muted">
          </small>
        </b-col>
        <b-col cols="6" class="mb-2">
          <label for="encoder-input-2" class="form-label">
            {{ $t('form_live.tabs.advanced.diffusion.index_audio_port') }} :
          </label>
          <b-form-input
            id="encoder-input-2"
            v-model="form.audioPortIndex"
            type="number"
            min="0"
            placeholder="0"
            :readonly="isUnescoClient"
          ></b-form-input>
          <small v-if="isUnescoClient" class="text-muted">
          </small>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col cols="12">
          <label for="protocol-select" class="form-label">
            {{ $t('form_live.tabs.advanced.diffusion.protocol') }}
          </label>
          <b-form-select
            id="protocol-select"
            v-model="form.protocolType"
            :options="protocolOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
  </div>
</b-col>
                    <b-col xl="4" lg="4"  md="4" sm="12">
<template v-if="hasPermission('')">
	                    <b-form-radio
	                        value="externalHls"
	                        class="radio-check-white"
	                        v-has-permission="''"
	                        >
	                        <font-awesome-icon
	  class="actionIcons btn-icons network-icon"
  :icon="{ prefix: 'fas', iconName: 'network-wired' }"
/>

                        {{ $t('form_live.tabs.advanced.diffusion.externalHlst') }}
                      </b-form-radio>

                      <div v-show="form.externalHls" >
                        <b-form-input @input="setHls"
                        v-model="form.linkHls" v-has-permission="''"></b-form-input>
                      </div>
</template>

                    </b-col>
                    <b-col xl="4" lg="4"  md="4" sm="12">
                    </b-col>
                  </b-row>
                </b-form-radio-group>
	               </div>
	              </b-collapse>
	              </div>
	              <div
	                v-if="form.diffusion==='webinar' && form.webinar"
	                class="form-group settings-section collapsible-section"
	                v-has-permission="'lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'"
	                has-permission="lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api"
	              >
	                <div class="section-header" @click="toggleSection('connexionEmpreinte')">
	                  <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.connexion.title_empreinte') }}</label>
	                  <i class="fa" :class="sections.connexionEmpreinte ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
	                  <font-awesome-icon :icon="sections.connexionEmpreinte ? 'chevron-up' : 'chevron-down'" />
	                </div>
	                <b-collapse :visible="sections.connexionEmpreinte" id="collapse-connexion-empreinte" :key="'connexion-empreinte-' + form.connexionType">
	                  <div class="collapse-content">
	                    <b-form-radio-group v-model="form.connexionType" @input="handleDiffusionTypeChanged('connexionType')">
	                      <b-row class="webinar-type__radio">
	                        <div class="webinar-type__radio col-12" v-has-permission="'lives_webinar_connexion_auto_no_api'" has-permission="lives_webinar_connexion_auto_no_api">
	                          <b-form-radio value="auto">
	                            {{ $t('form_live.tabs.advanced.diffusion.connexion.auto') }}
	                            <small class="text-muted ml-1">({{ $t('form_live.tabs.advanced.diffusion.connexion.auto_description') }})</small>
	                          </b-form-radio>
	                        </div>
	                        <div class="webinar-type__radio col-12" v-has-permission="'lives_webinar_connexion_by_authorization_no_api'" has-permission="lives_webinar_connexion_by_authorization_no_api">
	                          <b-form-radio value="by_authorization">
	                            {{ $t('form_live.tabs.advanced.diffusion.connexion.by_authorization') }}
	                            <small class="text-muted ml-1">({{ $t('form_live.tabs.advanced.diffusion.connexion.by_authorization_description') }})</small>
	                          </b-form-radio>
	                        </div>
	                      </b-row>
	                    </b-form-radio-group>
	                  </div>
	                </b-collapse>
	              </div>
                <div
			                v-if="form.diffusion==='webinar' && form.webinar"
			                class="form-group settings-section collapsible-section"
			                v-has-permission="'lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'"
			                has-permission="lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api"
			              >
			                <div class="section-header" @click="toggleSection('consent')">
			                  <label class="primary">{{ $t('form_live.consent.title') }}</label>
			                  <font-awesome-icon :icon="sections.consent ? 'chevron-up' : 'chevron-down'" />
			                </div>
			                <b-collapse :visible="sections.consent" id="collapse-consent">
			                  <div class="collapse-content">
			                    <b-form-radio-group v-model="form.record_with_permission" name="consent">
			                      <b-form-radio :value="false">
			                        {{ $t('form_live.consent.noConsent') }}
			                      </b-form-radio>
			                      <b-form-radio :value="true">
			                        {{ $t('form_live.consent.withConsent') }}
			                      </b-form-radio>
			                    </b-form-radio-group>
			                  </div>
			                </b-collapse>
			              </div>

	               <div class="form-group settings-section collapsible-section" v-show="filteredTypesToShow.length>0 && (
	                (form.diffusion =='webinar'  && hasPermission('lives_type_meeting,lives_type_webinar')) 
	                || 
	                 (form.diffusion == 'isPearl' && hasPermission('lives_type_webcast') ))"
                  >
                  <div class="section-header" @click="toggleSection('typeLive')">
                            <label class="primary">{{  $t('form_live.tabs.advanced.diffusion.type_source') }}</label>
                             <i class="fa" :class="sections.typeLive ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  <font-awesome-icon :icon="sections.typeLive ? 'chevron-up' : 'chevron-down'" />
                             </div>
                 <b-collapse :visible="sections.typeLive" id="collapse-type" :key="'typeLive'">
  <div class="collapse-content">
    
    <!-- Add a wrapper div with v-show instead of conditional rendering -->
    <div v-show="filteredTypesToShow.length > 0">
      <b-form-radio-group 
        v-model="form.sourceTypeId" 
        @input="handleSourceTypeInput"
        :key="'source-type-group'"
      >
        <b-form-radio
          v-for="option in filteredTypesToShow"
          :key="'type-' + option.id"
          :value="option.id"
        >
          {{ $t(option.type) }}
        </b-form-radio>
      </b-form-radio-group>
    </div>
  </div>
</b-collapse>
                        </div>
  <div class="form-group settings-section collapsible-section" v-show="form.diffusion =='webinar' && hasPermission('lives_social_media_no_api') ">
                  <div class="section-header" @click="toggleSection('social_media')">
                            <label class="primary">{{  $t('form_live.tabs.advanced.diffusion.diffusion_social_media') }}</label>
                             <i class="fa" :class="sections.social_media ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  <font-awesome-icon :icon="sections.social_media ? 'chevron-up' : 'chevron-down'" />
                             </div>
                 <b-collapse :visible="sections.social_media" id="collapse-type" :key="'social_media'">
  <div class="collapse-content">
    
   <b-col md="12" sm="12" v-show="form.diffusion=='webinar'" v-has-permission="'lives_social_media_no_api'" has-permission="lives_social_media_no_api">
                    <div  class="form-group">
                 
                        <b-form-checkbox
                          v-model="form.foFacebook"
                          :inline="true"
                          aria-label="ddd"
                          >{{
                            $t('form_live.tabs.frontOffice.options.social_media.fb')
                          }}</b-form-checkbox
                        >
                        <b-form-checkbox v-model="form.foYoutube" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.social_media.youtube')
                        }}</b-form-checkbox>
                          <b-form-checkbox v-if="isEmpreinteClient" v-model="form.foX" :inline="true">{{
                          'X'
                        }}</b-form-checkbox>
                         <b-form-checkbox  v-if="isEmpreinteClient" v-model="form.foLinkedin" :inline="true">{{
                          'LinkedIn'
                        }}</b-form-checkbox>
                    </div>
                  </b-col>
  </div>
</b-collapse>
                        </div>
 <div  v-if="form.diffusion=='webinar' && (hasPermission('lives_fo_whiteboard_no_api') || hasPermission('lives_fo_poll_no_api') || hasPermission('lives_fo_question_no_api') || hasPermission('lives_fo_excel_no_api'))" class="settings-section collapsible-section" >
                <div class="section-header" @click="toggleSection('tools')">
                <label v-if="hasPermission('lives_fo_whiteboard_no_api') || hasPermission('lives_fo_poll_no_api') || hasPermission('lives_fo_question_no_api') || hasPermission('lives_fo_excel_no_api')" class="primary">{{  $t('form_live.tabs.frontOffice.options.interactive_tools.title') }}</label>
              <font-awesome-icon :icon="sections.tools ? 'chevron-up' : 'chevron-down'" /> 
              </div>
              <b-collapse :visible="sections.tools" id="collapse-diffusion" >
               <div class="collapse-content">
                <b-row>                
                    <b-col md="12" sm="12"  >
                    <div class="form-group">
                      <div>                    
                        <b-form-checkbox
                        v-has-permission="'lives_fo_whiteboard_no_api'" has-permission="lives_fo_whiteboard_no_api"
                          v-model="form.whiteboard"
                          :inline="true"
                          aria-label="ddd"
                          >{{
                            $t('form_live.tabs.frontOffice.options.interactive_tools.whiteBoard')
                          }}</b-form-checkbox
                        >
                        <b-form-checkbox
                        v-has-permission="'lives_fo_poll_no_api'" has-permission="lives_fo_poll_no_api"
                        v-model="form.poll" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.interactive_tools.survey')
                        }}</b-form-checkbox>
                            <b-form-checkbox
                            v-has-permission="'lives_fo_question_no_api'" has-permission="lives_fo_question_no_api"
                            v-model="form.qna" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.interactive_tools.question')
                        }}</b-form-checkbox>
                            <b-form-checkbox
                            v-has-permission="'lives_fo_excel_no_api'" has-permission="lives_fo_excel_no_api"
                            v-model="form.spreadsheet_excel" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.interactive_tools.excel')
                        }}</b-form-checkbox>
                        <b-form-checkbox v-if="isEmpreintePollClient" v-model="form.autoSip" :inline="true">
                          {{ $t('form_live.tabs.frontOffice.options.interactive_tools.autoSip') }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>
                </b-row> 
                </div>
              </b-collapse>
              </div>
              <div class="form-group">
                <div  v-has-permission="'lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'" class="settings-section collapsible-section" v-show="(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl') && isEmpreinteClient">
               <div class="section-header" @click="toggleSection('options')">
                <label
                  class="primary"
                  v-has-permission="'lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'"
                  has-permission="lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api"
                  >{{ $t('form_live.tabs.advanced.options.title_empreinte') }}</label>
                  <font-awesome-icon :icon="sections.options ? 'chevron-up' : 'chevron-down'" />
                  </div>
                  <b-collapse :visible="sections.options" id="collapse-options">
                <div class="collapse-content">
                <b-row>
                  <!-- This code will be annotated if needed later. -->
                  
                  <!-- <b-col md="3" sm="12" v-has-permission="'lives_private_no_api'" has-permission="lives_private_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.private">{{
                        $t('form_live.tabs.advanced.options.private_video')
                      }}</b-form-checkbox>
                    </div>
                  </b-col> -->
                  <!-- <b-col md="4" sm="12" v-has-permission="'lives_active_no_api'" has-permission="lives_active_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.active">{{
                        $t('form_live.tabs.advanced.options.active_video')
                      }}</b-form-checkbox>
                    </div>
                  </b-col> -->
                  <b-col md="4" sm="12" >
                    <div class="form-group">
                        <b-form-checkbox v-model="form.isRecorded" class="form-group">{{$t('form_live.tabs.advanced.options.saveVideo')}} </b-form-checkbox>
                        <b-form-group v-if="form.isRecorded" v-has-permission="'lives_autopub_no_api'" has-permission="lives_autopub_no_api">
                          <b-form-checkbox v-model="form.autoPublish">{{
                            $t('form_live.tabs.advanced.options.automatic_share')
                          }}</b-form-checkbox>
                        </b-form-group>
                    </div>
                  </b-col>
                  <b-col md="4" sm="12" v-has-permission="'lives_dvr_no_api'" has-permission="lives_dvr_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.isDvr">DVR</b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>
                </div>
                </b-collapse>
                </div>

                 <div class="fields-example">
           <div v-show="form.diffusion == 'isPearl'" v-has-permission="'lives_langues_post_add','lives_countries_post_add'"  class="settings-section collapsible-section">
               <div class="section-header" @click="toggleSection('languages')">
          <label v-has-permission="'lives_langues_post_add','lives_countries_post_add'"  class="primary"> {{ $t('form_live.tabs.advanced.diffusion.languages_empreinte')  }}</label>
       <font-awesome-icon :icon="sections.languages ? 'chevron-up' : 'chevron-down'" />
	        </div>
	        <b-collapse :visible="sections.languages" id="collapse-languages">
	    <div class="collapse-content">
	      <b-row>
	  
	      <b-col md="6" sm="12">

	        <div class="form-group" v-has-permission="'lives_langues_post_add'">
          <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.languages') }}</label>
          <multiselect
            v-model="form.languages"
            :options="languagesOptions"
            :multiple="true"
            track-by="label"
            label="lang"
            :close-on-select="true"
            :placeholder="$t('form_live.tabs.advanced.diffusion.languagesPlaceholder')"
            :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
            :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
            :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
          >
            <span slot="noResult">{{
              $t('form_live.tabs.advanced.contributors.no_result')
            }}</span>
            <span slot="noOptions">{{
              $t('form_live.tabs.advanced.contributors.no_options')
            }}</span>
            <template slot="option" slot-scope="{ option }">
              <div>{{ option.lang }}</div>
            </template>
          </multiselect>
	        </div>
	      </b-col>
	      <b-col md="6" sm="12">
     
        <div class="form-group" v-has-permission="'lives_countries_post_add'" >
          <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.countries') }}</label>
          <multiselect
            v-model="form.countries"
            :options="countriesOptions"
            :multiple="true"
            track-by="id"
            label="countryName"
            :close-on-select="true"
            :placeholder="$t('form_live.tabs.advanced.diffusion.countriesPlaceholder')"
            :loading="isLoadingCountries"
            :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
            :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
            :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
          >
            <span slot="noResult">{{
              $t('form_live.tabs.advanced.contributors.no_result')
            }}</span>
            <span slot="noOptions">{{
              $t('form_live.tabs.advanced.contributors.no_options')
            }}</span>
            <template slot="option" slot-scope="{ option }">
              <div>{{ option.countryName }}</div>
            </template>
          </multiselect>
	        </div>
	      </b-col>
	      </b-row>
	    </div>
	    </b-collapse>
	   </div>
 <div style="display:none" v-has-permission="'lives_youtubelinks_post_add'" class="settings-section collapsible-section">
               <div class="section-header" @click="toggleSection('socialMedia')">

    <label v-has-permission="'lives_youtubelinks_post_add'"  class="primary"> {{ $t('form_live.tabs.frontOffice.options.social_media.title') }}</label>
       <font-awesome-icon :icon="sections.socialMedia ? 'chevron-up' : 'chevron-down'" />
 
  </div>
  <b-collapse :visible="sections.socialMedia" id="collapse-youtube">
    <youtube-links
     class="collapse-content"
     v-has-permission="'lives_youtubelinks_post_add'"
    :initial-youtube-enabled="form.isYoutube"
    :initial-youtube-links="form.youtubeLinks"
    @update:youtubeEnabled="onYoutubeEnabledChange"
    @update:youtubeLinks="onYoutubeLinksChange"
/>
</b-collapse>
</div>
  </div>

  <div v-has-permission="'lives_associate_users_no_api','lives_conf_moderators_api'" class="settings-section collapsible-section">
                    <div class="section-header" @click="toggleSection('contributors')">
                <label v-has-permission="'lives_associate_users_no_api','lives_conf_moderators_api'" class="primary">{{$t('form_live.tabs.advanced.contributors.header')  }}</label> 
       <font-awesome-icon :icon="sections.contributors ? 'chevron-up' : 'chevron-down'" />             
              </div>
<b-collapse :visible="sections.contributors" id="collapse-moderator" >
             <div class="collapse-content">
                <b-row v-has-permission="'lives_associate_users_no_api'" has-permission="lives_associate_users_no_api">
                     

         
                  <b-col cols="12">

<div class="form-group">            
    <label>
      {{ $t('form_live.tabs.advanced.contributors.title') }}
      <small class="text-muted ml-1">({{ $t('form_live.tabs.advanced.contributors.admin_description') }})</small>
    </label>
    <multiselect
      v-model="form.contributors"
      :options="getWebtvUsers"
      :multiple="true"
      track-by="email"
      label="email"
      placeholder=""
      :close-on-select="false"
      :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
      :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
      :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
    >
      <span slot="noResult">{{
        $t('form_live.tabs.advanced.contributors.no_result')
      }}</span>
      <span slot="noOptions">{{
        $t('form_live.tabs.advanced.contributors.no_options')
      }}</span>
      <template slot="singleLabel" slot-scope="{ option }">
        <strong>{{ option.name }}</strong>
      </template>
    </multiselect>
  </div>
</b-col>
<b-col cols="12" v-show="form.diffusion == 'webinar' ">
                    <div class="form-group">
                      <label>
                        {{ $t('form_live.tabs.advanced.contributors.participantTitle') }}
                        <small class="text-muted ml-1">({{ $t('form_live.tabs.advanced.contributors.participants_description') }})</small>
                      </label>
                      <div class="participant-import-card">
                        <div class="participant-import-card__content">
                          <div class="participant-import-card__title">Inviter plusieurs participants</div>
                          <div class="participant-import-card__text">
                         {{ $t('form_live.tabs.advanced.contributors.importMultiParticipants') }}
                          </div>
                        </div>
                        <b-button
variant="link"
size="sm"
type="button"
class="fp-upload-btn"
@click="triggerParticipantImport"
>
<!-- <b-spinner small v-if="documentsUploading" class="mr-2" /> -->
   {{ $t('button.upload') }} CSV / Excel
</b-button>
                      </div>
                      <input
                        ref="participantsImportInput"
                        type="file"
                        class="d-none"
                        accept=".csv,.xls,.xlsx"
                        @change="handleParticipantFileChange"
                      >
                      <multiselect
                        ref="participantsMultiselect"
                        v-model="form.participants"
                        :options="localParticipantOptions"
                        :multiple="true"
                        track-by="email"
                        label="email"
                        placeholder=""
                        :taggable="true"
                        :tag-placeholder="$t('form_live.tabs.advanced.contributors.add_email')"
                        @tag="addCustomParticipant"
                        :close-on-select="false"
                        :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                        :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                        :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                      >
                        <span slot="noResult">{{
                          $t('form_live.tabs.advanced.contributors.no_result')
                        }}</span>
                        <span slot="noOptions">{{
                          $t('form_live.tabs.advanced.contributors.no_options')
                        }}</span>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.name }}</strong>
                        </template>
                      </multiselect>
                    </div>
                  </b-col>

                </b-row>
                <!-- Moderators -->
               <b-row v-has-permission="'lives_associate_users_no_api'">
                  <b-col cols="12">
                    <div class="form-group">
                      <label>
                        {{ $t('modal.moderators') }}
                        <small class="text-muted ml-1">({{ $t('form_live.tabs.advanced.contributors.moderators_description') }})</small>
                      </label>
                      <multiselect
                        v-model="moderators"
                        :options="getWebtvUsers"
                        :multiple="true"
                        track-by="id"
                        label="email"
                        placeholder=""
                        :close-on-select="false"
                        :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                        :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                        :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                      >
                        <span slot="noResult">{{
                          $t('form_live.tabs.advanced.contributors.no_result')
                        }}</span>
                        <span slot="noOptions">{{
                          $t('form_live.tabs.advanced.contributors.no_options')
                        }}</span>
                          <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.email }}</strong>
                        </template>
                      </multiselect>
                    </div>
                  </b-col>
                </b-row>
                </div>
    </b-collapse>
    </div>
    <div v-show="(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')" v-has-permission="'lives_rich_media_no_api,lives_associate_files_no_api'" class="settings-section collapsible-section">
                   <div class="section-header" @click="toggleSection('richMedia')">
                  <label class="primary"> {{ $t('form_live.tabs.advanced.diffusion.medias') }}  </label>
              <font-awesome-icon :icon="sections.richMedia ? 'chevron-up' : 'chevron-down'" />             

                 </div>
      <b-collapse :visible="sections.richMedia" id="collapse-media" >
        <div class="collapse-content">  
        <b-row  v-show="(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')" v-has-permission="'lives_rich_media_no_api'" has-permission="lives_rich_media_no_api">
                  <b-col cols="12">
                    <div class="form-group">
                  <!-- <label class="primary"> {{ $t('form_live.tabs.advanced.diffusion.medias') }}  </label> -->

                      <b-form-checkbox v-model="form.isRm">{{
                        $t('form_live.tabs.advanced.rich_media.title')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col cols="12" v-if="form.isRm">
                    <div class="rm-tabs-wrapper">
                      <b-tabs content-class="mt-3" :noKeyNav="true">
                        <b-tab v-if="hasPermission('lives_rich_media_question_no_api')" has-permission="lives_rich_media_question_no_api">
                          <template slot="title">
                            <div>
                              <span class="icon-question"></span>
                            </div>
                            <div class="d-none d-md-block ml-2">
                              {{ $t('form_live.tabs.advanced.rich_media.tabs.questions.title') }}
                            </div>
                          </template>
                          <!--<VuePerfectScrollbar-->
                            <!--ref="ps-questions"-->
                            <!--class="scroll-area scroll-questions"-->
                          <!--&gt;-->
                            <b-row>
                              <b-col md="12">
                                <div class="chapters-wrapper">
                                  <draggable v-model="form.questions" handle=".sort-handler">
                                    <div
                                      md="12"
                                      class="chapter-wrapper"
                                      v-for="(question, index) in form.questions"
                                      :key="index"
                                    >
                                      <div
                                        class="chapter-container question"
                                        :class="{ 'is-open': question.isEditMode }"
                                      >
                                        <div class="sort-handler">
                                          <font-awesome-icon icon="bars" />
                                        </div>
                                        <div class="index">{{ index + 1 }}.&nbsp;</div>
                                        <div v-show="!question.isEditMode">
                                          {{ question.question }}
                                        </div>
                                        <question-form
                                          v-if="question.isEditMode"
                                          :question="question"
                                          :buttonLabel="
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.edit',
                                            )
                                          "
                                          @addQuestion="updateQuestion($event, index)"
                                          @closeForm="toggleEditQuestion(index)"
                                        >
                                        </question-form>
                                      </div>
                                      <div class="rm-actions-wrapper" v-show="!question.isEditMode">
                                        <b-button
                                          v-show="!isQuestionEditMode"
                                          size="sm"
                                          @click.stop="toggleEditQuestion(index)"
                                          variant="light"
                                        >
                                          <span class="icon-edit"></span>
                                        </b-button>
                                        <b-button
                                          size="sm"
                                          @click="removeQuestion(index)"
                                          variant="light"
                                          class="btn-remove"
                                        >
                                          <span class="icon-trash"></span>
                                        </b-button>
                                      </div>
                                    </div>
                                  </draggable>
                                  <h5
                                    class="text-center m-3 c-grey-600"
                                    v-if="form.questions.length === 0"
                                  >
                                    {{
                                      $t('form_live.tabs.advanced.rich_media.tabs.questions.empty')
                                    }}
                                  </h5>
                                </div>
                              </b-col>
                            </b-row>
                          <!--</VuePerfectScrollbar>-->
                          <div class="add-item-wrapper">
                            <question-form
                              v-if="addQuestionMode"
                              @addQuestion="addQuestion"
                              @closeForm="addQuestionMode = false"
                            >
                              <label slot="title">{{
                                $t('form_live.tabs.advanced.rich_media.tabs.questions.new')
                              }}</label>
                            </question-form>
                            <b-row v-if="!addQuestionMode">
                              <b-col>
                                <div class="float-right">
                                  <b-button
                                    variant="link"
                                    type="button"
                                    @click="setAddQuestionMode(true)"
                                  >
                                    <font-awesome-icon icon="plus-circle" />
                                    {{
                                      $t(
                                        'form_live.tabs.advanced.rich_media.tabs.questions.add_new',
                                      )
                                    }}</b-button
                                  >
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-tab>
                        <b-tab
                          @click="updateScrollbar"
                          v-has-permission="'lives_rich_media_slides_no_api'"
                          has-permission="lives_rich_media_slides_no_api"
                        >
                          <template slot="title">
                            <div>
                              <font-awesome-icon icon="th-large" />
                            </div>
                            <div class="d-none d-md-block ml-2">
                              {{ $t('form_live.tabs.advanced.rich_media.tabs.slides.title') }}
                            </div>
                          </template>

                          <div class="slides-wrapper">
                            <!--<VuePerfectScrollbar ref="ps-slides" class="scroll-area">-->
                              <draggable v-model="form.slides" class="row">
                                <b-col
                                  lg="2"
                                  md="3"
                                  sm="4"
                                  class="slide-wrapper"
                                  v-for="(slide, index) in form.slides"
                                  :key="index"
                                >
                                  <figure class="img-fluid">
                                    <div class="type-tag">
                                      <span
                                        :class="
                                          'icon-' +
                                            (slide.slideType === 'Image' ? 'picture' : 'video')
                                        "
                                      ></span>
                                    </div>
                                    <img
                                      v-if="slide.slideType === 'Image'"
                                      :src="slide.urlSlide"
                                      alt=""
                                    />
                                    <video
                                      v-if="slide.slideType === 'Video'"
                                      :src="slide.urlSlide"
                                      alt=""
                                    ></video>
                                    <div class="more-btn-container">
                                      <b-dropdown
                                        variant="link"
                                        toggle-class="text-decoration-none"
                                        no-caret
                                      >
                                        <template slot="button-content">
                                          <span class="icon-more"></span>
                                        </template>
                                        <b-dropdown-item @click.stop="replaceSlide(index)">
                                          <span class="icon-edit"></span>
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.edit',
                                            )
                                          }}
                                        </b-dropdown-item>
                                        <b-dropdown-item @click.stop="removeSlide(index)">
                                          <span class="icon-trash"></span>
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.delete',
                                            )
                                          }}
                                        </b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                  </figure>
                                </b-col>
                              </draggable>
                            <!--</VuePerfectScrollbar>-->
                          </div>
                          <div class="dz-upload-wrapper">
                            <vue-dropzone
                              id="slides-dz"
                              ref="slidesDZ"
                              :options="getDropzoneOptions('media')"
                              :auto-process-queue="false"
                              @vdropzone-files-added="handleDzSlideAdded"
                              @vdropzone-file-added-manually="handleDzSlideAdded"
                              @vdropzone-complete="handleDzSlideCompleted"
                            >
                            </vue-dropzone>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </b-col>
                
                </b-row>
                <b-row  v-show="(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')">
                  <b-col md="12" sm="12"
                   v-has-permission="'lives_fo_docs_share_no_api'"
                   has-permission="lives_fo_docs_share_no_api"
                  >
  <div class="form-group fp-files-section">

    <b-form-checkbox v-model="showFilesPanel">
      {{ $t('form_live.tabs.advanced.documents.title') }}
    </b-form-checkbox>
    <transition name="fp-slide">
      <div v-if="showFilesPanel" class="fp-panel">

        <div class="fp-header">
          <span class="fp-count">
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'folder-open' }" class="mr-1" />
            {{ managedLiveDocuments.length }} {{ $t('form_live.tabs.advanced.documents.fichier') }}
          </span>

          <div class="fp-header-actions">
            <b-button
             variant="link"
             size="sm"
             type="button"
             class="fp-upload-btn"
            :disabled="documentsUploading"
            @click="triggerLiveDocumentUpload"
            >
              <b-spinner small v-if="documentsUploading" class="mr-1" />
              <font-awesome-icon v-else :icon="{ prefix: 'fas', iconName: 'upload' }" class="mr-1" />
              {{ documentsUploading ? $t('form_live.tabs.advanced.documents.refresh') : $t('form_live.tabs.advanced.documents.upload') }}
            </b-button>
          </div>
        </div>

        <div v-if="documentsLoading" class="fp-state">
          <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'spinner' }" spin />
          {{ $t('form_live.tabs.advanced.documents.refresh') }}…
        </div>
        <template v-else>
          <div v-if="!$route.params.id && managedLiveDocuments.length > 0" class="fp-save-hint">
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'info-circle' }" />
            <span>{{ $t('form_live.tabs.advanced.documents.save_first') }}</span>
          </div>

          <div v-if="managedLiveDocuments.length === 0" class="fp-empty">
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'folder-open' }" />
            <span>{{ $t('form_live.tabs.advanced.documents.empty') }}</span>
          </div>

          <div v-else class="fp-list">
            <div
              v-for="document in managedLiveDocuments"
              :key="document.localId || document.id"
              class="fp-item"
            >
              <div class="fp-item-icon" :class="getManagedDocumentIconClass(document)">
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: getManagedDocumentIcon(document) }" />
              </div>

              <div class="fp-item-info">
                <div class="fp-item-name">
                  <a
                    v-if="getManagedDocumentUrl(document)"
                    :href="getManagedDocumentUrl(document)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ getManagedDocumentName(document) }}
                  </a>
                  <span v-else>{{ getManagedDocumentName(document) }}</span>
                </div>
                <div v-if="getManagedDocumentOwner(document)" class="fp-item-owner">
                  {{ $t('form_live.tabs.advanced.documents.uploaded_by') }}: {{ getManagedDocumentOwner(document) }}
                </div>
                <div class="fp-item-meta">
                  <span v-if="document.isPending" class="fp-badge fp-badge-pending">
                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'clock' }" />
                    {{ $t('form_live.tabs.advanced.documents.pending') }}
                  </span>
                  <span v-else-if="isManagedDocumentPublic(document)" class="fp-badge fp-badge-public">
                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'globe' }" />
                    {{ $t('form_live.tabs.advanced.documents.public') }}
                  </span>
                
                </div>
              </div>

              <div class="fp-item-actions">            
                <button
                  type="button"
                  class="fp-icon-btn fp-icon-btn--danger"
                  :disabled="documentsDeletingId === (document.id || document.localId)"
                  title="Supprimer le fichier"
                  @click="deleteLiveDocument(document)"
                >
                  <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'trash' }" />
                </button>
              </div>

            </div>
          </div>
        </template>

        <input
          ref="liveDocumentsInput"
          type="file"
          multiple
          class="d-none"
          @change="handleLiveDocumentFileChange"
        />

      </div>
    </transition>

  </div>
</b-col>
      
                </b-row>
                <b-row v-show="(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl') && !isEmpreintePollClient" v-has-permission="'lives_associate_files_no_api'" has-permission="lives_associate_files_no_api">
                  <b-col
                    md="4"
                    sm="12"
                    v-has-permission="'lives_fo_files_share_no_api'"
                    has-permission="lives_fo_files_share_no_api"
                  >
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foFilesShare">{{
                        $t('form_live.tabs.frontOffice.options.sharing_files')
                      }}</b-form-checkbox>
                      <b-form-group style="margin-left:1.2em" v-if="form.foFilesShare">
                          <b-form-checkbox  v-model="form.doc_public"
                            >{{
                              $t('form_live.tabs.frontOffice.options.sharing_files_live_event.text')
                            }}
                            <span style="color: #62626b">
                              {{
                                $t(
                                  'form_live.tabs.frontOffice.options.sharing_files_live_event.explanation',
                                )
                              }}
                            </span>
                          </b-form-checkbox>
                          <b-form-checkbox  v-model="form.doc_public_mail">
                          {{
                            $t('form_live.tabs.frontOffice.options.sharing_files_emails')
                          }}</b-form-checkbox>
                          <b-form-checkbox  v-model="form.doc_private">
                            {{
                              $t(
                                'form_live.tabs.frontOffice.options.sharing_files_studio_live.text',
                              )
                            }}
                            <span style="color: #62626b">
                              {{
                                $t(
                                  'form_live.tabs.frontOffice.options.sharing_files_studio_live.explanation',
                                )
                              }}
                            </span>
                          </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </b-col>

                </b-row>
             
        </div>

                </b-collapse>
                </div>
              </div>
            </b-tab>
            <b-tab
              @click="initInfinitScrollVideos = true"
              has-permission="lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api"
              v-if="
                hasPermission(
                  'lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api',
                )
              "
            >
              <template slot="title">
                <div>
                  <font-awesome-icon icon="desktop" />
                </div>
                <div class="d-none d-md-block ml-2">
                   Player
                </div>
              </template>
                <div class="form-group" >
               <div v-has-permission="'lives_password_security_no_api','lives_fo_subscript_no_api'"  class="settings-section  collapsible-section" >
                <div class="section-header" @click="toggleSection('access_direct')">
                  <label v-has-permission="'lives_password_security_no_api','lives_fo_subscript_no_api'" class="primary">{{ $t('form_live.tabs.frontOffice.access_page_direct') }}</label>
                  <font-awesome-icon :icon="sections.access_direct ? 'chevron-up' : 'chevron-down'" />
               </div>
               <b-collapse :visible="sections.access_direct" id="collapse-access" >
               <div class="collapse-content">
                <b-row>
<b-col md="3" sm="12" v-has-permission="'lives_password_security_no_api'" has-permission="lives_password_security_no_api">
                    <div class="form-group">
                      <b-form-checkbox
                        v-model="password"
                        class="primary"
                        @input="handleToggleSecured"
                        >{{ $t('form_live.tabs.frontOffice.mdp')}}</b-form-checkbox
                      >
                      <div class="sub-form-control" v-if="password">
                        <b-form-input
                          type="text"
                          v-model="form.pwd"
                          placeholder="*****"
                        ></b-form-input>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_subscript_no_api'" has-permission="lives_fo_subscript_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foSubscript" class="primary">{{
                       $t('form_live.tabs.frontOffice.inscri_abonne')
                      }}</b-form-checkbox>
                           <div class="form-group">
                    </div>
                    </div>
                  </b-col>
               </b-row>
                </div>
               </b-collapse>
               </div>
              <div v-has-permission="'lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'"  class="settings-section collapsible-section" >
               <div class="section-header" @click="toggleSection('video')">
                <label v-has-permission="'lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'"  class="primary">{{ $t('form_live.tabs.frontOffice.lecteur_video') }}</label>
                <font-awesome-icon :icon="sections.video ? 'chevron-up' : 'chevron-down'" />  
              </div>
              <b-collapse :visible="sections.video" id="collapse-player" >
                <div class="collapse-content">
                <b-row>
   <b-col md="3" sm="12" v-has-permission="'lives_fo_like_no_api'" has-permission="lives_fo_like_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foLike" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.like')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_chat_no_api'" has-permission="lives_fo_chat_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.chat" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.chat_empreinte')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_chat_no_api'" has-permission="lives_fo_chat_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.privateChat" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.privateChat_empreinte')
                      }}</b-form-checkbox>
                    </div>
                    </b-col>
                     
                  </b-row>
                  </div>
              </b-collapse>
              </div>
               <div v-has-permission="'lives_fo_comment_no_api'" has-permission="lives_fo_comment_no_api" class="settings-section collapsible-section" >
                <div class="section-header" @click="toggleSection('questions')">
                <label v-has-permission="'lives_fo_comment_no_api'" class="primary">Questions</label>
                <font-awesome-icon :icon="sections.questions ? 'chevron-up' : 'chevron-down'" />
                </div>
                <b-collapse :visible="sections.questions" id="collapse-diffusion" >
                 <div class="collapse-content">
                  <b-row>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_comment_no_api'" has-permission="lives_fo_comment_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foComment" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.active_comment.title')
                      }}</b-form-checkbox>
                      <div
                      class="sub-form-control"
                      v-show="form.foComment"
                      v-has-permission="'lives_fo_comment_confirmation_no_api'"
                      has-permission="lives_fo_comment_confirmation_no_api"
                    >
                      <b-form-checkbox v-model="form.canCommentBeforeLive">{{
                        $t('form_live.tabs.frontOffice.options.active_comment.questionsBeforeLive')
                      }}</b-form-checkbox>
                    </div>
                      <div
                        class="sub-form-control"
                        v-show="form.foComment"
                        v-has-permission="'lives_fo_comment_confirmation_no_api'"
                        has-permission="lives_fo_comment_confirmation_no_api"
                      >
                        <b-form-checkbox v-model="form.isCommentValidation">{{
                          $t('form_live.tabs.frontOffice.options.active_comment.confirm')
                        }}</b-form-checkbox>
                      </div>
                      <div
                      class="sub-form-control"
                      v-show="form.foComment"
                      v-has-permission="'lives_fo_comment_confirmation_no_api'"
                      has-permission="lives_fo_comment_confirmation_no_api"
                    >
                      <b-form-checkbox v-model="form.canReplyToComments">{{
                        $t('form_live.tabs.frontOffice.options.active_comment.replies')
                      }}</b-form-checkbox>
                    </div>

                    </div>
                  </b-col>
                  </b-row>
                  </div>
                </b-collapse>
                </div>
                  <div v-has-permission="'lives_fo_subtitles_no_api'"  class="settings-section collapsible-section" >
                <div class="section-header" @click="toggleSection('sous_titrage')">
                <label v-has-permission="'lives_fo_subtitles_no_api'" has-permission="lives_fo_subtitles_no_api" class="primary">{{ $t('form_live.tabs.frontOffice.sous_titrage') }}</label>
             <font-awesome-icon :icon="sections.sous_titrage ? 'chevron-up' : 'chevron-down'" />
              </div>
              <b-collapse :visible="sections.sous_titrage" id="collapse-diffusion" >
                 <div class="collapse-content">
                <b-row>
<b-col md="3" sm="12" v-has-permission="'lives_fo_subtitles_no_api'" has-permission="lives_fo_subtitles_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foSubtitles" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.subtitles_empreinte')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_auto_transcription'" has-permission="lives_fo_auto_transcription">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.autoTranscription" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.autoTranscription_empreinte')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  </b-row>
                </div>
                </b-collapse>
                </div>

                <!-- CHAPTERS START -->
  <div v-show="(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')" v-has-permission="'lives_rich_media_no_api'"  class="settings-section collapsible-section" >
   <div class="section-header" @click="toggleSection('chapitres')">
            <label v-has-permission="'lives_rich_media_no_api'" has-permission="lives_rich_media_no_api" class="primary">{{ $t('form_live.tabs.advanced.rich_media.tabs.chapters.title') }}</label>
             <font-awesome-icon :icon="sections.chapitres ? 'chevron-up' : 'chevron-down'" />
              </div>
              <b-collapse :visible="sections.chapitres" id="collapse-diffusion" >
                 <div class="collapse-content">
                <b-row>
              <b-col cols="12">
              <div class="rm-tabs-wrapper">
                      <div content-class="mt-3" :noKeyNav="true">
                      <b-row v-if="hasPermission('lives_rich_media_chapter_no_api')"
                         has-permission="lives_rich_media_chapter_no_api">
                          <b-col md="12">
                                <div class="chapters-wrapper">
                                <draggable v-model="form.chapters" handle=".sort-handler">               
                                   <div
                                      md="12"
                                      class="chapter-wrapper"
                                      v-for="(chapter, index) in form.chapters"
                                      :key="index"
                                    >
                                      <div class="chapter-container">
                                        <div class="sort-handler">
                                          <font-awesome-icon icon="bars" />
                                        </div>
                                        <div class="index">{{ index + 1 }}.&nbsp;</div>
                                        <div v-show="!chapter.isEditMode"> {{ chapter.title }}
                                        </div>
                                        <b-form-group class="m-0"   v-show="chapter.isEditMode">
                                          <b-form-input
                                            v-model="chapterTitle"
                                            :placeholder="
                                              $t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.title')"
                                            @keyup.enter="toggleEditChapter(index)"
                                          ></b-form-input>
                                          <b-button
                                            size="sm"
                                            @click="toggleEditChapter(index)"
                                            variant="light"
                                            class="inline-submit-btn"
                                            v-show="chapter.isEditMode && !!chapter.title"
                                          >
                                            <font-awesome-icon icon="check-circle"
                                            ></font-awesome-icon>
  </b-button>
      </b-form-group>
                                       </div>
                               <div class="rm-actions-wrapper" v-show="!chapter.isEditMode">
                                         <b-button
                                          v-show="!isChapterEditMode"
                                          size="sm"
                                          @click.stop="toggleEditChapter(index, false)"
                                          variant="light" >
                                          <span class="icon-edit"></span>
                                        </b-button>
                                        <b-button
                                          size="sm"
                                          @click="removeChapter(index)"
                                          variant="light"
                                          class="btn-remove"  >
                    <span class="icon-trash"></span>
                                        </b-button>
                                      </div>
                      </div>
                                  </draggable>
                                  <h5 class="text-center m-3 c-grey-600" v-if="form.chapters.length === 0" >
                            {{$t('form_live.tabs.advanced.rich_media.tabs.chapters.empty')}}
                             </h5>
                                </div>
                              </b-col>
                            </b-row>
                          <!--</VuePerfectScrollbar>-->
                          <div class="add-item-wrapper">
                            <div class="position-relative">
                              <b-form-input
                                v-model="newChapter"
                                :placeholder="$t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.new')"
                                @keyup.enter="addChapter"
                                ref="newChapterInput"
                              ></b-form-input>
                              <b-button
                               v-show="newChapter"
                               size="sm"
                               @click="addChapter"
                               variant="light" class="inline-submit-btn">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                              </b-button>
                            </div>
                          </div>
                        </div>
                    </div>
                  </b-col>
                  </b-row>
                  </div>
                </b-collapse>
                </div>
                <!-- CHAPTERS END -->
                   <div
                v-if="isEmpreintePollClient"
              <div
                v-has-permission="'lives_form_presentation'"
                has-permission="lives_form_presentation"
                class="settings-section collapsible-section"
              >
                <div class="section-header" @click="toggleSection('presentation')">
                  <label class="primary">{{ $t('form_live.tabs.advanced.presentation.label') }}</label>
                  <font-awesome-icon :icon="sections.presentation ? 'chevron-up' : 'chevron-down'" />
                </div>
                <b-collapse :visible="sections.presentation" id="collapse-presentation">
                  <div class="collapse-content">
                   <div class="presentation-upload-panel">
  <input
    ref="presentationInput"
    type="file"
    class="d-none"
    accept=".pdf,.ppt,.pptx,.doc,.docx"
    @change="handlePresentationFileChange"
  >
  <button
    type="button"
    class="presentation-upload-box"
    :disabled="!canManagePresentation || presentationUploading"
    @click="triggerPresentationUpload"
  >
    <b-spinner v-if="presentationUploading" small />
    <font-awesome-icon v-else icon="plus-circle" />
  </button>
  <div class="presentation-upload-panel__meta">
    <strong>{{ $t('form_live.tabs.advanced.presentation.upload') }}</strong>
    <span>{{ $t('form_live.tabs.advanced.presentation.formats_hint') }}</span>
    <span v-if="presentationLoading" class="text-muted">
      {{ $t('form_live.tabs.advanced.presentation.loading') }}
    </span>
    <span v-else-if="presentationUploading" class="text-muted">
      {{ $t('form_live.tabs.advanced.presentation.uploading') }}
    </span>
    <span v-else-if="presentationDeletingId" class="text-muted">
      {{ $t('form_live.tabs.advanced.presentation.deleting') }}
    </span>
  </div>
</div>

                    <div
                      v-if="presentationItems.length === 0 && !presentationLoading"
                      class="presentation-empty-state"
                    >
                      <span>{{ $t('form_live.tabs.advanced.presentation.empty') }}</span>
                    </div>

                    <div v-if="presentationItems.length > 0" class="presentation-list">
                      <div
                        v-for="(presentationItem, presentationIndex) in presentationItems"
                        :key="presentationItem.id || presentationItem.documentId || presentationItem.name || presentationIndex"
                        class="presentation-list-item"
                      >
                        <div
                          class="presentation-list-item__icon"
                          :class="'presentation-list-item__icon--' + getPresentationFileType(presentationItem)"
                        >
                          {{ getPresentationExtension(presentationItem) }}
                        </div>
                        <div class="presentation-list-item__content">
                          <strong class="presentation-list-item__title">
                            {{ getPresentationTitle(presentationItem) }}
                          </strong>
                          <div class="presentation-list-item__meta">
                            <span>{{ getPresentationExtension(presentationItem) }}</span>
                            <span>
                              <template v-if="presentationItem.isPending">
                                {{ $t('form_live.tabs.advanced.presentation.pending') }}
                              </template>
                              <template v-else>
                                {{
                                  $t('form_live.tabs.advanced.presentation.slides_count', {
                                    count: getPresentationSlidesCount(presentationItem),
                                  })
                                }}
                              </template>
                            </span>
                          </div>
                        </div>
                        <div class="presentation-list-item__actions">
                          <b-button
                            v-if="!presentationItem.isPending && getPresentationSourceUrl(presentationItem)"
                            size="sm"
                            variant="outline-success"
                            type="button"
                            class="presentation-action-button"
                            :href="getPresentationSourceUrl(presentationItem)"
                            target="_blank"
                          >
                            <font-awesome-icon icon="play" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            type="button"
                            class="presentation-action-button"
                            :disabled="!presentationItem.isPending && presentationDeletingId === getPresentationDeleteId(presentationItem)"
                            @click="deletePresentation(getPresentationDeleteId(presentationItem))"
                          >
                            <font-awesome-icon icon="trash" />
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
              
              <div
                v-has-permission="'lives_form_poll'"
                has-permission="lives_form_poll"
                class="settings-section collapsible-section"
              >
                <div class="section-header" @click="toggleSection('polls')">
                  <label class="primary">{{ $t('form_live.tabs.advanced.polls.label') }}</label>
                  <font-awesome-icon :icon="sections.polls ? 'chevron-up' : 'chevron-down'" />
                </div>
                <b-collapse :visible="sections.polls" id="collapse-polls">
                  <div class="collapse-content">
                    <div v-if="livePolls.length === 0" class="poll-empty-state">
                      <span>{{ $t('form_live.tabs.advanced.polls.empty') }}</span>
                      <b-button size="sm" variant="primary" type="button" @click="addPollDraft">
                        <font-awesome-icon icon="plus-circle" class="mr-2" />
                        {{ $t('form_live.tabs.advanced.polls.add_first') }}
                      </b-button>
                    </div>

                    <div v-if="livePolls.length > 0" class="poll-tabs">
                      <button
                        v-for="(pollItem, pollIndex) in livePolls"
                        :key="pollItem.id || 'poll-tab-' + pollIndex"
                        type="button"
                        class="poll-tab"
                        :class="{ 'poll-tab--active': pollIndex === activePollIndex }"
                        @click="setActivePoll(pollIndex)"
                      >
                        <span class="poll-tab__eyebrow">{{
                          $t('form_live.tabs.advanced.polls.tab_label', { number: pollIndex + 1 })
                        }}</span>
                        <strong class="poll-tab__title">{{ getPollTabTitle(pollItem) }}</strong>
                        <span class="poll-tab__meta">
                          {{
                            $t('form_live.tabs.advanced.polls.options_count', {
                              count: pollItem.options.length,
                            })
                          }}
                          <span
                            v-if="getPollValidationError(pollItem)"
                            class="poll-tab__warning"
                          >
                            {{ $t('form_live.tabs.advanced.polls.incomplete') }}
                          </span>
                        </span>
                      </button>
                      <button
                        type="button"
                        class="poll-tab poll-tab--add"
                        :disabled="!canAddPoll"
                        :title="!canAddPoll ? $t('form_live.tabs.advanced.polls.complete_current_first') : ''"
                        @click="addPollDraft"
                      >
                        <strong class="poll-tab__title">
                          <font-awesome-icon icon="plus-circle" class="mr-2" />
                          {{ $t('form_live.tabs.advanced.polls.add') }}
                        </strong>
                        <span class="poll-tab__meta">
                          {{ $t('form_live.tabs.advanced.polls.add_hint') }}
                        </span>
                      </button>
                    </div>

                    <div
                      v-if="activePoll"
                      :key="activePoll.id || 'poll-draft-' + activePollIndex"
                      class="poll-card"
                    >
                      <div class="poll-card__header">
                        <div>
                          <strong>{{
                            $t('form_live.tabs.advanced.polls.tab_label', {
                              number: activePollIndex + 1,
                            })
                          }}</strong>

                        </div>
                        <div class="poll-delete-actions">
                          <b-button
                            size="sm"
                            variant="light"
                            type="button"
                            class="poll-delete-button"
                            :title="$t('form_live.tabs.advanced.polls.delete_poll')"
                            @click="requestPollDelete(activePollIndex)"
                          >
                            <font-awesome-icon icon="trash" />
                          </b-button>
                          <div
                            v-if="isDeletePollPending(activePollIndex)"
                            class="confirm-tooltip"
                          >
                            <span>{{ $t('form_live.tabs.advanced.polls.confirm_delete_poll') }}</span>
                            <div class="confirm-tooltip__actions">
                              <b-button
                                size="sm"
                                variant="danger"
                                type="button"
                                @click="confirmPollDelete(activePollIndex)"
                              >
                                {{ $t('button.confirm') }}
                              </b-button>
                              <b-button
                                size="sm"
                                variant="light"
                                type="button"
                                @click="cancelPendingDelete"
                              >
                                {{ $t('button.cancel') }}
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="primary">{{
                          $t('form_live.tabs.advanced.polls.question_label')
                        }}</label>
                        <b-form-textarea
                          :value="activePoll.question"
                          rows="2"
                          max-rows="4"
                          :placeholder="$t('form_live.tabs.advanced.polls.question_placeholder')"
                          @input="updatePollQuestion(activePollIndex, $event)"
                        />
                      </div>
                      <div class="form-group mb-3">
                        <b-form-checkbox
                          :checked="!!activePoll.isPublished"
                          @change="updatePollPublished(activePollIndex, $event)"
                        >
                          {{ $t('form_live.tabs.advanced.polls.publish_label') }}
                        </b-form-checkbox>
                      </div>

                      <div
                        v-for="(option, optionIndex) in activePoll.options"
                        :key="option.id || 'poll-' + activePollIndex + '-option-' + optionIndex"
                        class="poll-option-row"
                      >
                        <div class="poll-option-row__input">
                          <label class="primary">{{
                            $t('form_live.tabs.advanced.polls.option_label', {
                              number: optionIndex + 1,
                            })
                          }}</label>
                          <b-form-input
                            :value="option.poll_option"
                            :placeholder="$t('form_live.tabs.advanced.polls.option_placeholder')"
                            @input="updatePollOption(activePollIndex, optionIndex, $event)"
                          />
                        </div>
                        <b-button
                          size="sm"
                          variant="light"
                          type="button"
                          class="poll-option-row__delete poll-delete-button"
                          :title="$t('form_live.tabs.advanced.polls.delete_option')"
                          @click="requestPollOptionDelete(activePollIndex, optionIndex)"
                        >
                          <font-awesome-icon icon="trash" />
                        </b-button>
                        <div
                          v-if="isDeleteOptionPending(activePollIndex, optionIndex)"
                          class="confirm-tooltip confirm-tooltip--option"
                        >
                          <span>{{ $t('form_live.tabs.advanced.polls.confirm_delete_option') }}</span>
                          <div class="confirm-tooltip__actions">
                            <b-button
                              size="sm"
                              variant="danger"
                              type="button"
                              @click="confirmPollOptionDelete(activePollIndex, optionIndex)"
                            >
                              {{ $t('button.confirm') }}
                            </b-button>
                            <b-button
                              size="sm"
                              variant="light"
                              type="button"
                              @click="cancelPendingDelete"
                            >
                              {{ $t('button.cancel') }}
                            </b-button>
                          </div>
                        </div>
                      </div>

                      <div class="poll-card__actions">
                        <b-button
                          size="sm"
                          variant="outline-primary"
                          type="button"
                          @click="addPollOption(activePollIndex)"
                        >
                          {{ $t('form_live.tabs.advanced.polls.add_option') }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
              
              </div>



              <hr />


            <div class="form-group settings-section collapsible-section" v-has-permission="'lives_conf_post_add'" has-permission="lives_conf_post_add">
               <div class="section-header" @click="toggleSection('program')">
                <label
                  class="primary conf-label"
                  >{{ $t('form_live.tabs.frontOffice.configuration.title') }}</label
                >
                <font-awesome-icon :icon="sections.program ? 'chevron-up' : 'chevron-down'" />
               </div>
               <b-collapse :visible="sections.program" id="collapse-diffusion" >
              <div class="collapse-content">
                <b-form-group>
                  <b-form-radio-group
                    v-model="form.defaultConf"
                  >
                    <b-form-radio :value="true">{{
                      $t('form_live.tabs.frontOffice.configuration.default')
                    }}</b-form-radio>
                    <b-form-radio :value="false">{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.title')
                    }}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                  <div
                class="custom-configuration "
                v-if="!form.defaultConf"
                v-has-permission="'lives_conf_post_add'"
                has-permission="lives_conf_post_add"
              >
                <!---- radio button message--->
                <div  class="form-group">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Message"
                    v-has-permission="'lives_conf_message_option'"
                    has-permission="lives_conf_message_option"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.message.title')
                    }}</b-form-radio
                  >
                  <textarea
                    rows="5" maxlength="255"
                    v-show="form.conf.type === 'Message'"
                    v-model="form.conf.message"
                    class="form-control "
                    :placeholder="
                      $t(
                        'form_live.tabs.frontOffice.configuration.personalized.message.description',
                      )
                    "
                    required
                    @keyup="removeError($event)"
                    @focus="removeError($event)"
                  ></textarea>
                  <div v-if="this.showErrorMessage" class="error_message">
                    {{ $t('form_live.tabs.error_long_message') }}
                  </div>
                  <div v-if="!$v.form.conf.message.required" class="invalid-feedback">
                    {{ $t('form_live.tabs.required_message') }}
                  </div>
                </div>
                <!---- radio button video--->
                <div class="form-group">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Video"
                    v-has-permission="'lives_conf_video_option'"
                    has-permission="lives_conf_video_option"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.video.title')
                    }}</b-form-radio
                  >
                  <div v-if="!isBeforeLiveVideoPickerVisible && form.conf.type === 'Video'">
                    <div class="before-live-video-container">
                      <figure>
                        <div class="before-live-video-container__overlay">
                          <font-awesome-icon icon="play-circle"></font-awesome-icon>
                        </div>
                        <button
                          class="btn btn-sm before-live-video-container__btn"
                          @click="toggleBeforeLiveVideoPicker"
                        >
                          <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                          Changer la source
                        </button>
                        <b-img
                          :src="form.videoBeforeLive.logo"
                          fluid
                          :alt="form.videoBeforeLive.title"
                        ></b-img>
                      </figure>
                      <h5>{{ form.videoBeforeLive.title }}</h5>
                    </div>
                  </div>
                  <div class="mb-4">
                    <input
                      type="text"
                      v-model="form.conf.video"
                      class="form-control"
                      required
                      hidden
                    />
                    <div
                      class="video-picker-wrapper"
                      v-if="
                        form.conf.type === 'Video' &&
                          initInfinitScrollVideos &&
                          isBeforeLiveVideoPickerVisible
                      "
                    >
                      <div class="search-wrapper position-relative">
                        <input
                          :placeholder="
                            $t(
                              'form_live.tabs.frontOffice.configuration.personalized.video.description',
                            )
                          "
                          type="text"
                          class="form-control mb-15"
                          @keyup.enter="searchVideo"
                          v-model="searchVideoKeyword"
                        />
                        <b-button
                          size="sm"
                          @click="searchVideo"
                          variant="light"
                          class="inline-submit-btn"
                        >
                          <font-awesome-icon icon="search"></font-awesome-icon>
                        </b-button>
                      </div>
                      <div class="video-slides-wrapper">
                        <VuePerfectScrollbar
                          ref="ps"
                          class="scroll-area"
                          @ps-y-reach-end="handlePageChanged"
                        >
                          <b-row>
                            <b-col
                              lg="2"
                              md="3"
                              sm="4"
                              class="slide-wrapper"
                              v-for="(slide, index) in slidesChips"
                              :key="slide.id"
                            >
                              <div class="mb-3">
                                <figure>
                                  <div
                                    class="video-overlay"
                                    :class="{ in: slide.id === form.conf.video }"
                                  >
                                    <button
                                      class="btn"
                                      @click="selectVideo(slide)"
                                      :class="
                                        slide.id === form.conf.video
                                          ? 'btn-light'
                                          : 'btn-outline-light'
                                      "
                                    >
                                      {{ $t('parameters.select.selectOption') }}
                                    </button>
                                  </div>
                                  <b-img :src="slide.thumbnail" fluid :alt="slide.title"></b-img>
                                </figure>
                                <div
                                  class="video-name"
                                  :class="{ selected: slide.id === form.conf.video }"
                                  :title="slide.title"
                                >
                                  {{ slide.title }}
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                          <div v-if="isLoading('videos')">
                            <div class="sk-circle">
                              <div class="sk-circle1 sk-child"></div>
                              <div class="sk-circle2 sk-child"></div>
                              <div class="sk-circle3 sk-child"></div>
                              <div class="sk-circle4 sk-child"></div>
                              <div class="sk-circle5 sk-child"></div>
                              <div class="sk-circle6 sk-child"></div>
                              <div class="sk-circle7 sk-child"></div>
                              <div class="sk-circle8 sk-child"></div>
                              <div class="sk-circle9 sk-child"></div>
                              <div class="sk-circle10 sk-child"></div>
                              <div class="sk-circle11 sk-child"></div>
                              <div class="sk-circle12 sk-child"></div>
                            </div>
                          </div>
                          <h5
                            v-if="isEndReached('videos') && slidesChips.length === 0"
                            class="c-grey-700 font-weight-bolder m-3 text-center"
                          >
                            Pas de vidéos
                          </h5>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                    <div v-if="!$v.form.conf.video.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.pick_video') }}
                    </div>
                  </div>
                </div>
                <!---- radio button image--->
                <div class="form-group" v-has-permission="'lives_conf_image_option'" has-permission="lives_conf_image_option">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Image"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.image')
                    }}</b-form-radio
                  >
                </div>
                <b-row v-show="form.conf.type === 'Image'">
                  <b-col md="4" sm="12">
                    <b-form-group
                      :description="$t('form_live.tabs.general.form.description_image')"
                      label-for="before-live-thumbnail"
                    >
                      <thumbnail-cropper
                        :crop-img="form.conf.image"
                        @thumbnailUpdated="handleBeforeLivePosterUpdated"
                      ></thumbnail-cropper>

                    </b-form-group>
                      <div>
                      <b-form-checkbox v-model="checked" name="check-button" switch>
                       Switch Checkbox <b>(Checked: {{ checkedSwitch }})</b>
                      </b-form-checkbox>
                   </div>
                  </b-col>
                  <b-col md="8" sm="12">
                    <div class="form-group">
                      <label for="before-live-image-description">{{
                        $t('form_live.tabs.frontOffice.configuration.personalized.text_before_live')
                      }}</label>
                      <textarea
                        v-model="form.conf.imageText"
                        class="form-control"
                        id="before-live-image-description"
                        :placeholder="
                          $t('form_live.tabs.frontOffice.configuration.personalized.text')
                        "
                        rows="5"
                      ></textarea>
                    </div>
                  </b-col>
                </b-row>
                <!---- radio button counter--->
                <div class="form-group" v-has-permission="'lives_conf_counter_option'" has-permission="lives_conf_counter_option">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Counter"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.countdown')
                    }}</b-form-radio
                  >
                </div>
                 </div>
                 </div>
                </b-collapse>
                
              
              </div>
              

            </b-tab>
              <b-tab has-permission="lives_conf_program" v-if="this.isPermission.lives_conf_program || this.isSuperAdmin" >
              <template slot="title">
               <div>                  
                  <font-awesome-icon icon="users" />
                </div>
                <div class="d-none d-md-block ml-2" has-permission="lives_conf_program" >{{$t('form_live.tabs.Program.new_title')}}</div>
              </template>
              <div has-permission="lives_conf_program" class="form-group settings-section collapsible-section">
                <div class="section-header" @click="toggleSection('LiveProgram')">
              <label for="LiveProgram" class="primary">{{
                  $t('form_live.tabs.Program.LiveProgram')
                }}</label>
              <font-awesome-icon :icon="sections.LiveProgram ? 'chevron-up' : 'chevron-down'" />
              </div>
              <b-collapse :visible="sections.LiveProgram" id="collapse-diffusion" >
            <div class="collapse-content">
                <div class="form-group">
                <label for="LiveProgram" class="primary">{{
                  $t('form_live.tabs.Program.LiveProgram')
                }}</label>

                <textarea
                  v-model="form.live_program"
                  class="form-control"
                  style="width: 45%"
                  id="LiveProgram"
                  :placeholder="$t('form_live.tabs.Program.LiveProgramDescription')"
                  rows="3"
                ></textarea>
              </div>
              
              <b-row class="mt-5 ml-0">
                <b-col md="6" sm="12">
                  <div style="width: 40%" has-permission="lives_conf_add_participant_limit" v-if="this.isPermission.lives_conf_add_participant_limit || this.isSuperAdmin">
                    <b-row class="d-flex">
                      <span>{{ $t('form_live.tabs.Program.ParticpantsLimit') }} </span>
                      <b-form-checkbox
                        v-model="checkedLimit"
                        name="check-button"
                        switch
                        class="ml-2"
                      >
                      </b-form-checkbox>
                    </b-row>

                    <b-row v-if="checkedLimit">
                      <b-col cols="12">
                        <label
                          for="nameIntervernant"
                          class="required primary"
                          style="font-size: 12px; color: gray"
                          >{{ $t('form_live.tabs.Program.MaxParticipantsDistance') }}</label
                        >
                        <b-form-input
                          type="number"
                          min="0"
                          v-model.number="form.max_online_guests"
                          id="inline-form-input-MaxParticipantsDistance"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          :placeholder="$t('form_live.tabs.Program.MaxParticipantsDistance')"
                          @keydown="portKeydown($event)"
                        ></b-form-input> </b-col></b-row
                    ><b-row class="mt-2" v-if="checkedLimit"
                      ><b-col cols="12">
                        <label
                          for="nameIntervernant"
                          class="required primary"
                          style="font-size: 12px; color: gray"
                          >{{ $t('form_live.tabs.Program.MaxInvited') }}</label
                        >
                        <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                          <b-form-input
                            type="number"
                             min="0"
                            v-model.number="form.max_onsite_guests"
                            @keydown="portKeydown($event)"
                            id="inline-form-input-MaxInvited"
                            :placeholder="$t('form_live.tabs.Program.MaxInvited')"
                          ></b-form-input> </b-input-group></b-col
                    ></b-row>
                  </div>
                </b-col>
            <b-col md="6" sm="12">
                  <div class="form-group">
                    <div v-if="!$v.form.description.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div class="d-flex">
                      <label for="Participants" class="primary">{{
                        $t('form_live.tabs.Program.Intervenants')
                      }}</label>
                      <b-form-checkbox v-model="checked" name="check-button" class="ml-2" switch>
                      </b-form-checkbox>
                    </div>
                    <b-button v-if="checked" id="show-btn" @click="showModal" class="mt-2">
                      {{ $t('form_live.tabs.Program.AddParticipant') }}
                    </b-button>
                  </div>
                  <b-list-group class="mb-2">
                    <b-list-group-item
                      v-for="(intervenant, index) in intervenants"
                      :key="index"
                      class="d-flex justify-content-between"
                      style="
                      margin-bottom: 12px;
                    "
                      >
                      <img
                        style="width: 75px;
                        border-radius: 50%;
                        "
                        :src="cleanedAvatarUrl(intervenant.avatar)"
                        v-if="intervenant.avatar.length > 1"
                      />
                      <b-avatar
                        variant="primary"
                        text="BV"
                        style="
                          width: 85px;
                          background-color: #007bff;
                          border-radius: 50%;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          font-size: 26px;
                          padding: 15px;
                          font-weight: bold;
                          color: white;
                        "
                        v-else
                        >{{ intervenant.name[0].toUpperCase()
                        }}{{ intervenant.lastName[0].toUpperCase() }}</b-avatar
                      >
                      <div style="width: 85%" class="intervenant">
                        <div class="d-flex w-100 justify-content-between">
                          <h5 class="mb-1">{{ intervenant.name }} {{ intervenant.lastName }}</h5>

                        </div>
                        <div class="d-flex w-100 justify-content-between">
                          <small>{{ intervenant.mail }}</small>

                        </div>
                      </div>
                      <div class="speaker-btns">
                            <b-button @click="deleteInter(index)" variant="light" pill >
                              <font-awesome-icon icon="trash" />
                             </b-button>
                             <b-button @click="openModelForUpdate(index)" variant="light" pill >
                              <font-awesome-icon icon="edit"  />
                            </b-button>

                          </div>
                    </b-list-group-item>
                  </b-list-group>
                  <b-modal
                    ref="my-modal"
                    hide-footer
                    :title="update || updateModal ? $t('form_live.tabs.Program.editParticipant') : $t('form_live.tabs.Program.AddParticipant')"
                    @hidden="closeModel"
                  >
                    <b-form ref="formIntervenant">
                      <label for="LiveProgram" class="required primary">{{
                        $t('form_live.tabs.Program.Photo')
                      }}</label>

                    <div class="Image-upload-container">
  <div class="image-container" @click="inputFile">
    <b-form-file
      id="file-default"
      v-model="file"
      hidden
      ref="File"
      accept="image/*"
      @change="changeInput"
    ></b-form-file>
    <div v-if="!url && !showDelete"  class="upload-button">
 <span>
          <img :src="uploadImage" alt="upload Icon" >
        </span>
      <span class="clickable-text">{{ $t('form_live.tabs.Program.Cliquez') }}</span>
    </div>
    <font-awesome-icon icon="spinner" spin v-if="PendingUpload" class="loading-icon" />
    <img v-if="url" :src="url" alt="Downloaded Image" class="uploaded-image" />
  </div>

  <div class="image-info">
    <font-awesome-icon
      v-if="showDelete"
      @click="deleteImageIntervenant"
      icon="trash"
      class="trash-icon"
    />
  </div>
</div>
                      <b-row>
                        <b-col cols="6">
                          <label for="nameIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Nom')
                          }}
                          <span class="required-star">*</span>
                        </label>
                          <b-form-input
                            v-model="form.nom"
                            id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Nom')"
                            required
                          ></b-form-input> </b-col
                        ><b-col cols="6">
                          <label for="lastnameIntervernant"
                          class="required primary">{{
                            $t('form_live.tabs.Program.Prenom')
                          }}
                         <span class="required-star">*</span>
                        </label>
                          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input
                              v-model="form.lastName"
                              id="inline-form-input-username"
                              :placeholder="$t('form_live.tabs.Program.Prenom')"
                              required
                            ></b-form-input> </b-input-group></b-col
                      ></b-row>
                      <b-row class="mt-2">
                        <b-col cols="6">
                          <label for="fonctionIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Fonction')
                          }}</label>
                          <b-form-input
                            v-model="form.fonction"
                            id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Fonction')"
                          ></b-form-input> </b-col
                        ><b-col cols="6">
                          <label for="StructureIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Structure')
                          }}</label>
                          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input
                              v-model="form.structure"
                              id="inline-form-input-username"
                              :placeholder="$t('form_live.tabs.Program.Structure')"
                            ></b-form-input> </b-input-group></b-col
                      ></b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <label for="roleIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Role')
                          }}</label>
                          <b-form-input
                            v-model="form.role"
                            id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Role')"
                          ></b-form-input> </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <label for="descriptionIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Description')
                          }}</label>
                        <textarea
                            v-model="form.Description"
                            id="inline-form-input-name"
                            class="form-control"
                            style="width: 100%"
                            rows="3"
                            :placeholder="$t('form_live.tabs.Program.Description')"
                          ></textarea>
                          </b-col
                        >
                      </b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <label for="EmailIntervenant" class="required primary">{{
                            $t('form_live.tabs.Program.Email')
                          }}</label>
                          <b-form-input
                            v-model="form.mail"
                            id="inline-form-input-email"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Email')"
                          ></b-form-input
                        >
                        <div v-if="form.mail && emailError" class="error-message">{{ emailError }}</div>
                      </b-col>
                      </b-row>
                      <br />
                      <b-divider></b-divider>
                      <b-button variant="light" type="button" class="mr-2" @click="closeModel">{{
                        $t('button.cancel')
                      }}</b-button>
                       <b-button
                        v-if="updateModal"
                        variant="primary"
                        @mousedown="ManageIntervenant"
                        class="outlined-black"
                        color="gray"
                        :disabled="PendingUpload || $v.form.$error"
                        >{{ $t('button.edit') }}</b-button
                      >
                      <b-button
                        v-if="!update && !updateModal"
                        variant="primary"
                        @mousedown="ManageIntervenant"
                        class="outlined-black"
                        color="gray"
                         :disabled="PendingUpload || $v.form.$error"
                         >{{ $t('button.save') }}</b-button
                      >
                      <b-button
                        v-if="update"
                        variant="primary"
                        class="outlined-black"
                        @mousedown="ManageIntervenant"
                      :disabled="PendingUpload || $v.form.$error"
                        >{{ $t('button.edit') }}</b-button
                      ></b-form
                    >
                  </b-modal>
                </b-col>

              </b-row>
              </div>

              </b-collapse>
              </div>
            </b-tab>
            <b-tab has-permission="lives_skin"
       v-if="this.isPermission.lives_skin || this.isSuperAdmin">

  <template slot="title">
    <div><font-awesome-icon icon="palette" /></div>
    <div class="d-none d-md-block ml-2">{{ $t('form_live.tabs.SkinModel.new_title') }}</div>
  </template>
<div class="settings-section collapsible-section">
  <div class="section-header" @click="toggleSection('skin')">
<label class="primary">{{ $t('form_live.tabs.SkinModel.title') }}</label>
<font-awesome-icon :icon="sections.skin ? 'chevron-up' : 'chevron-down'" />
</div>
<b-collapse :visible="sections.skin" id="collapse-diffusion" >
  <div class="collapse-content">
  <!-- SELECT EXISTING SKIN -->
  <div class="form-group mt-3">
    <label class="primary">{{ $t('form_live.tabs.SkinModel.selectOrCreate') }}</label>

    <b-form-select
      v-model="skinForm.selectedSkin"
      :options="skinOptions"
      class="w-50"
      @change="onSelectSkin"
    />

    <small class="text-muted d-block mt-1">
      {{ $t('form_live.tabs.SkinModel.explanation') }}
    </small>
  </div>

  <hr>
  <!-- <div v-if="skinConfirmed" class="applied-skin-message">
    {{ $t('form_live.tabs.SkinModel.selectedSkin') }} "{{ skinConfirmed.name }}"
  </div> -->
  <!-- NEW SKIN -->
  <div v-if="skinForm.selectedSkin">

    <h5 class="mt-4 mb-3" v-if="!skinIsEditMode">{{ $t('form_live.tabs.SkinModel.newSkin') }}</h5>
  
    <!-- COLORS (compact, fixed width) -->
    <div class="row mt-2">

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.primaryColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.primary_color">
      </div>

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.secondaryColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.secondary_color">
      </div>

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.primaryTextColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.text_primary_color">
      </div>

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.secondaryTextColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.text_secondary_color">
      </div>

    </div>
    <div class="row">     <!-- TITLES -->
    <!-- <div class="form-group col-6">
      <label>{{ $t('form_live.tabs.SkinModel.liveTitle') }}</label>
      <input type="text" class="form-control" v-model="skinForm.skin.title">
    </div> -->

    <!-- LOGO -->
    <div class="form-group col-6">
  <div class="custom-file-wrapper">
    <button
      type="button"
      class="btn-upload"
      :disabled="uploading.logo"
      @click="$refs.logoInput.click()"
    >
      <b-spinner small v-if="uploading.logo" class="mr-2" />
      {{ $t('form_live.tabs.SkinModel.logo') }}
    </button>

    <input
      type="file"
      ref="logoInput"
      accept="image/*"
      @change="e => uploadLogo(e, 'logo')"
      class="hidden-file-input"
    />
  </div>

  <div v-if="skinForm.skin.logoPreview" class="mt-2">
  <div class="image-preview-wrapper position-relative d-inline-block">
    <img
      :src="skinForm.skin.logoPreview"
      alt="Logo preview"
      class="logo-preview"
      :class="{ 'is-loading': uploading.logo }"
    />

    <div
      v-if="uploading.logo"
      class="preview-overlay"
    >
      <b-spinner />
    </div>
  </div>
</div>
</div>

</div>


    <hr>

    <!-- BEFORE / AFTER LIVE (COMPACT 2-COLUMNS) -->
    <div class="row mt-4">

      <!-- BEFORE LIVE -->
      <div class="col-md-6 pr-md-4 mb-4">
        <h6>{{ $t('form_live.tabs.SkinModel.beforeLiveInfo') }}</h6>

        <div class="form-group mt-2">
          <label>{{ $t('form_live.tabs.SkinModel.infoText') }}</label>
          <textarea rows="2"
                    class="form-control w-100"             

                    v-model="skinForm.skin.before.info_text"></textarea>
        </div>

        <div class="d-flex mb-2">
          <div class="mr-4">
            <label>{{ $t('form_live.tabs.SkinModel.showDate') }}</label>
            <b-form-checkbox         
            v-model="skinForm.skin.before.show_date"></b-form-checkbox>
          </div>

          <div>
            <label>{{ $t('form_live.tabs.SkinModel.showHour') }}</label>
            <b-form-checkbox    
             v-model="skinForm.skin.before.show_hour"></b-form-checkbox>
          </div>
        </div>
        <div class="form-group">
  <div class="custom-file-wrapper">
    <button
      type="button"
      class="btn-upload"
      :disabled="uploading.before"
      @click="$refs.beforeInput.click()"
    >
      <b-spinner small v-if="uploading.before" class="mr-2" />
      {{ $t('form_live.tabs.SkinModel.backgroundImage') }}
    </button>

    <input
      type="file"
      ref="beforeInput"
      accept="image/*"
      @change="e => uploadBackground(e, 'before')"
      class="hidden-file-input"
    />
  </div>

  <div
    v-if="skinForm.skin.before.backgroundPreview"
    class="mt-2 position-relative"
  >
  <div class="image-preview-wrapper position-relative d-inline-block">

    <img
      :src="skinForm.skin.before.backgroundPreview"
      class="bg-preview"
      :class="{ 'is-loading': uploading.before }"
      alt="Before background"
    />

    <div v-if="uploading.before" class="preview-overlay">
      <b-spinner />
    </div>
  </div>
</div>
</div>



        <b-form-checkbox            
        v-model="skinForm.skin.before.background_blur">
          {{ $t('form_live.tabs.SkinModel.blurred') }}
        </b-form-checkbox>
      </div>


      <!-- AFTER LIVE -->
      <div class="col-md-6 pl-md-4">
        <h6>{{ $t('form_live.tabs.SkinModel.afterLiveInfo') }}</h6>

        <div class="form-group mt-2">
          <label>{{ $t('form_live.tabs.SkinModel.infoText') }}</label>
          <textarea rows="2"
                    class="form-control w-100"
                  

                    v-model="skinForm.skin.after.info_text"></textarea>
        </div>
        <div class="form-group">
  <div class="custom-file-wrapper">
    <button
      type="button"
      class="btn-upload"
      :disabled=" uploading.after"
      @click="$refs.afterInput.click()"
    >
      <b-spinner small v-if="uploading.after" class="mr-2" />
      {{ $t('form_live.tabs.SkinModel.backgroundImage') }}
    </button>

    <input
      type="file"
      ref="afterInput"
      accept="image/*"
      @change="e => uploadBackground(e, 'after')"
      class="hidden-file-input"
    />
  </div>

  <div
    v-if="skinForm.skin.after.backgroundPreview"
    class="mt-2 position-relative"
  >
  <div class="image-preview-wrapper position-relative d-inline-block">

    <img
      :src="skinForm.skin.after.backgroundPreview"
      class="bg-preview"
      :class="{ 'is-loading': uploading.after }"
      alt="After background"
    />

    <div v-if="uploading.after" class="preview-overlay">
      <b-spinner />
    </div>
  </div>
  </div>
</div>



        <b-form-checkbox            
        v-model="skinForm.skin.after.background_blur">
          {{ $t('form_live.tabs.SkinModel.blurred') }}
        </b-form-checkbox>
      </div>

    </div>

    <!-- NAME + APPLY BUTTON -->
     <div class="mt-4 row d-flex justify-content-center align-items-center">
      <div  class="col-md-8 applied-skin-message">  
        <span v-show="skinIsEditMode">
      {{ $t('form_live.tabs.SkinModel.editNote') }}
    </span>
      </div> 

      <div class="col-md-4 d-flex justify-content-end align-items-center">

<input type="text"
       class="form-control mr-2"
       style="width: 220px"
       v-model="skinForm.skin.name"
       :placeholder="$t('form_live.tabs.SkinModel.skinName')">

<!-- <b-button v-if="!skinIsEditMode" variant="primary" @click="saveAndApplySkin">
  {{ $t('form_live.tabs.SkinModel.addAndApply') }}
</b-button>
<b-button v-if="skinIsEditMode"
    variant="primary"
    @click="saveAndApplySkin">
{{ $t('form_live.tabs.SkinModel.applySkin') }}
</b-button> -->

</div>
     </div>


  </div>
  </div>
</b-collapse>
</div>

</b-tab>
          </b-tabs>
          <b-tabs v-if="!isEmpreinteClient" content-class="mt-3" :noKeyNav="true">
            <b-tab active>
              <template slot="title">
                <div>
                  <font-awesome-icon icon="pen" />
                </div>
                <div class="d-none d-md-block ml-2">{{ $t('form_live.tabs.general.title') }}</div>
              </template>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group
                    :description="$t('form_live.tabs.general.form.description_image')"
                    :label="$t('form_live.tabs.general.form.add_image')"
                    label-for="live-thumbnail"
                    label-class="primary"
                  >
                  <thumbnail-cropper
  :crop-img="form.thumbnail"
  @thumbnailUpdated="handleThumbnailUpdated"
/>
                  </b-form-group>
                </b-col>
                <b-col md="8" sm="12">
                  <div class="form-group">
                    <label for="title" class="required primary">{{
                      $t('form_live.tabs.general.form.title')
                    }}</label>
                    <input
                      :placeholder="$t('form_live.tabs.general.form.title')"
                      type="text"
                      v-model="form.title"
                      id="title"
                      name="title"
                      class="form-control"
                      required
                    />
                    <div v-if="!$v.form.title.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="description" class="required primary">{{
                      $t('form_live.tabs.general.form.description')
                    }}</label>
                    <textarea
                      v-model="form.description"
                      class="form-control "
                      id="description"
                      :placeholder="$t('form_live.tabs.general.form.description')"
                      required
                      rows="3"
                    ></textarea>
                    <div v-if="!$v.form.description.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                  </div>
                  <div class="form-group" v-has-permission="'lives_type'" has-permission="lives_type">
                    <label class="primary">{{ $t('form_live.tabs.general.form.types') }}</label>
                    <multiselect
                      v-model="form.types"
                      :options="liveTypesOptions"
                      :multiple="false"
                      track-by="id"
                      label="title"
                      :close-on-select="false"
                      placeholder=""
                      :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                      :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                      :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
            
                    >
                      <span slot="noResult">{{
                        $t('form_live.tabs.advanced.contributors.no_result')
                      }}</span>
                      <span slot="noOptions">{{
                        $t('form_live.tabs.advanced.contributors.no_options')
                      }}</span>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.title }}</strong>
                      </template>

                      <template slot="option" slot-scope="{ option }">
                        <div :style="{ 'margin-left': option.index + 'em' }">
                          {{ option.title }}
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <div
                    class="form-group"
                    :class="{ 'is-invalid__custom': $v.form.startDate.$invalid }"
                  >
                    <label class="required primary">{{
                      $t('form_live.tabs.general.form.start_date')
                    }}</label>
                    <div id="filter-date" class="input_css input filter-date ">
                      <datepicker
                        id="start-date"
                        v-model="form.startDate"
                        input-class="form-control selectedDate"
                        wrapper-class="start-date-picker"
                        :bootstrap-styling="true"
                        :calendar-button="true"
                        :required="true"
                        :lang="$i18n.locale"
                        :disabled-days="disabledDate"
                        :format="'YYYY-MM-DD'"
                        value-type="format"
                        :active-color="getActiveColor"
                        :clearable="false"
                        :editable="false"
                      >
                        <template slot="calendar-icon">
                          <font-awesome-icon
                            class="calendar-icon "
                            :icon="{ prefix: 'fas', iconName: 'calendar-alt' }"
                          />
                        </template>
                      </datepicker>
                    </div>

                    <div v-if="!$v.form.startDate.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div v-else-if="!$v.form.startDate.minValue" class="invalid-feedback">
                      {{ $t('form_live.tabs.general.form.invalid_date') }}
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div
                    class="form-group"
                    :class="{ 'is-invalid__custom': $v.form.startTime.$invalid }"
                  >
                    <label for="start-time" class="required primary">{{
                      $t('form_live.tabs.general.form.start_hour')
                    }}</label>
                    <vue-clock-picker
                      id="start-time"
                      v-model="form.startTime"
                      input-class="form-control"
                      :active-color="getActiveColor"
                      :required="false"
                      :cancel-text="$t('button.cancel')"
                      :done-text="$t('button.done')"
                      :close-on-overlay="closeOnOverlay"
                      @close="closeModal"
                      @beforeOpen="handleBeforeOpen"
                    >
                    </vue-clock-picker>
                    <div v-if="!$v.form.startTime.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div v-else-if="!$v.form.startTime.minValue" class="invalid-feedback">
                      {{ $t('form_live.tabs.general.form.invalid_hour') }}
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div
                    class="form-group"
                    :class="{ 'is-invalid__custom': $v.form.endTime.$invalid }"
                  >
                    <label for="end-time" class="required primary">{{
                      $t('form_live.tabs.general.form.end_hour')
                    }}</label>
                    <vue-clock-picker
                      id="end-time"
                      v-model="form.endTime"
                      input-class="form-control"
                      :active-color="getActiveColor"
                      :required="false"
                      :cancel-text="$t('button.cancel')"
                      :done-text="$t('button.done')"
                      :close-on-overlay="closeOnOverlay"
                      @close="closeModal"
                      @beforeOpen="handleBeforeOpen"
                    >
                    </vue-clock-picker>
                    <div v-if="!$v.form.endTime.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div v-else-if="!$v.form.endTime.minValue" class="invalid-feedback">
                      {{ $t('form_live.tabs.general.form.invalid_hour') }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <div class="form-group">
                    <label class="primary">{{ $t('form_live.tabs.general.form.tags') }}</label>
                    <input-tag v-model="form.tags"
                    @input="handleAddInputTags"
                    :add-tag-on-keys=[13,32]
                    ></input-tag>
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="form-group">
                    <label class="primary">{{ $t('form_live.tabs.general.form.themes') }}</label>
                    <multiselect
                      v-model="form.themes"
                      :options="themesOptions"
                      :multiple="true"
                      track-by="id"
                      label="title"
                      :close-on-select="true"
                      placeholder=""
                      :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                      :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                      :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                    >
                      <span slot="noResult">{{
                        $t('form_live.tabs.advanced.contributors.no_result')
                      }}</span>
                      <span slot="noOptions">{{
                        $t('form_live.tabs.advanced.contributors.no_options')
                      }}</span>
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.title }}</strong>
                      </template>

                      <template slot="option" slot-scope="{ option }">
                        <div :style="{ 'margin-left': option.index + 'em' }">
                          {{ option.title }}
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template slot="title">
                <div>                     
                <font-awesome-icon icon="cog" />
                </div>
                <div class="d-none d-md-block ml-2">{{ $t('form_live.tabs.advanced.title') }}</div>
              </template>
              <div class="form-group" v-has-permission="'lives_type_no_api'" has-permission="lives_type_no_api">
                <label class="primary">{{  $t('form_live.tabs.advanced.type.title') }}</label>
                <b-form-radio-group v-model="form.isCdn" name="type">
                  <b-form-radio :value="false">{{
                    $t('form_live.tabs.advanced.type.intranet')
                  }}</b-form-radio>
                  <b-form-radio :value="true">{{
                    $t('form_live.tabs.advanced.type.internet')
                  }}</b-form-radio>
                </b-form-radio-group>
              </div>
              <div
                class="form-group"
                v-has-permission="getDifferentDiffusionPermission"
              >
                <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.title_empreinte') }}</label>
                <b-form-radio-group v-model="form.diffusion" @input="handleDiffusionTypeChanged('diffusion')">
                  <b-row>
                    <b-col xl="4" lg="4" md="4" sm="12" class="order-1 order-md-0" v-has-permission="'lives_webinar_no_api'" has-permission="lives_webinar_no_api">
                      <b-form-radio value="webinar">
                        <font-awesome-icon
  class="actionIcons btn-icons video-icon"
  :icon="{ prefix: 'fas', iconName: 'video' }"
/>

                        {{
                       $t('form_live.tabs.advanced.diffusion.webinar_empreinte')
                      }}
                      </b-form-radio>
                      <div class="webinar-type" v-has-permission="'lives_webinar_type_by_link_no_api,lives_webinar_type_private_no_api,lives_webinar_type_public_no_api'" 
                      has-permission="lives_webinar_type_by_link_no_api,lives_webinar_type_private_no_api,lives_webinar_type_public_no_api"
                      v-if="form.diffusion==='webinar' && form.webinar">
                        <div class="form-group" >
                            <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.type.title_empreinte') }}</label>
                            <b-form-radio-group v-model="form.accessType" @input="handleDiffusionTypeChanged('accessType')">
                              <b-row >
                                <div class="webinar-type__radio col-xl-6 col-lg-12" v-has-permission="'lives_webinar_type_by_link_no_api'" has-permission="lives_webinar_type_by_link_no_api">
                                  <b-form-radio value="by_link">{{
                                  $t('form_live.tabs.advanced.diffusion.type.by_link_empreinte')
                                    }}</b-form-radio>
                                </div>
                                <div class="webinar-type__radio col-xl-3 col-lg-12"  v-has-permission="'lives_webinar_type_private_no_api'" has-permission="lives_webinar_type_private_no_api">
                                  <b-form-radio value="private" >{{
                                    $t('form_live.tabs.advanced.diffusion.type.private_empreinte')
                                    }}</b-form-radio>
                                </div>
                                <div class="webinar-type__radio col-xl-3 col-lg-12"  v-has-permission="'lives_webinar_type_public_no_api'" has-permission="lives_webinar_type_public_no_api">
                                  <b-form-radio
                                    value="public"

                                  >{{  $t('form_live.tabs.advanced.diffusion.type.public_empreinte') }}
                                  </b-form-radio>
                                </div>
                              </b-row>
                            </b-form-radio-group>
                        </div>
                        <div class="form-group" v-has-permission="'lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'"
                        has-permission="lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api"
                        >
                            <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.connexion.title_empreinte')}}</label>
                            <b-form-radio-group v-model="form.connexionType" @input="handleDiffusionTypeChanged('connexionType')">
                              <b-row class="webinar-type__radio">
                                <div class="webinar-type__radio col-xl-6" v-has-permission="'lives_webinar_connexion_auto_no_api'" has-permission="lives_webinar_connexion_auto_no_api">
                                  <b-form-radio value="auto">{{
                                    $t('form_live.tabs.advanced.diffusion.connexion.auto')
                                    }}</b-form-radio>
                                </div>
                                <div class="webinar-type__radio col-xl-6" v-has-permission="'lives_webinar_connexion_by_authorization_no_api'" has-permission="lives_webinar_connexion_by_authorization_no_api">
                                  <b-form-radio value="by_authorization" >{{
                                    $t('form_live.tabs.advanced.diffusion.connexion.by_authorization')
                                    }}</b-form-radio>
                                </div>
                              </b-row>
                            </b-form-radio-group>
                        </div>
                       </div>
                    </b-col>
<b-col xl="4" lg="4" md="4" sm="12">
  <b-form-radio 
    :value="'isPearl'"
    @change="form.diffusion = 'isPearl'"
    v-has-permission="'lives_encoder_no_api'" 
    has-permission="lives_encoder_no_api"
  >
  <font-awesome-icon
  class="actionIcons btn-icons server-icon"
  :icon="{ prefix: 'fas', iconName: 'server' }"
/>
    {{$t('form_live.tabs.advanced.diffusion.encodeur_empreinte')}}
  </b-form-radio>
    <div v-if="form.diffusion === 'isPearl'" class="encoder-options mt-3 ml-3">
    <b-form-radio-group 
      v-model="form.isAuto" 
      name="encoder-type-group"
      @input="handleEncoderTypeChange"
    >
      <b-form-radio
        :value="false"
        v-has-permission="'lives_encoder_no_api'"
        has-permission="lives_encoder_no_api"
      >

        {{ $t('form_live.tabs.advanced.diffusion.encoding') }}
      </b-form-radio>
      <b-form-radio
      v-if="hasPermission('lives_encoder_external_no_api')"
      :value="true"
        v-has-permission="'lives_encoder_external_no_api'"
        has-permission="lives_encoder_external_no_api"
      >
        {{ $t('form_live.tabs.advanced.diffusion.encodeur_automatique') }}
      </b-form-radio>
    </b-form-radio-group>
    <!-- <div v-if="form.encoderType === 'manual'" class="mt-3">
      <div class="mb-2">
        <label for="manual-station-select" class="font-weight-bold">
          {{ $t('form_live.tabs.advanced.diffusion.select_station') }}
        </label>
        <b-form-select
          id="manual-station-select"
          v-model="form.selectedManualStation"
          :options="manualStations"
          :disabled="loadingManualStations"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              {{ loadingManualStations ? $t('form_live.tabs.advanced.diffusion.loading_stations') : $t('form_live.tabs.advanced.diffusion.select_station') }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </div>
    </div> -->

    <div v-if="form.isAuto" class="mt-3">
      <div class="mb-2">
        <label for="automatic-station-select" class="required primary">
          {{ $t('form_live.tabs.advanced.diffusion.select_station') }}
        </label>
        <b-form-select
  id="automatic-station-select"
  v-model="form.stationId"
  :options="automaticStations"
  value-field="id"
  text-field="name"
  :disabled="loadingAutomaticStations"
  @change="onStationChange"
  required
>
  <template #first>
    <option :value="null" disabled>
      {{ loadingAutomaticStations
        ? $t('form_live.tabs.advanced.diffusion.loading_stations')
        : $t('form_live.tabs.advanced.diffusion.select_station') }}
    </option>
  </template>
</b-form-select>
      </div>
    </div>
        <div v-if="form.isAuto" class="mt-3">
      <b-row>
        <b-col cols="6" class="mb-2">
          <label for="encoder-input-1" class="form-label">
            {{ $t('form_live.tabs.advanced.diffusion.index_video_port') }} :
          </label>
          <b-form-input
            id="encoder-input-1"
            v-model="form.videoPortIndex"
            type="number"
            min="0"
            placeholder="0"
            :readonly="isUnescoClient"
          ></b-form-input>
          <small v-if="isUnescoClient" class="text-muted">
          </small>
        </b-col>
        <b-col cols="6" class="mb-2">
          <label for="encoder-input-2" class="form-label">
            {{ $t('form_live.tabs.advanced.diffusion.index_audio_port') }} :
          </label>
          <b-form-input
            id="encoder-input-2"
            v-model="form.audioPortIndex"
            type="number"
            min="0"
            placeholder="0"
            :readonly="isUnescoClient"
          ></b-form-input>
          <small v-if="isUnescoClient" class="text-muted">
          </small>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col cols="12">
          <label for="protocol-select" class="form-label">
            {{ $t('form_live.tabs.advanced.diffusion.protocol') }}
          </label>
          <b-form-select
            id="protocol-select"
            v-model="form.protocolType"
            :options="protocolOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
  </div>
</b-col>
                    <b-col xl="4" lg="4"  md="4" sm="12">

                    <b-form-radio
                        value="externalHls"
                        v-has-permission="''"
                        >
                        <font-awesome-icon
  class="actionIcons btn-icons network-icon"
  :icon="{ prefix: 'fas', iconName: 'network-wired' }"
/>

                        {{ $t('form_live.tabs.advanced.diffusion.externalHlst') }}
                      </b-form-radio>
                      <div v-show="form.externalHls" >
                        <b-form-input @input="setHls"
                        v-model="form.linkHls" v-has-permission="''"></b-form-input>
                      </div>
                    </b-col>
                    <b-col xl="4" lg="4"  md="4" sm="12">
                      <!-- Ce code sera annoté en cas de besoin ultérieur. -->

                      <!-- <b-form-radio
                        v-has-permission="'lives_screen_share_no_api'"
                        >{{ $t('form_live.tabs.advanced.diffusion.sharing') }}
                      </b-form-radio>
                      <div v-if="form.screenShare">
                        <b-form-select
                          class="screen-share-select"
                          v-model="form.screenType"
                          :options="screenTypeOptions"
                        ></b-form-select>
                      </div> -->
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </div>
              <div class="form-group">
                <label
                  class="primary"
                  v-has-permission="'lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'"
                  has-permission="lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api"
                  >{{ $t('form_live.tabs.advanced.options.title_empreinte') }}</label>
                <b-row>
                  <!-- This code will be annotated if needed later. -->
                  
                  <!-- <b-col md="3" sm="12" v-has-permission="'lives_private_no_api'" has-permission="lives_private_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.private">{{
                        $t('form_live.tabs.advanced.options.private_video')
                      }}</b-form-checkbox>
                    </div>
                  </b-col> -->
                  <b-col md="4" sm="12" v-has-permission="'lives_active_no_api'" has-permission="lives_active_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.active">{{
                        $t('form_live.tabs.advanced.options.active_video')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="4" sm="12" >
                    <div class="form-group">
                        <b-form-checkbox v-model="form.isRecorded" class="form-group">{{$t('form_live.tabs.advanced.options.saveVideo')}} </b-form-checkbox>
                        <b-form-group v-if="form.isRecorded" v-has-permission="'lives_autopub_no_api'" has-permission="lives_autopub_no_api">
                          <b-form-checkbox v-model="form.autoPublish">{{
                            $t('form_live.tabs.advanced.options.automatic_share')
                          }}</b-form-checkbox>
                        </b-form-group>
                    </div>
                  </b-col>
                  <b-col md="4" sm="12" v-has-permission="'lives_dvr_no_api'" has-permission="lives_dvr_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.isDvr">DVR</b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>
                


                 <div class="fields-example">
          <label v-has-permission="'lives_langues_post_add','lives_countries_post_add'" class="primary"> {{ $t('form_live.tabs.advanced.diffusion.languages_empreinte')  }}</label>

    <b-row>
  
      <b-col md="6" sm="12">

        <div class="form-group" v-has-permission="'lives_langues_post_add'">
          <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.languages') }}</label>
          <multiselect
            v-model="form.languages"
            :options="languagesOptions"
            :multiple="true"
            track-by="label"
            label="lang"
            :close-on-select="true"
            :placeholder="$t('form_live.tabs.advanced.diffusion.languagesPlaceholder')"
            :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
            :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
            :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
          >
            <span slot="noResult">{{
              $t('form_live.tabs.advanced.contributors.no_result')
            }}</span>
            <span slot="noOptions">{{
              $t('form_live.tabs.advanced.contributors.no_options')
            }}</span>
            <template slot="option" slot-scope="{ option }">
              <div>{{ option.lang }}</div>
            </template>
          </multiselect>
        </div>
      </b-col>
      <b-col md="6" sm="12">
     
        <div class="form-group" v-has-permission="'lives_countries_post_add'" >
          <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.countries') }}</label>
          <multiselect
            v-model="form.countries"
            :options="countriesOptions"
            :multiple="true"
            track-by="id"
            label="countryName"
            :close-on-select="true"
            :placeholder="$t('form_live.tabs.advanced.diffusion.countriesPlaceholder')"
            :loading="isLoadingCountries"
            :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
            :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
            :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
          >
            <span slot="noResult">{{
              $t('form_live.tabs.advanced.contributors.no_result')
            }}</span>
            <span slot="noOptions">{{
              $t('form_live.tabs.advanced.contributors.no_options')
            }}</span>
            <template slot="option" slot-scope="{ option }">
              <div>{{ option.countryName }}</div>
            </template>
          </multiselect>
        </div>
      </b-col>
    </b-row>
    <label  v-has-permission="'lives_youtubelinks_post_add'" class="primary"> {{ $t('form_live.tabs.frontOffice.options.social_media.title') }}</label>
   <youtube-links
     v-has-permission="'lives_youtubelinks_post_add'"
    :initial-youtube-enabled="form.isYoutube"
    :initial-youtube-links="form.youtubeLinks"
    @update:youtubeEnabled="onYoutubeEnabledChange"
    @update:youtubeLinks="onYoutubeLinksChange"
/>
  </div>
                <b-row v-has-permission="'lives_associate_users_no_api'" has-permission="lives_associate_users_no_api">
                     

      
                  
                  <b-col cols="12">

<div class="form-group">            
    <label>{{ $t('form_live.tabs.advanced.contributors.title') }}</label>
    <multiselect
      v-model="form.contributors"
      :options="getWebtvUsers"
      :multiple="true"
      track-by="email"
      label="email"
      placeholder=""
      :close-on-select="false"
      :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
      :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
      :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
    >
      <span slot="noResult">{{
        $t('form_live.tabs.advanced.contributors.no_result')
      }}</span>
      <span slot="noOptions">{{
        $t('form_live.tabs.advanced.contributors.no_options')
      }}</span>
      <template slot="singleLabel" slot-scope="{ option }">
        <strong>{{ option.name }}</strong>
      </template>
    </multiselect>
  </div>
</b-col>

<b-col cols="12">
                    <div class="form-group">
                <div><label  class="primary">{{ $t('form_live.tabs.advanced.contributors.header') }}</label> </div>

                      <label>{{ $t('form_live.tabs.advanced.contributors.participantTitle') }}</label>
                      <multiselect
                        v-model="form.participants"
                        :options="localParticipantOptions"
                        :multiple="true"
                        track-by="email"
                        label="email"
                        placeholder=""
                        :taggable="true"
                        :tag-placeholder="$t('form_live.tabs.advanced.contributors.add_email')"
                        @tag="addCustomParticipant"
                        :close-on-select="false"
                        :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                        :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                        :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                      >
                        <span slot="noResult">{{
                          $t('form_live.tabs.advanced.contributors.no_result')
                        }}</span>
                        <span slot="noOptions">{{
                          $t('form_live.tabs.advanced.contributors.no_options')
                        }}</span>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.name }}</strong>
                        </template>
                      </multiselect>
                    </div>
                  </b-col>


                </b-row>
                <!-- Moderators -->
               <b-row v-has-permission="'lives_associate_users_no_api'">
                  <b-col cols="12">
                    <div class="form-group">
                      <label>{{ $t('modal.moderators') }}</label>
                      <multiselect
                        v-model="moderators"
                        :options="getWebtvUsers"
                        :multiple="true"
                        track-by="id"
                        label="email"
                        placeholder=""
                        :close-on-select="false"
                        :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                        :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                        :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                      >
                        <span slot="noResult">{{
                          $t('form_live.tabs.advanced.contributors.no_result')
                        }}</span>
                        <span slot="noOptions">{{
                          $t('form_live.tabs.advanced.contributors.no_options')
                        }}</span>
                          <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.email }}</strong>
                        </template>
                      </multiselect>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-has-permission="'lives_rich_media_no_api'" has-permission="lives_rich_media_no_api">
                  <b-col cols="12">
                    <div class="form-group">
                  <label class="primary"> {{ $t('form_live.tabs.advanced.diffusion.medias') }}  </label>

                      <b-form-checkbox v-model="form.isRm">{{
                        $t('form_live.tabs.advanced.rich_media.title')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col cols="12" v-if="form.isRm">
                    <div class="rm-tabs-wrapper">
                      <b-tabs content-class="mt-3" :noKeyNav="true">
                        <b-tab
                          v-if="hasPermission('lives_rich_media_chapter_no_api')"
                          has-permission="lives_rich_media_chapter_no_api"
                          active
                          @click="focusAddChapter"
                        >
                          <template slot="title">
                            <div>
                              <font-awesome-icon icon="list" />
                            </div>
                            <div class="d-none d-md-block ml-2">
                              {{ $t('form_live.tabs.advanced.rich_media.tabs.chapters.title') }}
                            </div>
                          </template>
                          <!--<VuePerfectScrollbar-->
                            <!--ref="ps-chapters"-->
                            <!--class="scroll-area scroll-chapters"-->
                          <!--&gt;-->
                            <b-row>
                              <b-col md="12">
                                <div class="chapters-wrapper">
                                  <draggable v-model="form.chapters" handle=".sort-handler">
                                    <div
                                      md="12"
                                      class="chapter-wrapper"
                                      v-for="(chapter, index) in form.chapters"
                                      :key="index"
                                    >
                                      <div class="chapter-container">
                                        <div class="sort-handler">
                                          <font-awesome-icon icon="bars" />
                                        </div>
                                        <div class="index">{{ index + 1 }}.&nbsp;</div>
                                        <div v-show="!chapter.isEditMode">
                                          {{ chapter.title }}
                                        </div>
                                        <b-form-group class="m-0"   v-show="chapter.isEditMode">
                                          <b-form-input

                                            v-model="chapterTitle"
                                            :placeholder="
                                              $t(
                                                'form_live.tabs.advanced.rich_media.tabs.chapters.fields.title',
                                              )
                                            "
                                            @keyup.enter="toggleEditChapter(index)"
                                          ></b-form-input>
                                          <b-button
                                            size="sm"
                                            @click="toggleEditChapter(index)"
                                            variant="light"
                                            class="inline-submit-btn"
                                            v-show="chapter.isEditMode && !!chapter.title"
                                          >
                                            <font-awesome-icon
                                              icon="check-circle"
                                            ></font-awesome-icon>
                                          </b-button>
                                        </b-form-group>
                                      </div>
                                      <div class="rm-actions-wrapper" v-show="!chapter.isEditMode">
                                        <b-button
                                          v-show="!isChapterEditMode"
                                          size="sm"
                                          @click.stop="toggleEditChapter(index, false)"
                                          variant="light"
                                        >
                                          <span class="icon-edit"></span>
                                        </b-button>
                                        <b-button
                                          size="sm"
                                          @click="removeChapter(index)"
                                          variant="light"
                                          class="btn-remove"
                                        >
                                          <span class="icon-trash"></span>
                                        </b-button>
                                      </div>
                                    </div>
                                  </draggable>
                                  <h5
                                    class="text-center m-3 c-grey-600"
                                    v-if="form.chapters.length === 0"
                                  >
                                    {{
                                      $t('form_live.tabs.advanced.rich_media.tabs.chapters.empty')
                                    }}
                                  </h5>
                                </div>
                              </b-col>
                            </b-row>
                          <!--</VuePerfectScrollbar>-->
                          <div class="add-item-wrapper">
                            <div class="position-relative">
                              <b-form-input
                                v-model="newChapter"
                                :placeholder="
                                  $t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.new')
                                "
                                @keyup.enter="addChapter"
                                ref="newChapterInput"
                              ></b-form-input>
                              <b-button
                                v-show="newChapter"
                                size="sm"
                                @click="addChapter"
                                variant="light"
                                class="inline-submit-btn"
                              >
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                              </b-button>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab v-if="hasPermission('lives_rich_media_question_no_api')" has-permission="lives_rich_media_question_no_api">
                          <template slot="title">
                            <div>
                              <span class="icon-question"></span>
                            </div>
                            <div class="d-none d-md-block ml-2">
                              {{ $t('form_live.tabs.advanced.rich_media.tabs.questions.title') }}
                            </div>
                          </template>
                          <!--<VuePerfectScrollbar-->
                            <!--ref="ps-questions"-->
                            <!--class="scroll-area scroll-questions"-->
                          <!--&gt;-->
                            <b-row>
                              <b-col md="12">
                                <div class="chapters-wrapper">
                                  <draggable v-model="form.questions" handle=".sort-handler">
                                    <div
                                      md="12"
                                      class="chapter-wrapper"
                                      v-for="(question, index) in form.questions"
                                      :key="index"
                                    >
                                      <div
                                        class="chapter-container question"
                                        :class="{ 'is-open': question.isEditMode }"
                                      >
                                        <div class="sort-handler">
                                          <font-awesome-icon icon="bars" />
                                        </div>
                                        <div class="index">{{ index + 1 }}.&nbsp;</div>
                                        <div v-show="!question.isEditMode">
                                          {{ question.question }}
                                        </div>
                                        <question-form
                                          v-if="question.isEditMode"
                                          :question="question"
                                          :buttonLabel="
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.edit',
                                            )
                                          "
                                          @addQuestion="updateQuestion($event, index)"
                                          @closeForm="toggleEditQuestion(index)"
                                        >
                                        </question-form>
                                      </div>
                                      <div class="rm-actions-wrapper" v-show="!question.isEditMode">
                                        <b-button
                                          v-show="!isQuestionEditMode"
                                          size="sm"
                                          @click.stop="toggleEditQuestion(index)"
                                          variant="light"
                                        >
                                          <span class="icon-edit"></span>
                                        </b-button>
                                        <b-button
                                          size="sm"
                                          @click="removeQuestion(index)"
                                          variant="light"
                                          class="btn-remove"
                                        >
                                          <span class="icon-trash"></span>
                                        </b-button>
                                      </div>
                                    </div>
                                  </draggable>
                                  <h5
                                    class="text-center m-3 c-grey-600"
                                    v-if="form.questions.length === 0"
                                  >
                                    {{
                                      $t('form_live.tabs.advanced.rich_media.tabs.questions.empty')
                                    }}
                                  </h5>
                                </div>
                              </b-col>
                            </b-row>
                          <!--</VuePerfectScrollbar>-->
                          <div class="add-item-wrapper">
                            <question-form
                              v-if="addQuestionMode"
                              @addQuestion="addQuestion"
                              @closeForm="addQuestionMode = false"
                            >
                              <label slot="title">{{
                                $t('form_live.tabs.advanced.rich_media.tabs.questions.new')
                              }}</label>
                            </question-form>
                            <b-row v-if="!addQuestionMode">
                              <b-col>
                                <div class="float-right">
                                  <b-button
                                    variant="link"
                                    type="button"
                                    @click="setAddQuestionMode(true)"
                                  >
                                    <font-awesome-icon icon="plus-circle" />
                                    {{
                                      $t(
                                        'form_live.tabs.advanced.rich_media.tabs.questions.add_new',
                                      )
                                    }}</b-button
                                  >
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-tab>
                        <b-tab
                          @click="updateScrollbar"
                          v-has-permission="'lives_rich_media_slides_no_api'"
                          has-permission="lives_rich_media_slides_no_api"
                        >
                          <template slot="title">
                            <div>
                              <font-awesome-icon icon="th-large" />
                            </div>
                            <div class="d-none d-md-block ml-2">
                              {{ $t('form_live.tabs.advanced.rich_media.tabs.slides.title') }}
                            </div>
                          </template>

                          <div class="slides-wrapper">
                            <!--<VuePerfectScrollbar ref="ps-slides" class="scroll-area">-->
                              <draggable v-model="form.slides" class="row">
                                <b-col
                                  lg="2"
                                  md="3"
                                  sm="4"
                                  class="slide-wrapper"
                                  v-for="(slide, index) in form.slides"
                                  :key="index"
                                >
                                  <figure class="img-fluid">
                                    <div class="type-tag">
                                      <span
                                        :class="
                                          'icon-' +
                                            (slide.slideType === 'Image' ? 'picture' : 'video')
                                        "
                                      ></span>
                                    </div>
                                    <img
                                      v-if="slide.slideType === 'Image'"
                                      :src="slide.urlSlide"
                                      alt=""
                                    />
                                    <video
                                      v-if="slide.slideType === 'Video'"
                                      :src="slide.urlSlide"
                                      alt=""
                                    ></video>
                                    <div class="more-btn-container">
                                      <b-dropdown
                                        variant="link"
                                        toggle-class="text-decoration-none"
                                        no-caret
                                      >
                                        <template slot="button-content">
                                          <span class="icon-more"></span>
                                        </template>
                                        <b-dropdown-item @click.stop="replaceSlide(index)">
                                          <span class="icon-edit"></span>
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.edit',
                                            )
                                          }}
                                        </b-dropdown-item>
                                        <b-dropdown-item @click.stop="removeSlide(index)">
                                          <span class="icon-trash"></span>
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.delete',
                                            )
                                          }}
                                        </b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                  </figure>
                                </b-col>
                              </draggable>
                            <!--</VuePerfectScrollbar>-->
                          </div>
                          <div class="dz-upload-wrapper">
                            <vue-dropzone
                              id="slides-dz"
                              ref="slidesDZ"
                              :options="getDropzoneOptions('media')"
                              :auto-process-queue="false"
                              @vdropzone-files-added="handleDzSlideAdded"
                              @vdropzone-file-added-manually="handleDzSlideAdded"
                              @vdropzone-complete="handleDzSlideCompleted"
                            >
                            </vue-dropzone>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-has-permission="'lives_associate_files_no_api'" has-permission="lives_associate_files_no_api">
                  <b-col md="3" sm="12">
                    <div class="form-group">
                      <b-form-checkbox v-model="joinFile">{{
                         $t('form_live.tabs.advanced.attaching_files_empreinte')
                      }}</b-form-checkbox>
                    </div>
                    <div class="attached-files-wrapper" v-if="joinFile">
                      <div class="attached-file" v-for="(file, index) in form.files">
                        <b-button
                          variant="link"
                          class="attached-file__btn-remove"
                          @click="removeFile(index)"
                        >
                          <font-awesome-icon icon="times-circle"></font-awesome-icon>
                        </b-button>
                        <div class="attached-file__icon">
                          <font-awesome-icon :icon="file.icon" />
                        </div>
                        <div class="attached-file__name">
                          {{ file.fileName }}
                        </div>
                      </div>
                    </div>
                    <vue-dropzone
                      id="files-dz"
                      ref="filesDZ"
                      v-if="joinFile"
                      :options="getDropzoneOptions('file')"
                      :auto-process-queue="false"
                      @vdropzone-files-added="handleDzFileAdded"
                      @vdropzone-file-added-manually="handleDzFileAdded"
                      @vdropzone-complete="handleDzFileCompleted"
                    ></vue-dropzone>
                  </b-col>
                  <b-col
                    md="4"
                    sm="12"
                    v-has-permission="'lives_fo_files_share_no_api'"
                    has-permission="lives_fo_files_share_no_api"
                  >
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foFilesShare" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.sharing_files')
                      }}</b-form-checkbox>
                      <b-form-group v-if="form.foFilesShare">
                          <b-form-checkbox  v-model="form.doc_public"
                            >{{
                              $t('form_live.tabs.frontOffice.options.sharing_files_live_event.text')
                            }}
                            <span style="color: #62626b">
                              {{
                                $t(
                                  'form_live.tabs.frontOffice.options.sharing_files_live_event.explanation',
                                )
                              }}
                            </span>
                          </b-form-checkbox>
                          <b-form-checkbox  v-model="form.doc_public_mail">
                          {{
                            $t('form_live.tabs.frontOffice.options.sharing_files_emails')
                          }}</b-form-checkbox>
                          <b-form-checkbox  v-model="form.doc_private">
                            {{
                              $t(
                                'form_live.tabs.frontOffice.options.sharing_files_studio_live.text',
                              )
                            }}
                            <span style="color: #62626b">
                              {{
                                $t(
                                  'form_live.tabs.frontOffice.options.sharing_files_studio_live.explanation',
                                )
                              }}
                            </span>
                          </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-tab>
            <b-tab
              @click="initInfinitScrollVideos = true"
              has-permission="lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api"
              v-if="
                hasPermission(
                  'lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api',
                )
              "
            >
              <template slot="title">
                <div>
                  <font-awesome-icon icon="desktop" />
                </div>
                <div class="d-none d-md-block ml-2">
                   Player
                </div>
              </template>
              <div class="form-group">
                <div>
                <label v-has-permission="'lives_password_security_no_api','lives_fo_subscript_no_api'" class="primary">{{ $t('form_live.tabs.frontOffice.access_page_direct') }}</label>
                <b-row>
<b-col md="3" sm="12" v-has-permission="'lives_password_security_no_api'" has-permission="lives_password_security_no_api">
                    <div class="form-group">
                      <b-form-checkbox
                        v-model="password"
                        class="primary"
                        @input="handleToggleSecured"
                        >{{ $t('form_live.tabs.frontOffice.mdp')}}</b-form-checkbox
                      >
                      <div class="sub-form-control" v-if="password">
                        <b-form-input
                          type="text"
                          v-model="form.pwd"
                          placeholder="*****"
                        ></b-form-input>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_subscript_no_api'" has-permission="lives_fo_subscript_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foSubscript" class="primary">{{
                       $t('form_live.tabs.frontOffice.inscri_abonne')
                      }}</b-form-checkbox>
                           <div class="form-group">
                    </div>
                    </div>
                  </b-col>
               </b-row>
                <label v-has-permission="'lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'" class="primary">{{ $t('form_live.tabs.frontOffice.lecteur_video') }}</label>
                <b-row>
   <b-col md="3" sm="12" v-has-permission="'lives_fo_like_no_api'" has-permission="lives_fo_like_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foLike" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.like')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_chat_no_api'" has-permission="lives_fo_chat_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.chat" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.chat_empreinte')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_chat_no_api'" has-permission="lives_fo_chat_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.privateChat" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.privateChat_empreinte')
                      }}</b-form-checkbox>
                    </div>
                    </b-col>
                     <b-col md="3" sm="12" v-has-permission="'lives_social_media_no_api'" has-permission="lives_social_media_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="socialNetwork" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.social_media.title')
                      }}</b-form-checkbox>
                      <div class="sub-form-control" v-if="socialNetwork">                    
                        <b-form-checkbox
                          v-model="form.foFacebook"
                          :inline="true"
                          aria-label="ddd"
                          >{{
                            $t('form_live.tabs.frontOffice.options.social_media.fb')
                          }}</b-form-checkbox
                        >
                        <b-form-checkbox v-model="form.foYoutube" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.social_media.youtube')
                        }}</b-form-checkbox>
                      </div>
                    </div>
                  </b-col>
                  </b-row>
                <label v-has-permission="'lives_fo_comment_no_api'" class="primary">Questions</label>
                <b-row>
                  <b-col  md="3" sm="12" v-has-permission="'lives_fo_comment_no_api'" has-permission="lives_fo_comment_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foComment" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.active_comment.title')
                      }}</b-form-checkbox>
                      <div
                      class="sub-form-control"
                      v-show="form.foComment"
                      v-has-permission="'lives_fo_comment_confirmation_no_api'"
                      has-permission="lives_fo_comment_confirmation_no_api"
                    >
                      <b-form-checkbox v-model="form.canCommentBeforeLive">{{
                        $t('form_live.tabs.frontOffice.options.active_comment.questionsBeforeLive')
                      }}</b-form-checkbox>
                    </div>
                      <div
                        class="sub-form-control"
                        v-show="form.foComment"
                        v-has-permission="'lives_fo_comment_confirmation_no_api'"
                        has-permission="lives_fo_comment_confirmation_no_api"
                      >
                        <b-form-checkbox v-model="form.isCommentValidation">{{
                          $t('form_live.tabs.frontOffice.options.active_comment.confirm')
                        }}</b-form-checkbox>
                      </div>
                      <div
                      class="sub-form-control"
                      v-show="form.foComment"
                      v-has-permission="'lives_fo_comment_confirmation_no_api'"
                      has-permission="lives_fo_comment_confirmation_no_api"
                    >
                      <b-form-checkbox v-model="form.canReplyToComments">{{
                        $t('form_live.tabs.frontOffice.options.active_comment.replies')
                      }}</b-form-checkbox>
                    </div>

                    </div>
                  </b-col>
                  </b-row>
                <label v-has-permission="'lives_fo_subtitles_no_api'" has-permission="lives_fo_subtitles_no_api" class="primary">{{ $t('form_live.tabs.frontOffice.sous_titrage') }}</label>
                 <b-row>
<b-col md="3" sm="12" v-has-permission="'lives_fo_subtitles_no_api','lives_fo_auto_transcription'" has-permission="lives_fo_subtitles_no_api">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.foSubtitles" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.subtitles_empreinte')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col md="3" sm="12" v-has-permission="'lives_fo_auto_transcription'" has-permission="lives_fo_auto_transcription">
                    <div class="form-group">
                      <b-form-checkbox v-model="form.autoTranscription" class="primary">{{
                        $t('form_live.tabs.frontOffice.options.autoTranscription_empreinte')
                      }}</b-form-checkbox>
                    </div>
                  </b-col>
                  </b-row>
                <label v-if="hasPermission('lives_fo_whiteboard_no_api') || hasPermission('lives_fo_poll_no_api') || hasPermission('lives_fo_question_no_api') || hasPermission('lives_fo_excel_no_api')" class="primary">{{  $t('form_live.tabs.frontOffice.options.interactive_tools.title') }}</label>
                  <b-row>                
                    <b-col md="12" sm="12"  >
                    <div class="form-group">
                      <div>                    
                        <b-form-checkbox
                        v-has-permission="'lives_fo_whiteboard_no_api'" has-permission="lives_fo_whiteboard_no_api"
                          v-model="form.whiteboard"
                          :inline="true"
                          aria-label="ddd"
                          >{{
                            $t('form_live.tabs.frontOffice.options.interactive_tools.whiteBoard')
                          }}</b-form-checkbox
                        >
                        <b-form-checkbox
                        v-has-permission="'lives_fo_poll_no_api'" has-permission="lives_fo_poll_no_api"
                        v-model="form.poll" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.interactive_tools.survey')
                        }}</b-form-checkbox>
                            <b-form-checkbox
                            v-has-permission="'lives_fo_question_no_api'" has-permission="lives_fo_question_no_api"
                            v-model="form.qna" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.interactive_tools.question')
                        }}</b-form-checkbox>
                            <b-form-checkbox
                            v-has-permission="'lives_fo_excel_no_api'" has-permission="lives_fo_excel_no_api"
                            v-model="form.spreadsheet_excel" :inline="true">{{
                          $t('form_live.tabs.frontOffice.options.interactive_tools.excel')
                        }}</b-form-checkbox>
                        <b-form-checkbox v-if="isEmpreintePollClient" v-model="form.autoSip" :inline="true">
                          {{ $t('form_live.tabs.frontOffice.options.interactive_tools.autoSip') }}
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>
                  </b-row> 
                  
</div>
              </div>



              <hr />
              <div class="form-group" v-has-permission="'lives_conf_post_add'" has-permission="lives_conf_post_add">
                <label
                  class="primary conf-label"
                  >{{ $t('form_live.tabs.frontOffice.configuration.title') }}</label
                >
                <b-form-group>
                  <b-form-radio-group
                    v-model="form.defaultConf"
                  >
                    <b-form-radio :value="true">{{
                      $t('form_live.tabs.frontOffice.configuration.default')
                    }}</b-form-radio>
                    <b-form-radio :value="false">{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.title')
                    }}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div
                class="custom-configuration "
                v-if="!form.defaultConf"
                v-has-permission="'lives_conf_post_add'"
                has-permission="lives_conf_post_add"
              >
                <!---- radio button message--->
                <div  class="form-group">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Message"
                    v-has-permission="'lives_conf_message_option'"
                    has-permission="lives_conf_message_option"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.message.title')
                    }}</b-form-radio
                  >
                  <textarea
                    rows="5" maxlength="255"
                    v-show="form.conf.type === 'Message'"
                    v-model="form.conf.message"
                    class="form-control "
                    :placeholder="
                      $t(
                        'form_live.tabs.frontOffice.configuration.personalized.message.description',
                      )
                    "
                    required
                    @keyup="removeError($event)"
                    @focus="removeError($event)"
                  ></textarea>
                  <div v-if="this.showErrorMessage" class="error_message">
                    {{ $t('form_live.tabs.error_long_message') }}
                  </div>
                  <div v-if="!$v.form.conf.message.required" class="invalid-feedback">
                    {{ $t('form_live.tabs.required_message') }}
                  </div>
                </div>
                <!---- radio button video--->
                <div class="form-group">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Video"
                    v-has-permission="'lives_conf_video_option'"
                    has-permission="lives_conf_video_option"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.video.title')
                    }}</b-form-radio
                  >
                  <div v-if="!isBeforeLiveVideoPickerVisible && form.conf.type === 'Video'">
                    <div class="before-live-video-container">
                      <figure>
                        <div class="before-live-video-container__overlay">
                          <font-awesome-icon icon="play-circle"></font-awesome-icon>
                        </div>
                        <button
                          class="btn btn-sm before-live-video-container__btn"
                          @click="toggleBeforeLiveVideoPicker"
                        >
                          <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                          Changer la source
                        </button>
                        <b-img
                          :src="form.videoBeforeLive.logo"
                          fluid
                          :alt="form.videoBeforeLive.title"
                        ></b-img>
                      </figure>
                      <h5>{{ form.videoBeforeLive.title }}</h5>
                    </div>
                  </div>
                  <div class="mb-4">
                    <input
                      type="text"
                      v-model="form.conf.video"
                      class="form-control"
                      required
                      hidden
                    />
                    <div
                      class="video-picker-wrapper"
                      v-if="
                        form.conf.type === 'Video' &&
                          initInfinitScrollVideos &&
                          isBeforeLiveVideoPickerVisible
                      "
                    >
                      <div class="search-wrapper position-relative">
                        <input
                          :placeholder="
                            $t(
                              'form_live.tabs.frontOffice.configuration.personalized.video.description',
                            )
                          "
                          type="text"
                          class="form-control mb-15"
                          @keyup.enter="searchVideo"
                          v-model="searchVideoKeyword"
                        />
                        <b-button
                          size="sm"
                          @click="searchVideo"
                          variant="light"
                          class="inline-submit-btn"
                        >
                          <font-awesome-icon icon="search"></font-awesome-icon>
                        </b-button>
                      </div>
                      <div class="video-slides-wrapper">
                        <VuePerfectScrollbar
                          ref="ps"
                          class="scroll-area"
                          @ps-y-reach-end="handlePageChanged"
                        >
                          <b-row>
                            <b-col
                              lg="2"
                              md="3"
                              sm="4"
                              class="slide-wrapper"
                              v-for="(slide, index) in slidesChips"
                              :key="slide.id"
                            >
                              <div class="mb-3">
                                <figure>
                                  <div
                                    class="video-overlay"
                                    :class="{ in: slide.id === form.conf.video }"
                                  >
                                    <button
                                      class="btn"
                                      @click="selectVideo(slide)"
                                      :class="
                                        slide.id === form.conf.video
                                          ? 'btn-light'
                                          : 'btn-outline-light'
                                      "
                                    >
                                      {{ $t('parameters.select.selectOption') }}
                                    </button>
                                  </div>
                                  <b-img :src="slide.thumbnail" fluid :alt="slide.title"></b-img>
                                </figure>
                                <div
                                  class="video-name"
                                  :class="{ selected: slide.id === form.conf.video }"
                                  :title="slide.title"
                                >
                                  {{ slide.title }}
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                          <div v-if="isLoading('videos')">
                            <div class="sk-circle">
                              <div class="sk-circle1 sk-child"></div>
                              <div class="sk-circle2 sk-child"></div>
                              <div class="sk-circle3 sk-child"></div>
                              <div class="sk-circle4 sk-child"></div>
                              <div class="sk-circle5 sk-child"></div>
                              <div class="sk-circle6 sk-child"></div>
                              <div class="sk-circle7 sk-child"></div>
                              <div class="sk-circle8 sk-child"></div>
                              <div class="sk-circle9 sk-child"></div>
                              <div class="sk-circle10 sk-child"></div>
                              <div class="sk-circle11 sk-child"></div>
                              <div class="sk-circle12 sk-child"></div>
                            </div>
                          </div>
                          <h5
                            v-if="isEndReached('videos') && slidesChips.length === 0"
                            class="c-grey-700 font-weight-bolder m-3 text-center"
                          >
                            Pas de vidéos
                          </h5>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                    <div v-if="!$v.form.conf.video.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.pick_video') }}
                    </div>
                  </div>
                </div>
                <!---- radio button image--->
                <div class="form-group" v-has-permission="'lives_conf_image_option'" has-permission="lives_conf_image_option">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Image"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.image')
                    }}</b-form-radio
                  >
                </div>
                <b-row v-show="form.conf.type === 'Image'">
                  <b-col md="4" sm="12">
                    <b-form-group
                      :description="$t('form_live.tabs.general.form.description_image')"
                      label-for="before-live-thumbnail"
                    >
                      <thumbnail-cropper
                        :crop-img="form.conf.image"
                        @thumbnailUpdated="handleBeforeLivePosterUpdated"
                      ></thumbnail-cropper>

                    </b-form-group>
                      <div>
                      <b-form-checkbox v-model="checked" name="check-button" switch>
                       Switch Checkbox <b>(Checked: {{ checkedSwitch }})</b>
                      </b-form-checkbox>
                   </div>
                  </b-col>
                  <b-col md="8" sm="12">
                    <div class="form-group">
                      <label for="before-live-image-description">{{
                        $t('form_live.tabs.frontOffice.configuration.personalized.text_before_live')
                      }}</label>
                      <textarea
                        v-model="form.conf.imageText"
                        class="form-control"
                        id="before-live-image-description"
                        :placeholder="
                          $t('form_live.tabs.frontOffice.configuration.personalized.text')
                        "
                        rows="5"
                      ></textarea>
                    </div>
                  </b-col>
                </b-row>
                <!---- radio button counter--->
                <div class="form-group" v-has-permission="'lives_conf_counter_option'" has-permission="lives_conf_counter_option">
                  <b-form-radio
                    v-model="form.conf.type"
                    value="Counter"
                    >{{
                      $t('form_live.tabs.frontOffice.configuration.personalized.countdown')
                    }}</b-form-radio
                  >
                </div>
                <!---- radio button station encoder--->
               
              </div>
            </b-tab>
              <b-tab has-permission="lives_conf_program" v-if="this.isPermission.lives_conf_program || this.isSuperAdmin" >
              <template slot="title">
               <div>                  
                  <font-awesome-icon icon="users" />
                </div>
                <div class="d-none d-md-block ml-2" has-permission="lives_conf_program" >{{$t('form_live.tabs.Program.new_title')}}</div>
              </template>
              <div class="form-group">
                <label for="LiveProgram" class="primary">{{
                  $t('form_live.tabs.Program.LiveProgram')
                }}</label>

                <textarea
                  v-model="form.live_program"
                  class="form-control"
                  style="width: 45%"
                  id="LiveProgram"
                  :placeholder="$t('form_live.tabs.Program.LiveProgramDescription')"
                  rows="3"
                ></textarea>
              </div>
              <b-row class="mt-5">
                <b-col md="6" sm="12">
                  <div style="width: 40%" has-permission="lives_conf_add_participant_limit" v-if="this.isPermission.lives_conf_add_participant_limit || this.isSuperAdmin">
                    <b-row class="d-flex">
                      <span>{{ $t('form_live.tabs.Program.ParticpantsLimit') }} </span>
                      <b-form-checkbox
                        v-model="checkedLimit"
                        name="check-button"
                        switch
                        class="ml-2"
                      >
                      </b-form-checkbox>
                    </b-row>

                    <b-row v-if="checkedLimit">
                      <b-col cols="12">
                        <label
                          for="nameIntervernant"
                          class="required primary"
                          style="font-size: 12px; color: gray"
                          >{{ $t('form_live.tabs.Program.MaxParticipantsDistance') }}</label
                        >
                        <b-form-input
                          type="number"
                          min="0"
                          v-model.number="form.max_online_guests"
                          id="inline-form-input-MaxParticipantsDistance"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          :placeholder="$t('form_live.tabs.Program.MaxParticipantsDistance')"
                          @keydown="portKeydown($event)"
                        ></b-form-input> </b-col></b-row
                    ><b-row class="mt-2" v-if="checkedLimit"
                      ><b-col cols="12">
                        <label
                          for="nameIntervernant"
                          class="required primary"
                          style="font-size: 12px; color: gray"
                          >{{ $t('form_live.tabs.Program.MaxInvited') }}</label
                        >
                        <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                          <b-form-input
                            type="number"
                             min="0"
                            v-model.number="form.max_onsite_guests"
                            @keydown="portKeydown($event)"
                            id="inline-form-input-MaxInvited"
                            :placeholder="$t('form_live.tabs.Program.MaxInvited')"
                          ></b-form-input> </b-input-group></b-col
                    ></b-row>
                  </div>
                </b-col>
                <b-col md="6" sm="12">
                  <div class="form-group">
                    <div v-if="!$v.form.description.required" class="invalid-feedback">
                      {{ $t('form_live.tabs.required_message') }}
                    </div>
                    <div class="d-flex">
                      <label for="Participants" class="primary">{{
                        $t('form_live.tabs.Program.Intervenants')
                      }}</label>
                      <b-form-checkbox v-model="checked" name="check-button" class="ml-2" switch>
                      </b-form-checkbox>
                    </div>
                    <b-button v-if="checked" id="show-btn" @click="showModal" class="mt-2">
                      {{ $t('form_live.tabs.Program.AddParticipant') }}
                    </b-button>
                  </div>
                  <b-list-group class="mb-2">
                    <b-list-group-item
                      v-for="(intervenant, index) in intervenants"
                      :key="index"
                      class="d-flex justify-content-between"
                      style="
                      margin-bottom: 12px;
                    "
                      >
                      <img
                        style="width: 75px;
                        border-radius: 50%;
                        "
                        :src="cleanedAvatarUrl(intervenant.avatar)"
                        v-if="intervenant.avatar.length > 1"
                      />
                      <b-avatar
                        variant="primary"
                        text="BV"
                        style="
                          width: 85px;
                          background-color: #007bff;
                          border-radius: 50%;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          font-size: 26px;
                          padding: 15px;
                          font-weight: bold;
                          color: white;
                        "
                        v-else
                        >{{ intervenant.name[0].toUpperCase()
                        }}{{ intervenant.lastName[0].toUpperCase() }}</b-avatar
                      >
                      <div style="width: 85%" class="intervenant">
                        <div class="d-flex w-100 justify-content-between">
                          <h5 class="mb-1">{{ intervenant.name }} {{ intervenant.lastName }}</h5>

                        </div>
                        <div class="d-flex w-100 justify-content-between">
                          <small>{{ intervenant.mail }}</small>

                        </div>
                      </div>
                      <div class="speaker-btns">
                            <b-button @click="deleteInter(index)" variant="light" pill >
                              <font-awesome-icon icon="trash" />
                             </b-button>
                             <b-button @click="openModelForUpdate(index)" variant="light" pill >
                              <font-awesome-icon icon="edit"  />
                            </b-button>

                          </div>
                    </b-list-group-item>
                  </b-list-group>
                  <b-modal
                    ref="my-modal"
                    hide-footer
                    :title="update || updateModal ? $t('form_live.tabs.Program.editParticipant') : $t('form_live.tabs.Program.AddParticipant')"
                    @hidden="closeModel"
                  >
                    <b-form ref="formIntervenant">
                      <label for="LiveProgram" class="required primary">{{
                        $t('form_live.tabs.Program.Photo')
                      }}</label>

                    <div class="Image-upload-container">
  <div class="image-container" @click="inputFile">
    <b-form-file
      id="file-default"
      v-model="file"
      hidden
      ref="File"
      accept="image/*"
      @change="changeInput"
    ></b-form-file>
    <div v-if="!url && !showDelete"  class="upload-button">
 <span>
          <img :src="uploadImage" alt="upload Icon" >
        </span>
      <span class="clickable-text">{{ $t('form_live.tabs.Program.Cliquez') }}</span>
    </div>
    <font-awesome-icon icon="spinner" spin v-if="PendingUpload" class="loading-icon" />
    <img v-if="url" :src="url" alt="Downloaded Image" class="uploaded-image" />
  </div>

  <div class="image-info">
    <font-awesome-icon
      v-if="showDelete"
      @click="deleteImageIntervenant"
      icon="trash"
      class="trash-icon"
    />
  </div>
</div>
                      <b-row>
                        <b-col cols="6">
                          <label for="nameIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Nom')
                          }}
                          <span class="required-star">*</span>
                        </label>
                          <b-form-input
                            v-model="form.nom"
                            id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Nom')"
                            required
                          ></b-form-input> </b-col
                        ><b-col cols="6">
                          <label for="lastnameIntervernant"
                          class="required primary">{{
                            $t('form_live.tabs.Program.Prenom')
                          }}
                         <span class="required-star">*</span>
                        </label>
                          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input
                              v-model="form.lastName"
                              id="inline-form-input-username"
                              :placeholder="$t('form_live.tabs.Program.Prenom')"
                              required
                            ></b-form-input> </b-input-group></b-col
                      ></b-row>
                      <b-row class="mt-2">
                        <b-col cols="6">
                          <label for="fonctionIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Fonction')
                          }}</label>
                          <b-form-input
                            v-model="form.fonction"
                            id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Fonction')"
                          ></b-form-input> </b-col
                        ><b-col cols="6">
                          <label for="StructureIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Structure')
                          }}</label>
                          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input
                              v-model="form.structure"
                              id="inline-form-input-username"
                              :placeholder="$t('form_live.tabs.Program.Structure')"
                            ></b-form-input> </b-input-group></b-col
                      ></b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <label for="roleIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Role')
                          }}</label>
                          <b-form-input
                            v-model="form.role"
                            id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Role')"
                          ></b-form-input> </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <label for="descriptionIntervernant" class="required primary">{{
                            $t('form_live.tabs.Program.Description')
                          }}</label>
                        <textarea
                            v-model="form.Description"
                            id="inline-form-input-name"
                            class="form-control"
                            style="width: 100%"
                            rows="3"
                            :placeholder="$t('form_live.tabs.Program.Description')"
                          ></textarea>
                          </b-col
                        >
                      </b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <label for="EmailIntervenant" class="required primary">{{
                            $t('form_live.tabs.Program.Email')
                          }}</label>
                          <b-form-input
                            v-model="form.mail"
                            id="inline-form-input-email"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :placeholder="$t('form_live.tabs.Program.Email')"
                          ></b-form-input
                        >
                        <div v-if="form.mail && emailError" class="error-message">{{ emailError }}</div>
                      </b-col>
                      </b-row>
                      <br />
                      <b-divider></b-divider>
                      <b-button variant="light" type="button" class="mr-2" @click="closeModel">{{
                        $t('button.cancel')
                      }}</b-button>
                       <b-button
                        v-if="updateModal"
                        variant="primary"
                        @mousedown="ManageIntervenant"
                        class="outlined-black"
                        color="gray"
                        :disabled="PendingUpload || $v.form.$error"
                        >{{ $t('button.edit') }}</b-button
                      >
                      <b-button
                        v-if="!update && !updateModal"
                        variant="primary"
                        @mousedown="ManageIntervenant"
                        class="outlined-black"
                        color="gray"
                         :disabled="PendingUpload || $v.form.$error"
                         >{{ $t('button.save') }}</b-button
                      >
                      <b-button
                        v-if="update"
                        variant="primary"
                        class="outlined-black"
                        @mousedown="ManageIntervenant"
                      :disabled="PendingUpload || $v.form.$error"
                        >{{ $t('button.edit') }}</b-button
                      ></b-form
                    >
                  </b-modal>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab has-permission="lives_skin"
       v-if="this.isPermission.lives_skin || this.isSuperAdmin">

  <template slot="title">
    <div><font-awesome-icon icon="palette" /></div>
    <div class="d-none d-md-block ml-2">{{ $t('form_live.tabs.SkinModel.new_title') }}</div>
  </template>

  <!-- SELECT EXISTING SKIN -->
  <div class="form-group mt-3">
    <label class="primary">{{ $t('form_live.tabs.SkinModel.selectOrCreate') }}</label>

    <b-form-select
      v-model="skinForm.selectedSkin"
      :options="skinOptions"
      class="w-50"
      @change="onSelectSkin"
    />

    <small class="text-muted d-block mt-1">
      {{ $t('form_live.tabs.SkinModel.explanation') }}
    </small>
  </div>

  <hr>
  <!-- <div v-if="skinConfirmed" class="applied-skin-message">
    {{ $t('form_live.tabs.SkinModel.selectedSkin') }} "{{ skinConfirmed.name }}"
  </div> -->
  <!-- NEW SKIN -->
  <div v-if="skinForm.selectedSkin">

    <h5 class="mt-4 mb-3" v-if="!skinIsEditMode">{{ $t('form_live.tabs.SkinModel.newSkin') }}</h5>
  
    <!-- COLORS (compact, fixed width) -->
    <div class="row mt-2">

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.primaryColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.primary_color">
      </div>

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.secondaryColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.secondary_color">
      </div>

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.primaryTextColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.text_primary_color">
      </div>

      <div class="col-md-3 col-6 mb-3">
        <label>{{ $t('form_live.tabs.SkinModel.secondaryTextColor') }}</label>
        <input type="color"
               class="form-control p-1"
               style="height: 38px;"
               v-model="skinForm.skin.text_secondary_color">
      </div>

    </div>
    <div class="row">     <!-- TITLES -->
    <!-- <div class="form-group col-6">
      <label>{{ $t('form_live.tabs.SkinModel.liveTitle') }}</label>
      <input type="text" class="form-control" v-model="skinForm.skin.title">
    </div> -->

    <!-- LOGO -->
    <div class="form-group col-6">
  <div class="custom-file-wrapper">
    <button
      type="button"
      class="btn-upload"
      :disabled="uploading.logo"
      @click="$refs.logoInput.click()"
    >
      <b-spinner small v-if="uploading.logo" class="mr-2" />
      {{ $t('form_live.tabs.SkinModel.logo') }}
    </button>

    <input
      type="file"
      ref="logoInput"
      accept="image/*"
      @change="e => uploadLogo(e, 'logo')"
      class="hidden-file-input"
    />
  </div>

  <div v-if="skinForm.skin.logoPreview" class="mt-2">
  <div class="image-preview-wrapper position-relative d-inline-block">
    <img
      :src="skinForm.skin.logoPreview"
      alt="Logo preview"
      class="logo-preview"
      :class="{ 'is-loading': uploading.logo }"
    />

    <div
      v-if="uploading.logo"
      class="preview-overlay"
    >
      <b-spinner />
    </div>
  </div>
</div>
</div>

</div>


    <hr>

    <!-- BEFORE / AFTER LIVE (COMPACT 2-COLUMNS) -->
    <div class="row mt-4">

      <!-- BEFORE LIVE -->
      <div class="col-md-6 pr-md-4 mb-4">
        <h6>{{ $t('form_live.tabs.SkinModel.beforeLiveInfo') }}</h6>

        <div class="form-group mt-2">
          <label>{{ $t('form_live.tabs.SkinModel.infoText') }}</label>
          <textarea rows="2"
                    class="form-control w-100"             

                    v-model="skinForm.skin.before.info_text"></textarea>
        </div>

        <div class="d-flex mb-2">
          <div class="mr-4">
            <label>{{ $t('form_live.tabs.SkinModel.showDate') }}</label>
            <b-form-checkbox         
            v-model="skinForm.skin.before.show_date"></b-form-checkbox>
          </div>

          <div>
            <label>{{ $t('form_live.tabs.SkinModel.showHour') }}</label>
            <b-form-checkbox    
             v-model="skinForm.skin.before.show_hour"></b-form-checkbox>
          </div>
        </div>
        <div class="form-group">
  <div class="custom-file-wrapper">
    <button
      type="button"
      class="btn-upload"
      :disabled="uploading.before"
      @click="$refs.beforeInput.click()"
    >
      <b-spinner small v-if="uploading.before" class="mr-2" />
      {{ $t('form_live.tabs.SkinModel.backgroundImage') }}
    </button>

    <input
      type="file"
      ref="beforeInput"
      accept="image/*"
      @change="e => uploadBackground(e, 'before')"
      class="hidden-file-input"
    />
  </div>

  <div
    v-if="skinForm.skin.before.backgroundPreview"
    class="mt-2 position-relative"
  >
  <div class="image-preview-wrapper position-relative d-inline-block">

    <img
      :src="skinForm.skin.before.backgroundPreview"
      class="bg-preview"
      :class="{ 'is-loading': uploading.before }"
      alt="Before background"
    />

    <div v-if="uploading.before" class="preview-overlay">
      <b-spinner />
    </div>
  </div>
</div>
</div>



        <b-form-checkbox            
        v-model="skinForm.skin.before.background_blur">
          {{ $t('form_live.tabs.SkinModel.blurred') }}
        </b-form-checkbox>
      </div>


      <!-- AFTER LIVE -->
      <div class="col-md-6 pl-md-4">
        <h6>{{ $t('form_live.tabs.SkinModel.afterLiveInfo') }}</h6>

        <div class="form-group mt-2">
          <label>{{ $t('form_live.tabs.SkinModel.infoText') }}</label>
          <textarea rows="2"
                    class="form-control w-100"
                  

                    v-model="skinForm.skin.after.info_text"></textarea>
        </div>
        <div class="form-group">
  <div class="custom-file-wrapper">
    <button
      type="button"
      class="btn-upload"
      :disabled=" uploading.after"
      @click="$refs.afterInput.click()"
    >
      <b-spinner small v-if="uploading.after" class="mr-2" />
      {{ $t('form_live.tabs.SkinModel.backgroundImage') }}
    </button>

    <input
      type="file"
      ref="afterInput"
      accept="image/*"
      @change="e => uploadBackground(e, 'after')"
      class="hidden-file-input"
    />
  </div>

  <div
    v-if="skinForm.skin.after.backgroundPreview"
    class="mt-2 position-relative"
  >
  <div class="image-preview-wrapper position-relative d-inline-block">

    <img
      :src="skinForm.skin.after.backgroundPreview"
      class="bg-preview"
      :class="{ 'is-loading': uploading.after }"
      alt="After background"
    />

    <div v-if="uploading.after" class="preview-overlay">
      <b-spinner />
    </div>
  </div>
  </div>
</div>



        <b-form-checkbox            
        v-model="skinForm.skin.after.background_blur">
          {{ $t('form_live.tabs.SkinModel.blurred') }}
        </b-form-checkbox>
      </div>

    </div>

    <!-- NAME + APPLY BUTTON -->
     <div class="mt-4 row d-flex justify-content-center align-items-center">
      <div  class="col-md-8 applied-skin-message">  
        <span v-show="skinIsEditMode">
      {{ $t('form_live.tabs.SkinModel.editNote') }}
    </span>
      </div> 

      <div class="col-md-4 d-flex justify-content-end align-items-center">

<input type="text"
       class="form-control mr-2"
       style="width: 220px"
       v-model="skinForm.skin.name"
       :placeholder="$t('form_live.tabs.SkinModel.skinName')">

<!-- <b-button v-if="!skinIsEditMode" variant="primary" @click="saveAndApplySkin">
  {{ $t('form_live.tabs.SkinModel.addAndApply') }}
</b-button>
<b-button v-if="skinIsEditMode"
    variant="primary"
    @click="saveAndApplySkin">
{{ $t('form_live.tabs.SkinModel.applySkin') }}
</b-button> -->

</div>
     </div>


  </div>
</b-tab>
          </b-tabs>

          <div class="buttons-wrapper d-none d-lg-block">
            <b-button variant="light" type="button" class="mr-2" @click="goToListLive">{{
              $t('button.cancel')
            }}</b-button>


            <b-button
              variant="primary"
              type="submit"
              has-permission="lives_post_edit"
               @mousedown="submitForm"
              :disabled="$v.form.$error  ||btnDisabled || (!confirmClicked && imageIsPicked) || openTimeModal"
              >{{ $t('button.save') }}</b-button
            >
          </div>
        </div>
      </b-form>
    </b-container>
    <b-modal
      :title="$t('startDirect.title')"
      id="modal-start-direct"
      ref="modal-start-direct"
      :header-bg-variant="headerBgVariant"
      hide-footer
      size="lg"
      @hide="redirectTo()"
    >

      <div class="subTitle"> {{ $t('startDirect.subtitle') }} </div>

      <div class="action-start-direct">
        <b-button
          @click="redirectTo(true)"
          variant="primary"
          type="button"
          class="mr-2"
        >{{ $t('startDirect.btn.YES') }}</b-button>
        <b-button variant="light" type="button"  @click="redirectToLives()">{{ $t('startDirect.btn.NO') }}</b-button>

      </div>
      <div class="action-choix">
        <div class="form-group">
          <b-form-checkbox
            v-model="status"
          >
            {{ $t('startDirect.choix') }}
          </b-form-checkbox>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker';
import axios from 'axios';
import VueClockPicker from '@pencilpix/vue2-clock-picker';
import InputTag from 'vue-input-tag';
import vue2Dropzone from 'vue2-dropzone';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable';

import { required, requiredIf } from 'vuelidate/lib/validators';
import { Carousel, Slide } from 'vue-carousel';
import { mapGetters, mapActions, mapState } from 'vuex';
import uploadImage from "./../assets/icons/Upload.svg"
import ThumbnailCropper from '@/components/components/ThumbnailCropper';
import QuestionForm from '@/components/components/QuestionForm';
import UploadMixin from '../mixins/UploadMixin.js';
import UtilsMixin from '../mixins/UtilsMixin.js';
import HasPermission from '../directives/HasPermission.js';
import YoutubeLinks from './YoutubeLinks.vue';
import common from '../helpers/common';
import {
  getLiveDocumentsHeaders,
  getSignedLiveDocumentsUrl,
  getLiveDocumentId,
  getLiveDocumentName,
  getLiveDocumentUrl,
  isLiveDocumentPublic,
  normalizeLiveDocumentsResponse,
} from '../helpers/live-documents';
import NProgress from 'nprogress';
import InfiniteLoading from 'vue-infinite-loading';
const XLSX = require('xlsx/dist/xlsx.full.min.js');

import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
var moment = require('moment');

const createPollOptionDraft = option => ({
  id: option && option.id ? option.id : null,
  poll_option: option && option.poll_option ? option.poll_option : '',
  dirty: false,
});

const createPollDraft = poll => {
  const options =
    poll && Array.isArray(poll.options) && poll.options.length > 0
      ? poll.options.map(createPollOptionDraft)
      : [createPollOptionDraft(), createPollOptionDraft()];

  return {
    id: poll && poll.id ? poll.id : null,
    question: poll && poll.question ? poll.question : '',
    isPublished: !!(poll && poll.isPublished),
    options,
    dirty: false,
  };
};


export default {
  name: 'LiveForm',
  mixins: [UploadMixin, UtilsMixin],
  components: {
    Datepicker,
    YoutubeLinks,
    VueClockPicker,
    InputTag,
    QuestionForm,
    VuePerfectScrollbar,
    Carousel,
    Slide,
    Multiselect,
    draggable,
    ThumbnailCropper,
    vueDropzone: vue2Dropzone,
    InfiniteLoading,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  directives: {
    HasPermission,
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      startDate: {
        required,
        // minValue: value => {
        //   const today = new Date();
        //   let yesterday = new Date();
        //   yesterday.setDate(today.getDate() - 1);
        //   return new Date(value) > yesterday;
        // },
      },
      startTime: {
        required,
        // minValue(value) {
        //   if (moment().isSame(this.form.startDate, 'day')) {
        //     const beginningTime = moment(this.form.startTime, 'HH:mm');
        //     return moment().isBefore(beginningTime);
        //   }
        //   return true;
        // },
      },
      endTime: {
        required,
        minValue(value) {
          const endTime = moment(value, 'HH:mm', true);
          const startTime = moment(this.form.startTime, 'HH:mm', true);
          return endTime > startTime;
        },
      },
      conf: {
        message: {
          required: requiredIf(function(nestedModel) {
            return this.form.conf.type === 'Message';
          }),
        },
        video: {
          required: requiredIf(function(nestedModel) {
            return this.form.conf.type === 'Video';
          }),
        },
      },
      survey: {
        required: requiredIf(function(nestedModel) {
          return this.form.foSondage;
        }),
      },
      stationId: {
        required: requiredIf(function(nestedModel) {
          return this.form.isAuto;
        }),
        minValue(value) {
    if (!this.form.isAuto) return true; // ⬅ ignore validation
    return value > 0;
  },
      },
    },
  },
	  data() {
	    return {
	      sourceTypeTouched: false,
        bulkEmailListenerCleanup: [],
	      localParticipantOptions:[],
	      uploading: {
	      logo: false,
	      before: false,
      after: false,
    },
    showFilesPanel: false,
	     sections: {
          consent:true,
	        typeLive:true,
	        connexionEmpreinte:true,
	        social_media:true,
	        diffusion: true,
	        sources:true,
        options: true,
        languages: true,
        socialMedia: true,
        contributors: true,
        richMedia: true,
        video:true,
        access_direct:true,
        program:true,
        questions:true,
        sous_titrage:true,
	      presentation:true,
        polls:true,
        tools:true,
        LiveProgram:true,
        general: true,
        skin:true,
        chapitres:true
      },
      TypesSources:[],
      TypesToShow:[],
      skinIsEditMode: false,
      currentSkin:null,
      skinConfirmed:null,
      skinOptions: [],
    skinForm: {
      selectedSkin: null,

      skin: {
        primary_color: "#00a6d9",
        secondary_color: "#ecf6fa",
        text_primary_color: "#ffffff",
        text_secondary_color: "#000000",
        title: "",
        logo: null,
        before: {
      info_text: "",
      show_date: false,
      show_hour: false,
      background: null,
      background_blur: false
    },
    after: {
      info_text: "",
      show_date: false,
      show_hour: false,
      background: null,
      background_blur: false
    }

      }
    }
,
      btnDisabled:false,
      PendingUpload:false,
      uploadImage:uploadImage,
       errorOccurred:false,
      errorOccurredInUpdate:false,
       errorOccurredInAdd:false,
      uploadError:false,
      EditOption:false,
      moderators : [],
      languages: [],
      countries: [],
      languagesOptions: [
    { label: 'fl', lang: i18n.t('form_live.tabs.advanced.diffusion.language.FL1') },
    { label: 'en', lang: i18n.t('form_live.tabs.advanced.diffusion.language.Anglais') },
    { label: 'sp', lang: i18n.t('form_live.tabs.advanced.diffusion.language.ES') },
    { label: 'fr', lang: i18n.t('form_live.tabs.advanced.diffusion.language.Français') },
    { label: 'ru', lang: i18n.t('form_live.tabs.advanced.diffusion.language.RU')},
    { label: 'ar', lang: i18n.t('form_live.tabs.advanced.diffusion.language.AR') },
    { label: 'zh', lang: i18n.t('form_live.tabs.advanced.diffusion.language.ZH') },
      ],
  
      manualStations: [],
      automaticStations: [],
      loadingManualStations: false,
      loadingAutomaticStations: false,
      countriesOptions: [],
      isLoadingCountries: false,
      openTimeModal:false,
      update: false,
      checked: false,
      checkedSwitch: false,
      headerBgVariant: 'custom-secondary',
      status: false,
      currentLive:{},
      imgSrc: '',
      cropImg: '',
      isEditingThumbnail:false,
      imageIsPicked: false,
      confirmClicked: false,
      form: {
        sourceTypeId:2,
        isYoutube:false,
        selectedManualStation: null,
        stationId: null,
        youtubeLinks:[],
        isRecorded: true,
        autoPublish: true,
        nom: '',
        lastName: '',
        fonction: '',
        structure: '',
        mail: '',
        live_plan:true,
        role:'',
        Description:'',
        max_online_guests: null,
        max_onsite_guests: null,
        title: '',
        description: '',
        types:null,
        startDate:  moment().format('YYYY-MM-DD'),
        startTime: moment().format('HH:mm'),
        endTime: moment()
          .add(1, 'hours')
          .format('HH:mm'),
        tags: [],
        isCdn: true,
        screenShare: false,
        externalHls:false,
        linkHls:"",
        webinar: true,
        isPearl: false,
        screenType: 'pip',
        chapters: [],
        questions: [],
        files: [],
        slides: [],
        defaultConf: true,
        conf: {
          type: 'Counter',
        },
        diffusion: 'webinar',
        isAuto: false,
        videoPortIndex: 0,
        audioPortIndex: 0,
        protocolType: 'RTMP',
        videoBeforeLive: null,
        connexionType:"auto",
        accessType:"public",
        thumbnail:'',
        thumbnailPath:'',
        emailError:null,
        encoderType:"manual",
        contributors:[],
        participants:[],
        record_with_permission: false,
        foFilesShare: false,
        doc_public: false,
        doc_publish_default: false,
        doc_public_mail: false,
        doc_private: false,
        autoSip: false,


      },
       protocolOptions: [
       { value: 'RTMP', text: 'RTMP' },
        { value: 'SRT', text: 'SRT' }
        ],
      accessWebinar:"",
      connexionWebinar:"",
      searchVideoKeyword: '',
      submitButtonClicked: false,
      requiredMessage: i18n.t('form_live.tabs.required_message'),
      screenTypeOptions: [
        { value: 'pip', text: 'Picture in Picture PIP' },
        { value: 'sbs', text: 'Side by Side' },
      ],
      newChapter: '',
      currentPageQuestion: 1,
      addQuestionMode: false,
      showAllSlides: false,
      joinFile: false,
      socialNetwork: false,
      password: false,
      //languages: lang,
      initialLocaleCode: 'fr',
      isEditMode: false,
      slideIndex: -1,
      showCarousel: false,
      ready: false,
      pastDates: {},
      isBeforeLiveVideoPickerVisible: true,
      initInfinitScrollVideos: false,
      chapterTitle: '',
      shortcuts: [
        {
          text: 'Today',
          onClick: () => {
            this.time3 = [new Date(), new Date()];
          },
        },
      ],
      permissions:[
        {name:"webinar",permission:"lives_webinar_no_api"},
        {name:"isPearl",permission:"lives_encoder_no_api"},
        {name:"screenShare", permission:"lives_screen_share_no_api"},
      ],
      disabledConfigFO: false,
      showErrorMessage: false,
      MaxParticipantsDistance: '',
      MaxInvited: '',
      file: null,
      url:null,
      intervenants: [],
      intervenantsToUpdate: [],
      intervenantsToAdd: [],
      checkedLimit: false,
      idUpdate: '',
      showDelete: false,
      intervenantsTodelete: [],
      forUpdate: false,
      updateModal:false,
      indexToupdate: '',
      updateIdParticipant:'',
      udpateInIntervenants:'',
      checkedLimit: true,
      livePolls: [],
      activePollIndex: 0,
      deletedPollIds: [],
      deletedPollOptionIds: [],
      pollsLoading: false,
      pollsSyncing: false,
      pollsLoaded: false,
      pendingPollDelete: null,
      presentationSlides: [],
      pendingPresentationFiles: [],
      presentationLoading: false,
      presentationUploading: false,
      presentationDeletingId: null,
      liveDocuments: [],
      pendingLiveDocuments: [],
      documentsLoading: false,
      documentsUploading: false,
      documentsDeletingId: null,
    };
  },
  computed: {
    ...mapGetters({
      getWebtvUsers: 'lives/getWebtvUsers',
      live: 'lives/getSelected',
      contributorsOptions: 'lives/getWebtvUsers',
      channelsOptions: 'lives/getChannels',
      typesOptions: 'lives/getTypes',
      surveyOptions: 'form/getSurveys',
      slidesChips: 'form/getVideos',
      isEndReached: 'form/getEndReached',
      isLoading: 'form/getLoading',
      hasPermission: 'common/hasPermission',
      getDiffusion: 'common/getDiffusion',
      getDiffusionObject: 'lives/getDiffusionObject',
      defaultThumbnail: 'common/getDefaultThumbnail',
      linkHls:'lives/getHlsValue',
      isPermission: 'common/getPermission',
      isSuperAdmin: 'common/getSuperAdmin',
      lang:'lives/getCurrentLang',
      liveSkinsOptions:'lives/getLiveSkins',
      getUserId: 'common/getUserId',

    }),
      isUnescoClient() {
      // return window.process.env.CLIENT_NAME === 'test';
      return true;
    },
    isEmpreinteClient(){
      return ['empreinte','cnam','gers','test'].includes(window.process.env.CLIENT_NAME);
    },
    isEmpreintePollClient() {
      return window.process.env.CLIENT_NAME === 'empreinte';
    },
    cleanedAvatarUrl(){
      return (avatarUrl) => {
        const parts = avatarUrl.split("https://");
        const correctUrl = "https://" + parts[parts.length - 1];
        return correctUrl;
      };
    },
    filteredTypesToShow() {
    return this.TypesToShow.filter(option => 
      this.hasPermission(option.permission)
    );
  },
    getThumbnail(){
      return process.env.BASE_HREF+'liste-lives/static/vignette/'+this.defaultThumbnail
    },
    getPermissions(){
      let permissionsArray=[]
      this.permissions.forEach((p)=>{
        if(this.hasPermission(p.permission)){
          permissionsArray.push(p);
        }
      })
      return permissionsArray
    },
      getDifferentDiffusionPermission(){
          let permissionsArray = this.getPermissions;
          if(permissionsArray.length> 0 && permissionsArray.length===1){
              this.getDefaultDiffusion()
          }
      },
      getDiffusionPermission(){
          if(this.currentLive.isPearl){
              return "lives_pearl_diffuser_no_api"
          }else{
              return "lives_diffuser_no_api"
          }
      },
    isChapterEditMode() {
      return this.form.chapters.some(c => c.isEditMode);
    },
    isQuestionEditMode() {
      return this.form.questions.some(c => c.isEditMode);
    },
        activePoll() {
      return this.livePolls[this.activePollIndex] || null;
    },
    canAddPoll() {
      if (this.livePolls.length === 0) {
        return true;
      }

      const lastPoll = this.livePolls[this.livePolls.length - 1];
      return !this.getPollValidationError(lastPoll);
    },
    canManagePresentation() {
      return true;
    },
    presentationItems() {
      return this.$route.params.id ? this.presentationSlides : this.pendingPresentationFiles;
    },
    managedLiveDocuments() {
      return this.$route.params.id ? this.liveDocuments : this.pendingLiveDocuments;
    },
    hasAnyPublishedLiveDocuments() {
      return this.managedLiveDocuments.some(
        document => document.public || this.isManagedDocumentPublic(document),
      );
    },
    getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    },
    liveTypesOptions() {
  const defaultType = {
    id: 0,
    title: i18n.t('form_live.tabs.general.form.type_default'),
  };
  if(this.form.types === null || this.form.types.length===0){
    this.form.types = defaultType;
  }
  let types = this.typesOptions || [];

  types = [defaultType, ...types];

  return types;
},

    themesOptions() {
      return this.mapThemes(this.channelsOptions);
    },

    closeOnOverlay() {
      return true;
    },
     ...mapState({
    confirmationClicked: state => state.confirmation.clicked,
  }),

  },
  watch: {
    '$route.params.id': function() {
      this.fetchPresentationSlides();
      this.fetchLivePolls();
      this.fetchLiveDocuments();
    },
    getWebtvUsers: {
    immediate: true,
    handler(users) {
      const customParticipants = this.localParticipantOptions.filter(option => option.isCustom);
      this.localParticipantOptions = [...users, ...customParticipants];
      this.setupParticipantBulkListener();
    }
  },

    'form.diffusion'(newValue){
      this.getTypesSources(newValue)
    },
    'skinConfirmed'(newV){
      if(newV && newV.id){
        const selected = newV
        this.skinForm.selectedSkin=newV.id
        this.skinIsEditMode=true
  this.currentSkin = selected;
  this.skinForm.skin = {
    primary_color: selected.primaryColor || "#00a6d9",
    secondary_color: selected.secondaryColor || "#ecf6fa",
    text_primary_color: selected.primaryTextColor || "#ffffff",
    text_secondary_color: selected.secondaryTextColor || "#000000",
    name: selected.name || "",


    logo: selected.logo || null,
    logoPreview: selected.logo || null, // <-- set preview URL

    before: {
      info_text: (selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.title) || "",
      show_date: (selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.date) || false,
      show_hour: (selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.duration) || false,
      background: selected.beforeBackground || null,
      backgroundPreview: selected.beforeBackground || null, // <-- set preview URL
      background_blur: selected.bluredBeforeBackground || false
    },

    after: {
      info_text: (selected.afterLiveTextOptions && selected.afterLiveTextOptions.title) || "",
      show_date: (selected.afterLiveTextOptions && selected.afterLiveTextOptions.date) || false,
      show_hour: (selected.afterLiveTextOptions && selected.afterLiveTextOptions.duration) || false,
      background: selected.afterBackground || null,
      backgroundPreview: selected.afterBackground || null, // <-- set preview URL
      background_blur: selected.bluredAfterBackground || false
    }
  };

      }
    },
    liveSkinsOptions: {
      handler(newSkins) {
          this.buildSkinOptions(Array.isArray(newSkins) ? newSkins : []);
          this.selectSkinIfReady();


      },
      immediate: true
    },
    live() {
      this.ready = true;
     // Object.assign(this.form, JSON.parse(JSON.stringify(this.live)));
     const liveData = JSON.parse(JSON.stringify(this.live));
    Object.keys(liveData).forEach(key => {
      this.$set(this.form, key, liveData[key]);
    });
      this.socialNetwork = this.form.foFacebook ||this.form.foYoutube ||this.form.foX ||  this.form.foLinkedin ;
      this.joinFile = this.form.files.length > 0;
      this.form.doc_public = !!this.form.doc_public;
      this.form.doc_publish_default = !!this.form.doc_publish_default;
      this.form.doc_public_mail = !!this.form.doc_public_mail;
      this.form.doc_private = !!this.form.doc_private;
      this.password = !!this.form.pwd;
      this.connexionWebinar = this.form.connexionType;
      this.accessWebinar = this.form.accessType;
      this.isBeforeLiveVideoPickerVisible = !this.form.videoBeforeLive;
      if (
        this.defaultThumbnail &&
        this.defaultThumbnail !== null &&
        this.defaultThumbnail !== '' &&
        this.defaultThumbnail !== undefined
      ) {
        this.getDefaultThumb();
      }
      this.selectSkinIfReady();
   if(this.isEmpreinteClient) {
    if (
       (this.form.questions && this.form.questions.length > 0) ||
       (this.form.slides && this.form.slides.length > 0)
     ) {
       this.form.isRm = true;
     } else {
       this.form.isRm = false;	
     }
    }


    },
    file() {
      if (this.file == '' || this.file == null) {
        this.showDelete = false;
      } else {
        this.showDelete = true;
      }
    },
    'form.mail'(newVal) {
      if (newVal) {
        this.validateEmail(newVal);
      } else {
        this.emailError = null;
      }
    },
    checkedLimit(newVal) {
      if (!newVal) {
        this.resetMaxOnlineGuests();

      }
    },
    'form.isRecorded': function(newVal) {
      if (!newVal) {
        this.form.autoPublish = false;
      }
    },
         },
  methods: {
    getPollRequestConfig() {
      return {
        headers: {
          Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' +process.env.API_TOKEN,
          'Content-Type': 'application/json',
          'client-name': window.process.env.CLIENT_NAME ,
        },
      };
    },
    getPresentationRequestConfig(contentType = 'application/json') {
      const headers = {
        Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' +process.env.API_TOKEN,
        'client-name': window.process.env.CLIENT_NAME || 'test',
      };

      if (contentType) {
        headers['Content-Type'] = contentType;
      }

      return {
        headers,
      };
    },
    normalizePresentationSlidesResponse(payload) {
      const candidates = [
        payload && payload.data,
        payload && payload.data && payload.data.data,
        payload && payload.data && payload.data.documents,
        payload && payload.data && payload.data.slides,
        payload && payload.data && payload.data.data && payload.data.data.documents,
        payload && payload.data && payload.data.data && payload.data.data.slides,
      ];

      for (const candidate of candidates) {
        if (Array.isArray(candidate)) {
          return candidate;
        }
      }

      return [];
    },
    getPresentationTitle(item) {
      return (
        item.doc_name ||
        this.$t('form_live.tabs.advanced.presentation.untitled')
      );
    },
    getPresentationExtension(item) {
      const title = this.getPresentationTitle(item);
      if (!title || title.indexOf('.') === -1) {
        return this.$t('form_live.tabs.advanced.presentation.file');
      }

      return title.split('.').pop().toUpperCase();
    },
    getPresentationFileType(item) {
      const extension = this.getPresentationExtension(item).toLowerCase();

      if (extension === 'pdf') {
        return 'pdf';
      }

      if (extension === 'ppt' || extension === 'pptx') {
        return 'ppt';
      }

      if (extension === 'doc' || extension === 'docx') {
        return 'doc';
      }

      return 'file';
    },
    getPresentationSlidesCount(item) {
      if (Array.isArray(item.slides)) {
        return item.slides.length;
      }

      if (Array.isArray(item.images)) {
        return item.images.length;
      }

      if (typeof item.slidesCount === 'number') {
        return item.slidesCount;
      }

      if (typeof item.slideCount === 'number') {
        return item.slideCount;
      }

      return 0;
    },
    getPresentationPreview(item) {
      if (item.preview) {
        return item.preview;
      }

      if (item.thumbnail) {
        return item.thumbnail;
      }

      if (Array.isArray(item.slides) && item.slides.length > 0) {
        const firstSlide = item.slides[0];
        return firstSlide.url || firstSlide.src || firstSlide.image || firstSlide;
      }

      if (Array.isArray(item.images) && item.images.length > 0) {
        const firstImage = item.images[0];
        return firstImage.url || firstImage.src || firstImage.image || firstImage;
      }

      return '';
    },
    getPresentationSourceUrl(item) {
      return item.url || item.fileUrl || item.sourceUrl || item.documentUrl || '';
    },
    getPresentationDeleteId(item) {
      return (
        item.localId ||
        item.doc_index ||
        item.docId ||
        item.doc_id ||
        item.id ||
        item.documentId ||
        item.fileId ||
        item.key ||
        ''
      );
    },
    triggerPresentationUpload() {
      if (!this.$refs.presentationInput) {
        return;
      }

      this.$refs.presentationInput.click();
    },
    async handlePresentationFileChange(event) {
      const input = event && event.target ? event.target : null;
      const selectedFile = input && input.files && input.files[0] ? input.files[0] : null;

      if (!selectedFile) {
        if (input) {
          input.value = '';
        }
        return;
      }

      if (!this.$route.params.id) {
        this.pendingPresentationFiles.push({
          localId: `pending-presentation-${Date.now()}-${this.pendingPresentationFiles.length}`,
          name: selectedFile.name,
          file: selectedFile,
          isPending: true,
        });
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.presentation.queued_success'),
          'icon-success',
        );
        if (input) {
          input.value = '';
        }
        return;
      }

      const extension = selectedFile.name.includes('.')
        ? selectedFile.name.split('.').pop().toLowerCase()
        : '';

      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('extension', extension);

      this.presentationUploading = true;

      try {
        await axios.post(
          `${window.process.env.API_HOST_LIVE}/live/convert-document/${this.$route.params.id}`,
          formData,
          this.getPresentationRequestConfig(null),
        );

        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.presentation.upload_success'),
          'icon-success',
        );
        await this.fetchPresentationSlides();
      } catch (error) {
        console.log('error while uploading presentation document : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.presentation.upload_error'),
          'icon-warning',
        );
      } finally {
        this.presentationUploading = false;
        if (input) {
          input.value = '';
        }
      }
    },
    async fetchPresentationSlides() {
      if (!this.$route.params.id) {
        this.presentationSlides = [];
        return;
      }

      this.presentationLoading = true;

      try {
        const response = await axios.get(
          `${window.process.env.API_HOST_LIVE}/live/doc-slides/${this.$route.params.id}`,
          this.getPresentationRequestConfig(),
        );
        this.presentationSlides = this.normalizePresentationSlidesResponse(response);
      } catch (error) {
        console.log('error while fetching presentation slides for this live : ', error);
        this.presentationSlides = [];
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.presentation.fetch_error'),
          'icon-warning',
        );
      } finally {
        this.presentationLoading = false;
      }
    },
    async deletePresentation(documentId) {
      if (!documentId) {
        return;
      }

      const pendingIndex = this.pendingPresentationFiles.findIndex(
        item => item.localId === documentId,
      );
      if (pendingIndex > -1) {
        this.pendingPresentationFiles.splice(pendingIndex, 1);
        return;
      }

      this.presentationDeletingId = documentId;

      try {
        const signedUrl = await getSignedLiveDocumentsUrl(`/live/doc-slides/${documentId}`);
        await axios.delete(signedUrl, this.getPresentationRequestConfig());
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.presentation.delete_success'),
          'icon-success',
        );
        await this.fetchPresentationSlides();
      } catch (error) {
        console.log('error while deleting presentation document : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.presentation.delete_error'),
          'icon-warning',
        );
      } finally {
        this.presentationDeletingId = null;
      }
    },
    async uploadPresentationFile(file, liveId) {
      const extension = file.name && file.name.includes('.')
        ? file.name.split('.').pop().toLowerCase()
        : '';
      const formData = new FormData();
      formData.append('file', file);
      formData.append('extension', extension);

      await axios.post(
        `${window.process.env.API_HOST_LIVE}/live/convert-document/${liveId}`,
        formData,
        this.getPresentationRequestConfig(null),
      );
    },
    async uploadPendingPresentations(liveId) {
      if (!liveId || this.pendingPresentationFiles.length === 0) {
        return;
      }

      this.presentationUploading = true;

      try {
        for (const pendingFile of this.pendingPresentationFiles) {
          await this.uploadPresentationFile(pendingFile.file, liveId);
        }

        this.pendingPresentationFiles = [];
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.presentation.upload_success'),
          'icon-success',
        );
        await this.fetchPresentationSlides();
      } catch (error) {
        console.log('error while uploading pending presentation documents : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.presentation.upload_error'),
          'icon-warning',
        );
      } finally {
        this.presentationUploading = false;
      }
    },
    getManagedDocumentName(item) {
      return getLiveDocumentName(item);
    },
    getManagedDocumentExtension(item) {
      const name = this.getManagedDocumentName(item);
      if (!name || name.indexOf('.') === -1) {
        return '';
      }

      return name.split('.').pop().toLowerCase();
    },
    getManagedDocumentIcon(item) {
      const extension = this.getManagedDocumentExtension(item);

      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(extension)) {
        return 'file-image';
      }

      if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
        return 'file-video';
      }

      if (['mp3', 'wav', 'ogg', 'm4a'].includes(extension)) {
        return 'file-audio';
      }

      if (extension === 'pdf') {
        return 'file-pdf';
      }

      if (['doc', 'docx'].includes(extension)) {
        return 'file-word';
      }

      if (['ppt', 'pptx'].includes(extension)) {
        return 'file-powerpoint';
      }

      if (['xls', 'xlsx', 'csv'].includes(extension)) {
        return 'file-excel';
      }

      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
        return 'file-archive';
      }

      return 'file';
    },
    getManagedDocumentIconClass(item) {
      const extension = this.getManagedDocumentExtension(item);

      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(extension)) {
        return 'is-image';
      }

      if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
        return 'is-video';
      }

      if (['mp3', 'wav', 'ogg', 'm4a'].includes(extension)) {
        return 'is-audio';
      }

      if (extension === 'pdf') {
        return 'is-pdf';
      }

      if (['doc', 'docx'].includes(extension)) {
        return 'is-word';
      }

      if (['ppt', 'pptx'].includes(extension)) {
        return 'is-powerpoint';
      }

      if (['xls', 'xlsx', 'csv'].includes(extension)) {
        return 'is-excel';
      }

      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
        return 'is-archive';
      }

      return 'is-default';
    },
    getManagedDocumentUrl(item) {
      const url = getLiveDocumentUrl(item);
      if (url) return url;
      if (item.file_path) {
        return item.file_path;
      }
      if (item.doc_index) {
        return `${window.process.env.API_HOST_DOWNLOAD}${item.doc_index}`;
      }
      return '';
    },
    getManagedDocumentOwner(item) {
      const owner = item && item.owner ? String(item.owner).trim() : '';
      return owner ? owner.toUpperCase() : '';
    },
    isManagedDocumentPublic(item) {
      return isLiveDocumentPublic(item);
    },
    getManagedDocumentId(item) {
      return getLiveDocumentId(item);
    },
    triggerLiveDocumentUpload() {
      if (this.$refs.liveDocumentsInput) {
        this.$refs.liveDocumentsInput.click();
      }
    },
    syncSharedFilesPanelState(hasDocuments = this.managedLiveDocuments.length > 0) {
      if (!hasDocuments) {
        return;
      }

      this.showFilesPanel = true;
    },
    async unpublishAllLiveDocuments() {
      if (this.documentsUploading) {
        return;
      }

      let hasPublishedPending = false;
      this.pendingLiveDocuments = this.pendingLiveDocuments.map(doc => {
        if (doc.public) {
          hasPublishedPending = true;
          return { ...doc, public: false };
        }
        return doc;
      });

      const publishedIds = this.liveDocuments
        .filter(doc => this.isManagedDocumentPublic(doc))
        .map(doc => this.getManagedDocumentId(doc))
        .filter(Boolean);

      if (publishedIds.length === 0 && !hasPublishedPending) {
        this.showToast(
          'info',
          this.$t('form_live.tabs.advanced.documents.unpublish_all_nothing'),
          'icon-info',
        );
        return;
      }

      if (publishedIds.length > 0) {
        this.documentsUploading = true;
        try {
          await this.setLiveDocumentsPublish(publishedIds, false);
          this.liveDocuments = this.liveDocuments.map(item => ({
            ...item,
            public: false,
          }));
          await this.fetchLiveDocuments();
        } catch (error) {
          console.log('error while unpublishing all live documents : ', error);
          this.showToast(
            'error',
            this.$t('form_live.tabs.advanced.documents.unpublish_all_error'),
            'icon-warning',
          );
          return;
        } finally {
          this.documentsUploading = false;
        }
      }

      this.showToast(
        'success',
        this.$t('form_live.tabs.advanced.documents.unpublish_all_success'),
        'icon-success',
      );
    },
    async fetchLiveDocuments() {
      if (!this.$route.params.id) {
        this.liveDocuments = [];
        return;
      }

      this.documentsLoading = true;

      try {
        const signedUrl = await getSignedLiveDocumentsUrl(`/live/file-live/${this.$route.params.id}`);
        const response = await axios.get(signedUrl, getLiveDocumentsHeaders());
        this.liveDocuments = normalizeLiveDocumentsResponse(response);
        this.syncSharedFilesPanelState();
      } catch (error) {
        console.log('error while fetching live documents : ', error);
        this.liveDocuments = [];
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.fetch_error'),
          'icon-warning',
        );
      } finally {
        this.documentsLoading = false;
      }
    },
    async handleLiveDocumentFileChange(event) {
      const input = event && event.target ? event.target : null;
      const files = input && input.files ? Array.from(input.files) : [];

      if (!files.length) {
        if (input) {
          input.value = '';
        }
        return;
      }

      this.syncSharedFilesPanelState(true);
      if (!this.$route.params.id) {
        files.forEach((file, index) => {
          this.pendingLiveDocuments.push({
            localId: `pending-document-${Date.now()}-${index}`,
            name: file.name,
            file,
            isPending: true,
            public: !!this.form.doc_publish_default,
          });
        });
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.queued_success'),
          'icon-success',
        );
        if (input) {
          input.value = '';
        }
        return;
      }

      this.documentsUploading = true;

      try {
        for (const file of files) {
          await this.uploadLiveDocument(file, this.$route.params.id, !!this.form.doc_publish_default);
        }

        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.upload_success'),
          'icon-success',
        );
        await this.fetchLiveDocuments();
      } catch (error) {
        console.log('error while uploading live documents : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.upload_error'),
          'icon-warning',
        );
      } finally {
        this.documentsUploading = false;
        if (input) {
          input.value = '';
        }
      }
    },
    async uploadLiveDocument(file, liveId, publishAfterUpload = false) {
      const signedUrl = await getSignedLiveDocumentsUrl(`/live/files-live/${liveId}`);
      const formData = new FormData();
      formData.append('files', file);
      formData.append('owner', window.client || window.process.env.CLIENT_NAME || 'empadmin');

      const response = await axios.post(signedUrl, formData, getLiveDocumentsHeaders(null));
      const uploadedDocuments = normalizeLiveDocumentsResponse(response);

      if (publishAfterUpload) {
        const ids = uploadedDocuments.map(item => getLiveDocumentId(item)).filter(Boolean);
        if (ids.length > 0) {
          await this.setLiveDocumentsPublish(ids, true);
        }
      }

      return response;
    },
    async uploadPendingLiveDocuments(liveId) {
      if (!liveId || this.pendingLiveDocuments.length === 0) {
        return;
      }

      this.documentsUploading = true;

      try {
        for (const pendingDocument of this.pendingLiveDocuments) {
          await this.uploadLiveDocument(
            pendingDocument.file,
            liveId,
            !!pendingDocument.public,
          );
        }

        this.pendingLiveDocuments = [];
        await this.fetchLiveDocuments();
      } finally {
        this.documentsUploading = false;
      }
    },
    async setLiveDocumentsPublish(ids, value) {
      if (!Array.isArray(ids) || ids.length === 0) {
        return;
      }

      const signedUrl = await getSignedLiveDocumentsUrl('/live/files-live/publish');
      await axios.post(
        signedUrl,
        [{ ids, public: !!value }],
        getLiveDocumentsHeaders('application/json'),
      );
    },
    async toggleLiveDocumentPublish(document, value) {
      const documentId = this.getManagedDocumentId(document);
      if (!documentId) {
        return;
      }

      try {
        await this.setLiveDocumentsPublish([documentId], value);
        this.liveDocuments = this.liveDocuments.map(item =>
          this.getManagedDocumentId(item) === documentId ? { ...item, public: !!value } : item,
        );
      } catch (error) {
        console.log('error while updating live document visibility : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.publish_error'),
          'icon-warning',
        );
      }
    },
    async deleteLiveDocument(document) {
      const documentId = document.isPending ? document.localId : this.getManagedDocumentId(document);
      if (!documentId) {
        return;
      }

      if (document.isPending) {
        this.pendingLiveDocuments = this.pendingLiveDocuments.filter(
          item => item.localId !== documentId,
        );
        return;
      }

      this.documentsDeletingId = documentId;

      try {
        const signedUrl = await getSignedLiveDocumentsUrl(`/live/file-live/${documentId}`);
        await axios.delete(signedUrl, getLiveDocumentsHeaders());
        this.liveDocuments = this.liveDocuments.filter(
          item => this.getManagedDocumentId(item) !== documentId,
        );
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.delete_success'),
          'icon-success',
        );
      } catch (error) {
        console.log('error while deleting live document : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.delete_error'),
          'icon-warning',
        );
      } finally {
        this.documentsDeletingId = null;
      }
    },
    async copyLiveDocumentLink(document) {
      const url = this.getManagedDocumentUrl(document);
      if (!url) {
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.link_copied'),
          'icon-success',
        );
      } catch (error) {
        console.log('error while copying live document link : ', error);
      }
    },
    normalizePollsResponse(payload) {
      const candidates = [
        payload && payload.data,
        payload && payload.data && payload.data.data,
        payload && payload.data && payload.data.polls,
        payload && payload.data && payload.data.data && payload.data.data.polls,
      ];

      for (const candidate of candidates) {
        if (Array.isArray(candidate)) {
          return candidate;
        }
      }

      const singlePoll =
        (payload && payload.data && payload.data.poll) ||
        (payload && payload.data && payload.data.data && payload.data.data.poll) ||
        (payload && payload.data && payload.data.id ? payload.data : null);

      return singlePoll ? [singlePoll] : [];
    },
    addPollDraft() {
      if (!this.canAddPoll) {
        this.showToast(
          'warning',
          this.$t('form_live.tabs.advanced.polls.complete_current_first'),
          'icon-warning',
        );
        this.activePollIndex = this.livePolls.length - 1;
        return;
      }
      this.livePolls.push(createPollDraft());
      this.activePollIndex = this.livePolls.length - 1;
    },
    setActivePoll(index) {
      if (index < 0 || index >= this.livePolls.length) {
        return;
      }

      this.activePollIndex = index;
    },
    ensureActivePollIndex(preferredIndex = 0) {
      if (this.livePolls.length === 0) {
        this.activePollIndex = 0;
        return;
      }

      this.activePollIndex = Math.min(Math.max(preferredIndex, 0), this.livePolls.length - 1);
    },
    getPollTabTitle(poll) {
      if (poll && poll.question && poll.question.trim()) {
        return poll.question;
      }

      return this.$t('form_live.tabs.advanced.polls.untitled');
    },
    isDeletePollPending(pollIndex) {
      return (
        this.pendingPollDelete &&
        this.pendingPollDelete.type === 'poll' &&
        this.pendingPollDelete.pollIndex === pollIndex
      );
    },
    isDeleteOptionPending(pollIndex, optionIndex) {
      return (
        this.pendingPollDelete &&
        this.pendingPollDelete.type === 'option' &&
        this.pendingPollDelete.pollIndex === pollIndex &&
        this.pendingPollDelete.optionIndex === optionIndex
      );
    },
    requestPollDelete(pollIndex) {
      this.pendingPollDelete = {
        type: 'poll',
        pollIndex,
      };
    },
    requestPollOptionDelete(pollIndex, optionIndex) {
      this.pendingPollDelete = {
        type: 'option',
        pollIndex,
        optionIndex,
      };
    },
    cancelPendingDelete() {
      this.pendingPollDelete = null;
    },
    confirmPollDelete(pollIndex) {
      this.cancelPendingDelete();
      this.removePoll(pollIndex);
    },
    async confirmPollOptionDelete(pollIndex, optionIndex) {
      this.cancelPendingDelete();
      await this.removePollOption(pollIndex, optionIndex);
    },
    addPollOption(pollIndex) {
      const poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      poll.options.push(createPollOptionDraft());
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, { ...poll });
    },
    updatePollQuestion(pollIndex, value) {
      const poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      poll.question = value;
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, { ...poll });
    },
    async updatePollPublished(pollIndex, value) {
      const poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      const nextValue = !!value;
      const previousValue = !!poll.isPublished;
      poll.isPublished = nextValue;
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, { ...poll });

      if (!poll.id || !this.isEmpreintePollClient) {
        return;
      }

      try {
        await axios.patch(
          `${window.process.env.API_HOST_LIVE}/live/polls/publish/${poll.id}`,
          {
            isPublished: nextValue,
          },
          this.getPollRequestConfig(),
        );
      } catch (error) {
        poll.isPublished = previousValue;
        this.livePolls.splice(pollIndex, 1, { ...poll });
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.polls.publish_error'),
          'icon-warning',
        );
      }
    },
    updatePollOption(pollIndex, optionIndex, value) {
      const poll = this.livePolls[pollIndex];
      if (!poll || !poll.options[optionIndex]) {
        return;
      }

      poll.options[optionIndex].poll_option = value;
      poll.options[optionIndex].dirty = true;
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, { ...poll });
    },
    removePollOptionLocally(pollIndex, optionIndex) {
      const poll = this.livePolls[pollIndex];
      if (!poll) {
        return false;
      }

      if (poll.options.length <= 2) {
        this.showToast(
          'warning',
          this.$t('form_live.tabs.advanced.polls.min_options_warning'),
          'icon-warning',
        );
        return false;
      }

      poll.options.splice(optionIndex, 1);
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, { ...poll });
      return true;
    },
    async removePollOption(pollIndex, optionIndex) {
      const poll = this.livePolls[pollIndex];
      if (!poll || !poll.options[optionIndex]) {
        return;
      }

      const option = poll.options[optionIndex];
      const removed = this.removePollOptionLocally(pollIndex, optionIndex);
      if (!removed) {
        return;
      }

      if (!option.id) {
        return;
      }

      if (
        poll.id &&
        !this.deletedPollOptionIds.some(
          deletedOption =>
            deletedOption.pollId === poll.id && deletedOption.optionId === option.id,
        )
      ) {
        this.deletedPollOptionIds.push({
          pollId: poll.id,
          optionId: option.id,
        });
      }
    },
    removePoll(pollIndex) {
      const poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      if (poll.id) {
        if (!this.deletedPollIds.includes(poll.id)) {
          this.deletedPollIds.push(poll.id);
        }
        this.deletedPollOptionIds = this.deletedPollOptionIds.filter(
          deletedOption => deletedOption.pollId !== poll.id,
        );
      }

      this.livePolls.splice(pollIndex, 1);
      if (this.livePolls.length === 0) {
        this.form.poll = false;
        this.activePollIndex = 0;
        return;
      }

      this.ensureActivePollIndex(Math.min(pollIndex, this.livePolls.length - 1));
    },
    getPollValidationError(poll) {
      if (!poll || !poll.question || !poll.question.trim()) {
        return this.$t('form_live.tabs.advanced.polls.validation_question_required');
      }

      if (!Array.isArray(poll.options) || poll.options.length < 2) {
        return this.$t('form_live.tabs.advanced.polls.validation_min_options');
      }

      const invalidOption = poll.options.find(option => !option.poll_option || !option.poll_option.trim());
      if (invalidOption) {
        return this.$t('form_live.tabs.advanced.polls.validation_options_required');
      }

      return '';
    },
    buildCreatePollsPayload(liveId) {
      return this.livePolls
        .filter(poll => !poll.id)
        .map(poll => ({
          question: poll.question.trim(),
          liveId,
          isPublished: !!poll.isPublished,
          options: poll.options.map(option => ({
            poll_option: option.poll_option.trim(),
          })),
        }));
    },
    buildUpdatePollsPayload() {
      return this.livePolls
        .filter(poll => poll.id)
        .map(poll => ({
          pollId: poll.id,
          question: poll.question.trim(),
          options: [
            ...poll.options.map(option =>
              option.id
                ? {
                    id: option.id,
                    action: 'update',
                    text: option.poll_option.trim(),
                  }
                : {
                    action: 'add',
                    text: option.poll_option.trim(),
                  },
            ),
            ...this.deletedPollOptionIds
              .filter(deletedOption => deletedOption.pollId === poll.id)
              .map(deletedOption => ({
                id: deletedOption.optionId,
                action: 'delete',
              })),
          ],
        }));
    },
    async fetchLivePolls() {
      if (!this.isEmpreintePollClient) {
        this.livePolls = [];
        this.activePollIndex = 0;
        this.deletedPollIds = [];
        this.deletedPollOptionIds = [];
        this.pollsLoaded = true;
        return;
      }

      if (!this.$route.params.id) {
        this.livePolls = [];
        this.activePollIndex = 0;
        this.pollsLoaded = true;
        return;
      }

      this.pollsLoading = true;

      try {
        const response = await axios.get(
          `${window.process.env.API_HOST_LIVE}/live/polls/${this.$route.params.id}`,
          this.getPollRequestConfig(),
        );
        const polls = this.normalizePollsResponse(response);
        this.livePolls = polls.map(createPollDraft);
        this.ensureActivePollIndex();
        this.deletedPollIds = [];
        this.deletedPollOptionIds = [];
        this.pollsLoaded = true;
      } catch (error) {
        console.log('error while fetching polls for this live : ', error);
        this.livePolls = [];
        this.activePollIndex = 0;
        this.pollsLoaded = true;
      } finally {
        this.pollsLoading = false;
      }
    },
    async syncLivePolls(liveId) {
      if (!this.isEmpreintePollClient || !liveId) {
        return;
      }

      const pollErrors = this.livePolls
        .map(this.getPollValidationError)
        .filter(Boolean);

      if (pollErrors.length > 0) {
        throw new Error(pollErrors[0]);
      }

      this.pollsSyncing = true;

      try {
        for (const pollId of this.deletedPollIds) {
          await axios.delete(
            `${window.process.env.API_HOST_LIVE}/live/polls/${pollId}`,
            this.getPollRequestConfig(),
          );
        }

        const pollsToCreate = this.buildCreatePollsPayload(liveId);
        if (pollsToCreate.length > 0) {
          await axios.post(
            `${window.process.env.API_HOST_LIVE}/live/polls/multiple`,
            pollsToCreate,
            this.getPollRequestConfig(),
          );
        }

        const pollsToUpdate = this.buildUpdatePollsPayload();
        if (pollsToUpdate.length > 0) {
          await axios.patch(
            `${window.process.env.API_HOST_LIVE}/live/polls/multiple`,
            pollsToUpdate,
            this.getPollRequestConfig(),
          );
        }

        this.deletedPollIds = [];
        this.deletedPollOptionIds = [];
        await this.fetchLivePolls();
      } finally {
        this.pollsSyncing = false;
      }
    },

     handleSourceTypeInput(value) {
    // Use setTimeout to ensure DOM stability
    setTimeout(() => {
      this.form.sourceTypeId = value;
    }, 50);
  },
  addCustomParticipant(email) {
      // Optional: validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) return;

      const existingOption = this.localParticipantOptions.find(option => option.email === email);
      if (existingOption) {
        const alreadySelected = this.form.participants.some(option => option.email === email);
        if (!alreadySelected) {
          this.form.participants.push(existingOption);
        }
        return;
      }

      const newParticipant = {
        id: `custom-${Date.now()}`,
        name: email,
        email,
        isCustom: true
      };
      // Add to options so it remains selectable
      this.localParticipantOptions.push(newParticipant);

      // Select it immediately
      this.form.participants.push(newParticipant);
    },
    extractEmailsFromText(value) {
      if (!value || typeof value !== 'string') return [];

      const matches = value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi) || [];
      const seen = new Set();

      return matches
        .map(email => email.trim().toLowerCase())
        .filter(email => {
          if (seen.has(email)) return false;
          seen.add(email);
          return true;
        });
    },
    addParticipantEmails(rawValue) {
      const emails = this.extractEmailsFromText(rawValue);

      emails.forEach(email => {
        this.addCustomParticipant(email);
      });

      return emails.length;
    },
    triggerParticipantImport() {
      const input = this.$refs.participantsImportInput;
      if (input) {
        input.click();
      }
    },
    async handleParticipantFileChange(event) {
      const input = event.target;
      const file = input && input.files ? input.files[0] : null;

      if (!file) return;

      try {
        const rawText = await this.readEmailsFromInviteFile(file);
        const importedCount = this.addParticipantEmails(rawText);

        if (importedCount > 0) {
          this.showToast('success', `${importedCount} e-mail(s) importé(s)`, 'icon-success');
        } else {
          this.showToast('error', 'Aucune adresse e-mail valide trouvée dans le fichier', 'icon-error');
        }
      } catch (error) {
        console.error('Error while importing participant file:', error);
        this.showToast('error', 'Impossible de lire ce fichier', 'icon-error');
      } finally {
        if (input) {
          input.value = '';
        }
      }
    },
    readEmailsFromInviteFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const fileName = (file.name || '').toLowerCase();

        reader.onload = event => {
          try {
            if (fileName.endsWith('.csv')) {
              resolve(event.target.result);
              return;
            }

            if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
              const workbook = XLSX.read(event.target.result, { type: 'array' });
              const content = workbook.SheetNames.map(sheetName => {
                const sheet = workbook.Sheets[sheetName];
                return XLSX.utils.sheet_to_csv(sheet);
              }).join('\n');

              resolve(content);
              return;
            }

            reject(new Error('Unsupported file type'));
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = () => reject(reader.error);

        if (fileName.endsWith('.csv')) {
          reader.readAsText(file);
          return;
        }

        reader.readAsArrayBuffer(file);
      });
    },
    setupParticipantBulkListener() {
      this.bulkEmailListenerCleanup.forEach(cleanup => cleanup());
      this.bulkEmailListenerCleanup = [];

      this.$nextTick(() => {
        const multiselect = this.$refs.participantsMultiselect;
        const input = multiselect && multiselect.$el
          ? multiselect.$el.querySelector('.multiselect__input')
          : null;

        if (!input) {
          return;
        }

        const handlePaste = event => {
          const pastedText = event.clipboardData && event.clipboardData.getData('text');
          if (!pastedText) return;

          if (this.extractEmailsFromText(pastedText).length > 1) {
            event.preventDefault();
            this.addParticipantEmails(pastedText);
            event.target.value = '';
          }
        };

        const handleKeydown = event => {
          const inputValue = event.target && event.target.value;
          if (!inputValue) return;

          const shouldSplit = ['Enter', 'Tab', ',', ';'].includes(event.key)
            || /[\n\r]/.test(inputValue);

          if (!shouldSplit) return;

          if (this.extractEmailsFromText(inputValue).length > 1) {
            event.preventDefault();
            this.addParticipantEmails(inputValue);
            event.target.value = '';
          }
        };

        input.addEventListener('paste', handlePaste);
        input.addEventListener('keydown', handleKeydown);

        this.bulkEmailListenerCleanup.push(() => {
          input.removeEventListener('paste', handlePaste);
          input.removeEventListener('keydown', handleKeydown);
        });
      });
    },
   toggleSection(section) {
  // Force Vue to complete any pending DOM updates BEFORE toggling
  this.$nextTick(() => {
    this.$nextTick(() => {  // Double $nextTick for safety
      this.sections[section] = !this.sections[section];
    });
  });
},
     getPermissionByType(type) {
    const permissionMap = {
      'Meeting': 'lives_type_meeting',
      'Webinar': 'lives_type_webinar',
      'Webcast': 'lives_type_webcast'
    };
    
    return permissionMap[type] ;
  },
     onStationChange(stationId) {
      this.form.stationId = stationId;
      this.$nextTick(() => {
        this.updatePortIndexesForUnesco(stationId);
      });
    },
    
    updatePortIndexesForUnesco(stationId) {
      if (!stationId || !this.isUnescoClient) return;
      
      const station = this.automaticStations.find(s => s.value === stationId);
      if (!station) return;
      
      const match = station.text.match(/SDI\s*(\d+)/i);
      if (match && match[1]) {
        const sdiNumber = parseInt(match[1], 10);
        const portIndex = sdiNumber - 1;
        this.$set(this.form, 'videoPortIndex', Math.max(0, portIndex));
        this.$set(this.form, 'audioPortIndex', Math.max(0, portIndex));
      }
    },
    setPortIndexesForVyv(station) {
      const match = station.text.toLowerCase().match(/sdi\s*(\d+)/);      
      if (match && match[1]) {
        const sdiNumber = parseInt(match[1], 10);
        const portIndex = sdiNumber - 1;
        // fixing portVIdeo and portAudio to 0 for now
        // this.form.videoPortIndex = portIndex;
        // this.form.audioPortIndex = portIndex;
      } else {
        this.form.videoPortIndex = 0;
        this.form.audioPortIndex = 0;
      }
    },
    onWebinarChange() {
    if (![1, 2].includes(this.form.sourceTypeId)) {
      this.form.sourceTypeId = 1;
    }
  },
  async fetchStations() {
    this.loadingAutomaticStations = true;
    try {
      const response = await axios.get(
        `${window.process.env.API_HOST_GLOBAL}/live/station/auto`,
        {
          headers: {
            Authorization: `Bearer ${process.env.API_TOKEN}`,
          },
        }
      );
      this.automaticStations = response.data.stations || response.data;
    } catch (error) {
      console.error('Error fetching manual stations:', error);
      this.showToast('error', this.$t('toast.error_fetching_stations'), 'icon-error');
    } finally {
      this.loadingAutomaticStations = false;
    }
  },
  handleEncoderTypeChange(type) {
    if (!type) {
      this.form.isAuto = false;
      this.form.isPearl = true;
    } else {
      this.form.isAuto = true;
      this.form.isPearl = true;
    }
  },
      async fetchEncoderStations() {
    const response = await axios.get('/api/encoders/stations');

    this.manualStations = response.data.manual || [];
    this.automaticStations = response.data.automatic || [];
  },
     onYoutubeEnabledChange(val) {
      this.form.isYoutube = val;
    },
    onYoutubeLinksChange(val) {
      this.form.youtubeLinks = val;
    },
      async fetchCountries() {
      this.isLoadingCountries = true;
      try {
        const response = await axios.get(`${window.process.env.API_HOST_GLOBAL}/video-api/video/countries?language=${this.lang}`, {
          headers: {
            Authorization: `Bearer ${process.env.API_TOKEN}`,
          },
        });
        
        this.countriesOptions = response.data.data?response.data.data.map(country => ({
          countryCode: country.country_code,
          countryName: country.country_name,
          id:country.id
        })):[];
        
      } catch (error) {
        console.error('Error fetching countries:', error);
      } finally {
        this.isLoadingCountries = false;
      }
    },
    
    showToast(variant, message, icon) {
      console.log(variant, message, icon);
        this.$toasted.show(message, {
        type: variant,
        theme: 'bubble',
        position: 'bottom-right',
        duration: 2000,
        icon: {
          name: 'mr-2 ' + icon,
        },
      });

    },
    handleAddInputTags(tags) {
      for (let i = 0; i < tags.length; i++) {
        tags[i] = tags[i].replaceAll(' ', '-');
      }
      return tags;
    },
    handleBeforeOpen() {
      this.openTimeModal=true;
    },
    closeModal(){
      this.openTimeModal=false;

    },
    resetMaxOnlineGuests(){
     //Reset inputs in case the user toggle off the limit participant checkbox
        this.form.max_online_guests = null ;
        this.form.max_onsite_guests = null;
    },

    ...mapActions('common', ['setDiffusionLive']),
    ...mapActions('lives', [
      'getLiveById',
      'fetchContributors',
      'fetchChannels',
      'fetchLiveTypes',
      'updateLive',
      'createLive',
      'setDiffusionObject',
      'setHlsLinkValue',
      'fetchLiveSkins'
    ]),

    setHls (e){
      this.setHlsLinkValue(e);
    },
    ...mapActions('form', ['fetchVideos', 'fetchSurveys', 'resetPagination']),
    async getDefaultThumb(){
      if(!this.form.thumbnail ){
        NProgress.start();
        await  this.getDefaultImage(this.getThumbnail);
      }
    },
   inputFile() {
  if (!this.url) {
    document.getElementById('file-default').click();
    // Alternatively, you can use the ref approach:
    // this.$refs.File.click();
  }
},


    changeInput() {
      setTimeout(async () => {
        await this.handleAvatarUpdated(this.file);
        this.PendingUpload=false
        this.showDelete = true;
      }, 400);
    },
    async toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();

    },
    portKeydown(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode >= 96 && charCode <= 105) || charCode == 8) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    
    closeModel() {
       this.uploadError=false
      this.hideModal();
      this.$refs.formIntervenant.reset();
      this.update = false;
      this.updateModal = false;

      this.form.nom = '';
      this.form.lastName = '';
      this.form.fonction = '';
      this.form.role = '';
      this.form.Description = '';
      this.file = '';
      this.form.mail = '';
      this.form.structure = '';
      this.showDelete = false;
      this.url = '';

    },
    showModal() {
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn');
    },



    async b64toBlob (b64Data, contentType='', sliceSize=512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    async getDefaultImage(defaultTumbnail){
      let self=this;
      var img =defaultTumbnail;
      await this.toDataURL(img,async function(dataUrl) {
        img =await dataUrl
        const contentType='image/jpeg'
        const replaceString = 'data:' + contentType + ';base64,';
        if(img.indexOf(contentType) > -1){
          const blob = await self.b64toBlob(img.replace(replaceString, ''), contentType);
          await self.uploadThumbnail(blob).then(result => {
            const { data } = result;

            if (img.indexOf('base64') > -1) {
              self.form.thumbnailPath = data.location.path;
              NProgress.done();
            }
          });
        }

      })
    },
    redirectTo(start){
      if(start){
        parent.postMessage(
          {
            info:'goToDiffusionLive' ,
            live: this.currentLive,
          },
          '*',
        );
        this.$root.$emit('bv::hide::modal', 'modal-start-direct-v2');

      }else {
        this.goToListLive();
      }

      if(this.status && start){
        localStorage.setItem('redirectToStartDirect',true);
      }else if(this.status && !start){
        localStorage.setItem('redirectToList',true);
      }

    },
    redirectToLives(){
      this.goToListLive()
    },
      removeError(event){
          if(event.target.value.length >=255 ){
              this.showErrorMessage=true;
          }else{
              this.showErrorMessage=false;
          }
      },

   async handleSubmit() {
  if (this.openTimeModal || this.btnDisabled) {
    return;
  }

  this.resetHighlightErrors();
  this.$v.form.$touch();
  if (this.$v.form.$error) {
    this.highlightFormErrors();
    return;
  }

  NProgress.start();
  if(this.skinForm.selectedSkin){
    await this.saveAndApplySkin().then((res)=>{
      if(res.liveSkin.liveSkin.id){
        this.form.liveSkinId = res.liveSkin.liveSkin.id

      }else{
        this.form.liveSkinId = null

      }

    }).catch((err)=>{
      console.log("error",err)
    })
  }else{
    this.form.liveSkinId = null;
  }
      // set isRm to true if chapters are not empty
  if (this.form.chapters && this.form.chapters.length > 0) {
    this.form.isRm = true;
    }

  let dataToSubmit = this.mapFormData(this.form);
  dataToSubmit.empLivesForm.record_with_permission = this.form.record_with_permission;
  if(this.getUserId){
    if (this.form && Array.isArray(this.form.contributors) && this.form.contributors.length > 0) {
        const ids = this.form.contributors.map(admin => admin.id);
       dataToSubmit.empLivesForm.contributorID = ids.includes(this.getUserId) ? ids : [this.getUserId, ...ids];
    } else {
        dataToSubmit.empLivesForm.contributorID = [this.getUserId];
    }
  }
  let message;
  let data;

  try {
    if (this.isEditMode) {
      if (this.EditOption) {
        for (const intervenant of this.intervenantsToUpdate) {
          await this.submitUpdateForm(intervenant);
        }
      }
      if (this.intervenantsTodelete.length > 0) {
        await this.deleteIntervenant();
      }
      if (this.intervenantsToAdd.length > 0) {
        await this.submitFormIntervenant();
      }
      if (!this.errorOccurred && !this.errorOccurredInUpdate && !this.errorOccurredInAdd) {
        dataToSubmit.moderators = this.moderators
        data = await this.updateLive(dataToSubmit);
        if (data.code == 200) {
          await this.syncLivePolls(this.$route.params.id);
          message = i18n.t('toast.success_edit');
        }
      }
    } else {
              dataToSubmit.moderators = this.moderators
              data = await this.createLive(dataToSubmit);
              if (data.code == 200) {
                await this.intervenantsToAdd.map((el) => {
                  el.liveId = data.Lives.id;
                });
                if (this.intervenantsToAdd.length > 0) {
                  let dd = await this.submitFormIntervenant();
                }
                if (this.intervenantsTodelete.length > 0) {
                  let deletee = await this.deleteIntervenant();
                }
                await this.uploadPendingPresentations(data.Lives.id);
                await this.uploadPendingLiveDocuments(data.Lives.id);
                await this.syncLivePolls(data.Lives.id);
              }
              message = i18n.t('toast.success_add');
            }
            this.showToast('success', message, 'icon-success');
            this.$v.form.$reset();
            var obj = this.getDiffusionObject;
            obj.type = this.getDiffusion;
            this.setDiffusionObject(obj);
            this.setDiffusionLive(this.getDiffusion);
          } catch (e) {
            message = i18n.t('toast.error');
            this.showToast('error', message, 'icon-warning');
          }
          NProgress.done();
          let startdate = moment(new Date(dataToSubmit.empLivesForm.dateStart)).format(
            'YYYY-MM-DD',
          );
          let currentdate = moment(new Date()).format('YYYY-MM-DD');
          let choix = localStorage.getItem('redirectToStartDirect');
          if (startdate === currentdate && !choix) {
            this.currentLive = data.Lives;
            if (this.currentLive.webinar && this.hasPermission(this.getDiffusionPermission)) {
              this.$root.$emit('bv::show::modal', 'modal-start-direct');
            } else {
              this.goToListLive();
            }

      } else {
        this.goToListLive();
      }
    },


    onReset() {},
    handleToggleSecured() {
      if (!this.password) {
        this.form.pwd = '';
      }
    },
    toggleBeforeLiveVideoPicker() {
      this.isBeforeLiveVideoPickerVisible = !this.isBeforeLiveVideoPickerVisible;
    },
    focusAddChapter() {
      this.$nextTick(() => {
        if (this.$refs.newChapterInput) {
          this.$refs.newChapterInput.$el.focus();
        }
      });
    },
    highlightFormErrors() {
      const validators = [
        ['description', 'endTime', 'startDate', 'startTime', 'title'],
        ['conf'],
        ['title'],
        ['title'],
      ];
      const tabs = document.querySelectorAll('.nav-item');
      let index;

      if (validators[0].some((item) => this.$v.form[item].$invalid)) {
        NProgress.done();
        index = 0;
      } else if(this.$v.form["stationId"].$invalid) {
        index = 1;
      }else{
        index = 2
      }
      tabs[index].classList.add('has-error');
      tabs[index].querySelector('.nav-link').click();
    },
    resetHighlightErrors() {
      const tabs = document.querySelectorAll('.nav-item');
      for (let i = 0; i < tabs.length; ++i) {
        tabs[i].classList.remove('has-error');
      }
    },
    submitForm() {
      this.submitButtonClicked = true;
    },
    openModelForUpdate(id) {
      this.uploadError=false
      this.update = true;
      this.showModal();
      this.form.nom = this.intervenants[id].name;
      this.form.lastName = this.intervenants[id].lastName;
      this.form.fonction = this.intervenants[id].function;
      this.form.structure = this.intervenants[id].structure;
      this.form.role =this.intervenants[id].role;
      this.form.Description =this.intervenants[id].description;
      this.form.mail = this.intervenants[id].mail;
      this.file = this.intervenants[id].avatar;
      
      const cleanedUrl = this.cleanedAvatarUrl(this.intervenants[id].avatar);
      this.url = cleanedUrl === "https://" ? "" : cleanedUrl;

      this.idUpdate = this.intervenants[id].id;
      if (this.intervenants[id].id == undefined) {
        this.update = false;
        this.updateModal = true;
        this.forUpdate = true;
        this.indexToupdate = id;
         const existingIntervenantIndex = this.intervenantsToAdd.findIndex(intervenant => {
            return intervenant.name  === this.form.nom && intervenant.lastName === this.form.lastName ;
        });
         const existingIndex = this.intervenants.findIndex(intervenant => {
            return intervenant.name  === this.form.nom && intervenant.lastName === this.form.lastName ;
        });


        if (existingIntervenantIndex > -1) {
this.updateIdParticipant=existingIntervenantIndex


         }
if(existingIndex> -1){
           this.udpateInIntervenants = existingIndex


}
        
       
      } else {
        this.update = true;
      }
    },
    deleteImageIntervenant() {
      this.file = '';
      this.url='';
    },
    fetchAllintervenant() {
      if(this.$route.params.id)
    {  axios
        .get(
          `${window.process.env.API_HOST_GLOBAL}/live/get-live-speakers/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${process.env.API_TOKEN}`,
            },
          },
        )
        .then((res) => {
          this.intervenants = res.data.data;
        });}
    },
    validateEmail(email) {
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (email) {
        this.emailError = emailRegex.test(email) ? null : this.$t("modal.errorEmail");
        // console.log("emailRegex", emailRegex.test(email))
        return emailRegex.test(email);
    } else {
        return true;
    }
},

async submitUpdateForm(intervenant) {
  if (!intervenant || !intervenant.name || !intervenant.lastName) {
    return;
  }

  if (this.validateEmail(intervenant.mail)) {
    try {
      const res = await axios.post(
        `${window.process.env.API_HOST_GLOBAL}/live/update-speakers`,
        {
          Speakers: [
            {
              id: intervenant.id,
              name: intervenant.name,
              lastName: intervenant.lastName,
              function: intervenant.fonction,
              role: intervenant.role,
              description: intervenant.Description,
              avatar: intervenant.avatar,
              liveId: Number(this.$route.params.id),
              mail: intervenant.mail,
              structure: intervenant.structure,
            },
          ],
        },
        {
          headers: {
            Authorization: `Bearer ${window.process.env.API_TOKEN}`,
          },
        }
      );
if(res.status ===200){
        this.errorOccurredInUpdate =false;

}
    
    } catch (err) {
      this.errorOccurredInUpdate =true;
      this.showToast('error', this.$t("toast.UpdateError"), 'icon-error');
    }
  }
},


    resetModal() {
      this.form.nom = '';
      this.form.lastName = '';
      this.form.fonction = '';
      this.form.structure = '';
      this.form.role = '';
      this.form.Description = '';
      this.form.mail = '';
      this.update = true;
    },
    handleeForm() {
      this.submitButtonClicked = true;
    },
    ManageIntervenant() {
      const intervenantEmails = this.intervenants.map((intervenant)=>intervenant.mail).filter((email) => email && email.trim() !== '');
      if (!this.form.nom || !this.form.lastName ) {

        this.showToast('error', this.$t("modal.error"), 'icon-error');

      }else if(intervenantEmails.includes(this.form.mail) && !this.updateModal && !this.update){
        this.showToast('error', this.$t("modal.errorEmailDuplicated"), 'icon-error');
      }else if(this.uploadError){
        this.showToast('error', this.$t("modal.errorUpload"), 'icon-error');

      }
      
      else {
        if (this.validateEmail(this.form.mail)) {

          var data = {
            name: this.form.nom,
            lastName: this.form.lastName,
            function: this.form.fonction,
            role: this.form.role,
            description: this.form.Description,
             avatar: this.url?this.url:"",
            liveId: Number(this.$route.params.id),
            mail: this.form.mail,
            structure: this.form.structure,
          };
          var dataSend = {
            name: this.form.nom,
            lastName: this.form.lastName,
            function: this.form.fonction,
            role: this.form.role,
            description: this.form.Description,
             avatar: this.file?this.file:"",
            liveId: Number(this.$route.params.id),
            mail: this.form.mail,
            structure: this.form.structure,
          };
          if (this.updateModal ) {
            this.showToast('success',this.$t("modal.successUpdate"), 'icon-success');
            this.intervenants[ this.udpateInIntervenants] = data;
            this.intervenantsToAdd[this.updateIdParticipant] = data;
        
          

          }else if(this.update){
          this.EditOption=true
            const updatedIntervenant = {
              id: this.idUpdate,
              name: this.form.nom,
              lastName: this.form.lastName,
              function: this.form.fonction,
              role: this.form.role,
              description: this.form.Description,
              avatar: this.url,
               liveId: Number(this.$route.params.id),
              mail: this.form.mail,
              structure: this.form.structure,
            };

            const intervenantsIndex = this.intervenants.findIndex((i) => i.id === this.idUpdate);
              const existingIndex = this.intervenantsToUpdate.findIndex((i) => i.id === this.idUpdate);

            if (intervenantsIndex > -1) {
              this.intervenants[intervenantsIndex] = updatedIntervenant;
            }
            if(existingIndex> -1){
          this.intervenantsToUpdate[existingIndex] = updatedIntervenant;


            }else{
         this.intervenantsToUpdate.push(updatedIntervenant);


            }         

            

          }else{
            this.intervenantsToAdd.push(dataSend);
          this.intervenants.push(data);
          this.showToast('success', this.$t("modal.success"), 'icon-success');

          }
        this.closeModel();
        }else{
          // this.showToast('error', this.$t("modal.errorEmail"), 'icon-error');
        }
      }

    },
    submitFormIntervenant() {
      var data = {
        speakers: this.intervenantsToAdd,
      };

  var config = {
    method: 'post',
    url: `${window.process.env.API_HOST_GLOBAL}/live/add-speakers`,
    headers: {
      Authorization: `Bearer ${window.process.env.API_TOKEN}`,
      'Content-Type': 'application/json',
      'Content-Length': JSON.stringify(data).length,
    },
    data: data,
  };

  axios(config)
    .then((response) => {
            this.errorOccurredInAdd=false
      if (response.data && response.data.status === 200) {
        this.$v.form.$reset();
      }
    })
    .catch((error) => {
      this.errorOccurredInAdd=true
      
            this.$v.form.$reset();
      console.error(error);
        this.showToast('error', this.$t("toast.AddError"), 'icon-error');

    });
},
    deleteInter(index) {
      this.PendingUpload = false
  const deletedIntervenantId = this.intervenants[index].id;
    if (deletedIntervenantId === undefined) {
  const nomToDelete = this.intervenants[index].name;
        const prenomToDelete = this.intervenants[index].lastName;
        const intervenantIndexToDelete = this.intervenants.findIndex(intervenant => intervenant.name === nomToDelete && intervenant.lastName === prenomToDelete);
      const intervenanIndexAdd = this.intervenantsToAdd.findIndex(intervenant => intervenant.name === nomToDelete && intervenant.lastName === prenomToDelete);

 if(intervenantIndexToDelete > -1 ){
   this.intervenantsTodelete.push(intervenantIndexToDelete);
        this.intervenants = this.intervenants.filter((el, i) => i !== intervenantIndexToDelete);
        if(intervenanIndexAdd> -1){
  this.intervenantsToAdd = this.intervenantsToAdd.filter((el,i) => i !== intervenanIndexAdd);

        }

 }
    }else{
 this.intervenantsTodelete.push(deletedIntervenantId);
  this.intervenants = this.intervenants.filter((el) => el.id !== deletedIntervenantId);
  this.intervenantsToAdd = this.intervenantsToAdd.filter((el) => el.id !== deletedIntervenantId);
   if(this.intervenantsToUpdate){
  this.intervenantsToUpdate=this.intervenantsToUpdate.filter((el) => el.id !== deletedIntervenantId);



  }
    }
 
 


    },
 async deleteIntervenant() {
    try {
        const res = await axios.delete(`${window.process.env.API_HOST_GLOBAL}/live/delete-speakers`, {
            headers: {
                Authorization: `Bearer ${window.process.env.API_TOKEN}`,
            },
            data: {
                list_to_delete_speakers: this.intervenantsTodelete,
            },
        });

        if (res.status === 200) {
                      this.errorOccurred = false;

        } else {
            this.errorOccurred = true;
            this.showToast('error', this.$t("toast.DeleteError"), 'icon-error');
        }
    } catch (error) {
        console.error("Error deleting intervenants:", error);
        this.errorOccurred = true;
        this.showToast('error', this.$t("toast.DeleteError"), 'icon-error');
    }
},

    handleDiffusionTypeChanged(type) {
      setTimeout(() => {
        let types = [];
        switch (type) {
          case 'accessType':
            types = ['by_link', 'private', 'public'];
            types.forEach(t => {
              this.connexionWebinar = t === this.form[type];
            });
            break;
          case 'connexionType':
            types = ['auto', 'by_authorization'];
            types.forEach(t => {
              this.accessWebinar = t === this.form[type];
            });
            break;
          case 'diffusion':
            types = ['webinar', 'isPearl', 'screenShare','externalHls'];
            this.form.accessType="public"
            this.form.connexionType="auto"
            types.forEach(t => {
              this.form[t] = t === this.form[type];
            });
            
            break;
        }
      }, 100);
    },
    addChapter() {
      if (!this.newChapter) {
        return;
      }
      const chapter = {
        title: this.newChapter,
        chapterOrder: this.form.chapters.length,
        timeCode: null,
      };
      this.form.chapters.push(chapter);
      this.newChapter = '';
      // const chapresEl = this.$refs['ps-chapters'].$el;
      // setTimeout(() => {
      //   chapresEl.scrollTop = chapresEl.scrollHeight;
      // }, 100);
    },
    toggleEditChapter(index, dismiss = true) {
      if (!(this.form.chapters[index] || this.chapterTitle)) {
        return;
      }
      this.form.chapters = this.form.chapters.map((c, i) => {
        if (i === index) {
          if (this.chapterTitle) {
            c.title = this.chapterTitle;
          } else {
            this.chapterTitle = c.title;
          }
          c.isEditMode = !c.isEditMode;
        }
        return c;
      });
      if (dismiss) {
        this.chapterTitle = '';
      }
    },
    removeChapter(index) {
      this.watchUndoRemoveItem(this.form.chapters, index).then(val => {
        this.form.chapters = val;
      });
      this.form.chapters = this.form.chapters.filter((c, i) => i !== index);
    },
    setAddQuestionMode(addQuestionMode) {
      this.addQuestionMode = addQuestionMode;
      this.form.questions = this.form.questions.map(q => {
        q.isEditMode = false;
        return q;
      });
    },
    addQuestion(question) {
      this.form.questions.push(question);
      this.addQuestionMode = false;

      // const questionsEl = this.$refs['ps-questions'].$el;
      // setTimeout(() => {
      //   questionsEl.scrollTop = questionsEl.scrollHeight;
      // }, 100);
    },
    updateQuestion(question, index) {
      this.form.questions = this.form.questions.map((q, i) =>
        i === index ? { ...question, isEditMode: false } : q,
      );
    },
    toggleEditQuestion(index) {
      this.form.questions = this.form.questions.map((q, i) => {
        if (i === index) {
          q.isEditMode = !q.isEditMode;
        }
        return q;
      });
      this.addQuestionMode = false;
    },
    removeQuestion(index) {
      this.watchUndoRemoveItem(this.form.questions, index).then(val => {
        this.form.questions = val;
      });
      this.form.questions = this.form.questions.filter((c, i) => i !== index);
    },
    updateScrollbar() {
      this.$nextTick(() => {
        const ps = this.$refs.ps;
        if (ps) {
          ps.update();
        }
      });
    },
    searchVideo() {
      this.resetPagination('videos');
      this.fetchVideos(this.searchVideoKeyword);
    },
    renderCarousel() {
      this.showCarousel = true;
      this.$nextTick(() => {
        const carousel = this.$refs.carousel;
        if (carousel) {
          carousel.render();
          carousel.goToPage(0);
        }
      });
    },

    selectVideo(slide) {
      this.form.conf.video = slide.id;
      this.form = Object.assign({}, this.form);
      this.form.videoBeforeLive = Object.assign({}, slide, { logo: slide.thumbnail });
      this.toggleBeforeLiveVideoPicker();
    },
    async checkEditMode() {
      const id = this.$route.params.id;
      this.isEditMode = !!id;
      if (this.isEditMode) {
        NProgress.start();
        await this.getLiveById(id);
        NProgress.done();
      }
    },
    getDropzoneOptions(type) {
      const opts = {
        url: '/',
        thumbnailWidth: 150,
        uploadMultiple: true,
        maxFilesize: 5,
        autoProcessQueue: false,
        dictDefaultMessage: '<span class="icon icon-upload"></span>' + i18n.t('upload_files.title'),
      };
      switch (type) {
        case 'media':
          opts.dictDefaultMessage += i18n.t('upload_files.media_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif, video/mp4';
          break;
        case 'file':
          opts.dictDefaultMessage += i18n.t('upload_files.file_type');
          break;
        case 'image':
          opts.dictDefaultMessage += i18n.t('upload_files.image_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
          break;
      }
      opts.dictDefaultMessage +=
        '<br>' +
        i18n.t('upload_files.or') +
        '<b><u>' +
        i18n.t('upload_files.click') +
        '</u></b>' +
        i18n.t('upload_files.selected_file');
      return opts;
    },
    replaceSlide(index) {
      this.slideIndex = index;
      window.dz = this.$refs.slidesDZ;
      document.getElementById('slides-dz').click();
    },
    handleDzSlideAdded(files) {
      setTimeout(async () => {
        for (let i = 0; i < files.length; i++) {
          const params = {
            id: 'slides-dz',
            current: i,
            total: files.length,
            type: 'slides',
          };
          const file = files[i];

          const blob = await this.processFile(file);
          await this.uploadThumbnail(blob, params).then(result => {
            const { data } = result;
            const slide = {
              slideType: file.type.indexOf('image') > -1 ? 'Image' : 'Video',
              slide: data.location.path,
              urlSlide: data.location.url,
            };
            if (this.slideIndex > -1) {
              this.form.slides.splice(this.slideIndex, 1, slide);
              this.slideIndex = -1;
            } else {
              this.form.slides.push(slide);
            }
            if (i === files.length - 1) {
              this.removeProgressCircle(params);
            }
          });
        }
        this.$refs.slidesDZ.removeAllFiles();
        // const slidesEl = this.$refs['ps-slides'].$el;
        // setTimeout(() => {
        //   slidesEl.scrollTop = slidesEl.scrollHeight;
        // }, 100);
      }, 100);
    },
    handleDzFileAdded(files) {
      setTimeout(async () => {
        for (let i = 0; i < files.length; i++) {
          const params = {
            id: 'files-dz',
            current: i,
            total: files.length,
            type: 'attatched_files',
          };

          const file = files[i];
          const blob = await this.processFile(file);

          await this.uploadThumbnail(blob, params).then(result => {
            const { data } = result;

            const f = {
              fileName: file.name,
              mimeType: data.location.mimeType,
              title: data.location.path,
            };
            this.form.files = this.form.files.concat(common.buildIcons([f]));
            if (i === files.length - 1) {
              this.removeProgressCircle(params);
            }
          });
        }

        this.$refs.filesDZ.removeAllFiles();
      }, 100);
    },
    handleDzFileCompleted() {
      this.$refs.filesDZ.removeAllFiles();
    },
    handleDzSlideCompleted() {
      this.$refs.slidesDZ.removeAllFiles();
    },
    removeSlide(index) {
      this.watchUndoRemoveItem(this.form.slides, index).then(val => {
        this.form.slides = val;
      });
      this.form.slides = this.form.slides.filter((s, i) => i !== index);
    },
    removeFile(index) {
      this.watchUndoRemoveItem(this.form.files, index).then(val => {
        this.form.files = val;
      });
      this.form.files = this.form.files.filter((f, i) => i !== index);
    },
  async handleAvatarUpdated(files) {
  try {
    this.PendingUpload=true
    const blob = await this.processFile(files);
    const result = await this.uploadThumbnail(blob);
    const { data } = result;
if (result.status === 200) {
    this.uploadError = false; 
  }
    const f = {
      fileName: files.name,
      mimeType: data.location.mimeType,
      title: data.location.path,
      url: data.location.url,
    };

    this.form.Avatarfiles = this.form.files.concat(common.buildIcons([f]));
    this.file = this.form.Avatarfiles[0].title;
    this.url = this.form.Avatarfiles[0].url;
  } catch (error) {
    this.uploadError=true;
        this.PendingUpload=false

    console.error('Error occurred in handleAvatarUpdated:', error);
    throw error;
  }
},

    async handleThumbnailUpdated(thumbnail) {
      if(this.defaultThumbnail && this.defaultThumbnail!==null &&  this.defaultThumbnail!=='' && this.defaultThumbnail!==undefined) {
        if (!thumbnail) {
          NProgress.start();
        }
       this.confirmClicked = true;

      }
      this.form.thumbnail = thumbnail;
      NProgress.done();
    },

        handleEditingThumbnail (isEditing) {
      this.imageIsPicked = isEditing;
    },
    thumbnailConfirmed(isConfirmed){
      this.imageIsPicked=false;
      this.confirmClicked=false;
    },
    handleBeforeLivePosterUpdated(thumbnail) {
      this.form.conf.image = thumbnail;
    },
    handlePageChanged() {
      if (
        this.isEndReached('videos') ||
        this.isLoading('videos') ||
        !(
          this.form.conf.type === 'Video' &&
          this.initInfinitScrollVideos &&
          this.isBeforeLiveVideoPickerVisible
        )
      ) {
        return;
      }
      this.fetchVideos(this.searchVideoKeyword);
    },
    goToListLive() {
      parent.postMessage(
        {
          info: 'goToListLive',
          value: this.getDiffusion,
        },
        '*',
      );
      const cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    },
    disabledDate(value) {
      const today = new Date();
      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      return new Date(value) < yesterday;
    },
    getDefaultDiffusion(){
      if(this.getPermissions.length>0){
        this.form.diffusion=  this.getPermissions[0].name
        this.permissions.forEach(t => {
          this.form[t.name] = t.name === this.form.diffusion;
        });
      }
    },
    verifyCheckLimit() {
      setTimeout(() => {
        if (this.form.max_online_guests != null || this.form.max_onsite_guests != null) {
          this.checkedLimit = true;
        }
      }, 400);
    },
    resetSkinForm() {
    this.skinForm.skin = {

      primary_color: "#00a6d9",
      secondary_color: "#ecf6fa",
      text_primary_color: "#ffffff",
      text_secondary_color: "#000000",
      name: "",
      logo: null,
      before: {
        info_text: "",
        show_date: false,
        show_hour: false,
        background: null,
        background_blur: false
      },
      after: {
        info_text: "",
        show_date: false,
        show_hour: false,
        background: null,
        background_blur: false
      }
    };
  },
    buildSkinOptions(skins) {

      this.skinOptions = [
        // Placeholder
        { value: null, text: this.$t('form_live.tabs.SkinModel.choose') },
        // Create new, with bold style
        { value: 'new', text: this.$t('form_live.tabs.SkinModel.createNew')},
        ...skins.map(skin => ({
          value: skin.id,
          text: skin.name || `Modèle #${skin.id}` // fallback (prevents undefined)
        }))
      ];
    },
    selectSkinIfReady() {
    if (!this.form.liveSkinId || !(this.liveSkinsOptions && this.liveSkinsOptions.length)) return;

    const selected = this.liveSkinsOptions.find(
      s => String(s.id) === String(this.form.liveSkinId)
    );
    if (selected) this.skinConfirmed = selected;
  }
,
    onSelectSkin(value) {
    this.skinConfirmed=null;  
  if (value === "new") {
    // Reset the skin form for creation
    this.resetSkinForm();
    this.skinIsEditMode = false;
    return;
  }

  // ----- EXISTING SKIN -----
  const selected = this.liveSkinsOptions.find(s => s.id === value);

  if (!selected) return;
  // commenting this to allow edit skin
  this.skinIsEditMode = true;
  // Populate all fields safely using && and fallbacks
  this.skinConfirmed=selected;
  this.currentSkin = selected;
  this.skinForm.skin = {
    primary_color: selected.primaryColor || "#00a6d9",
    secondary_color: selected.secondaryColor || "#ecf6fa",
    text_primary_color: selected.primaryTextColor || "#ffffff",
    text_secondary_color: selected.secondaryTextColor || "#000000",
    name: selected.name || "",


    logo: selected.logo || null,
    logoPreview: selected.logo || null, // <-- set preview URL

    before: {
      info_text: (selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.title) || "",
      show_date: (selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.date) || false,
      show_hour: (selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.duration) || false,
      background: selected.beforeBackground || null,
      backgroundPreview: selected.beforeBackground || null, // <-- set preview URL
      background_blur: selected.bluredBeforeBackground || false
    },

    after: {
      info_text: (selected.afterLiveTextOptions && selected.afterLiveTextOptions.title) || "",
      show_date: (selected.afterLiveTextOptions && selected.afterLiveTextOptions.date) || false,
      show_hour: (selected.afterLiveTextOptions && selected.afterLiveTextOptions.duration) || false,
      background: selected.afterBackground || null,
      backgroundPreview: selected.afterBackground || null, // <-- set preview URL
      background_blur: selected.bluredAfterBackground || false
    }
  };
},

async uploadAndPreview(file, target, localPreview) {
    const formData = new FormData();
    formData.append('file', file);

    this.uploading[target] = true;

    try {
      const { data } = await axios.post(
        `${window.process.env.API_HOST_LIVE}/live/upload/skin`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${window.process.env.API_TOKEN}`,
          },
        }
      );

      const url = data.urlSkin;

      if (target === 'before') {
        this.skinForm.skin.before.background = url;
        this.skinForm.skin.before.backgroundPreview = url;
      } else if (target === 'after') {
        this.skinForm.skin.after.background = url;
        this.skinForm.skin.after.backgroundPreview = url;
      }
    } catch (error) {
      console.error('Upload failed', error);

      // ❌ rollback preview
      if (target === 'before') {
        this.skinForm.skin.before.backgroundPreview = null;
      } else {
        this.skinForm.skin.after.backgroundPreview = null;
      }
    } finally {
      this.uploading[target] = false;
      URL.revokeObjectURL(localPreview);
    }
  },

uploadLogo(e, target) {
    const file = e.target.files[0];
    if (!file) return;

    // 1️⃣ instant preview
    const localPreview = URL.createObjectURL(file);

    if (target === 'logo') {
      this.skinForm.skin.logoPreview = localPreview;
    } else if (target === 'before') {
      this.skinForm.skin.before.backgroundPreview = localPreview;
    } else if (target === 'after') {
      this.skinForm.skin.after.backgroundPreview = localPreview;
    }

    // 2️⃣ upload async
    this.uploadAndPreview(file, target, localPreview);
  },


  uploadBackground(e, target) {
    const file = e.target.files[0];
    if (!file) return;

    // 1️⃣ Instant preview
    const localPreview = URL.createObjectURL(file);

    if (target === 'before') {
      this.skinForm.skin.before.backgroundPreview = localPreview;
    } else {
      this.skinForm.skin.after.backgroundPreview = localPreview;
    }

    // 2️⃣ Upload async
    this.uploadAndPreview(file, target, localPreview);
  },

async saveAndApplySkin() {
  if(this.skinIsEditMode){
    try {
    const skin = this.skinForm.skin;



    const payload = {
      liveSkin: {
        name:  (skin.name && skin.name.trim()) || `Modèle ${Math.floor(Math.random() * 10000)}`,
        primaryColor: skin.primary_color,
        secondaryColor: skin.secondary_color,
        primaryTextColor: skin.text_primary_color,
        secondaryTextColor: skin.text_secondary_color,
        logo: skin.logo,
        beforeBackground: skin.before.background,
        afterBackground: skin.after.background,
        bluredBeforeBackground: skin.before.background_blur,
        bluredAfterBackground: skin.after.background_blur,
        beforeLiveTextOptions: {
          title:skin.before.info_text,
          date: skin.before.show_date,
          duration: skin.before.show_hour
        },
        afterLiveTextOptions: {
          title: skin.after.info_text,
          date: skin.after.show_date,
          duration: skin.after.show_hour
        }
      }
    };
    if(this.currentSkin.id){
      const { data } = await axios.patch(
      `${window.process.env.API_HOST_LIVE}/live/skin/${this.currentSkin.id}`,
      payload,
      {
        headers: {
            Authorization: `Bearer ${window.process.env.API_TOKEN}`,
          'Content-Type': 'application/json'
        }
      }
    );
    this.skinConfirmed = data.liveSkin.liveSkin;
    this.fetchLiveSkins();

    return data;
    }


  } catch (error) {
    console.error('Skin creation failed', error);
    return;

  }    
  }else {

  
  try {
    const skin = this.skinForm.skin;



    const payload = {
      liveSkin: {
        name:  (skin.name && skin.name.trim()) || `Modèle ${Math.floor(Math.random() * 10000)}`,
        primaryColor: skin.primary_color,
        secondaryColor: skin.secondary_color,
        primaryTextColor: skin.text_primary_color,
        secondaryTextColor: skin.text_secondary_color,
        logo: skin.logo,
        beforeBackground: skin.before.background,
        afterBackground: skin.after.background,
        bluredBeforeBackground: skin.before.background_blur,
        bluredAfterBackground: skin.after.background_blur,
        beforeLiveTextOptions: {
          title:skin.before.info_text,
          date: skin.before.show_date,
          duration: skin.before.show_hour
        },
        afterLiveTextOptions: {
          title: skin.after.info_text,
          date: skin.after.show_date,
          duration: skin.after.show_hour
        }
      }
    };

    const { data } = await axios.post(
      `${window.process.env.API_HOST_LIVE}/live/skin`,
      payload,
      {
        headers: {
            Authorization: `Bearer ${window.process.env.API_TOKEN}`,
          'Content-Type': 'application/json'
        }
      }
    );

    this.skinConfirmed = data.liveSkin.liveSkin;
    this.fetchLiveSkins();

    return data;

  } catch (error) {
    console.error('Skin creation failed', error);
    return;
  }
}
}
,
  getTypesSources(source){
     switch(source){
        case 'webinar':
          this.TypesToShow = this.TypesSources.filter((row)=> row.source == "Empreinte Live")
          break;
        default :
         this.TypesToShow =[]
          break;
      }
  }
  },
  created() {
    this.checkEditMode();
    this.fetchContributors();
    this.fetchSurveys();
    this.fetchVideos();
    this.fetchChannels();
    this.fetchLiveTypes();
    this.fetchAllintervenant();
    this.verifyCheckLimit();
    this.fetchCountries();
    this.fetchStations();
    this.fetchLiveSkins();
    this.fetchLivePolls();
    this.fetchPresentationSlides();
    this.fetchLiveDocuments();
  },
  async mounted() {
    try {

      if(this.isEmpreinteClient)
   { const typesLiveData = await axios.get(`${window.process.env.API_HOST_LIVE}/live/source/type`, {
  headers: {
    Authorization: `Bearer ${window.process.env.API_TOKEN}`,
  },
});

const sources = typesLiveData && typesLiveData.data && typesLiveData.data.liveSourcesTypes 
  ? typesLiveData.data.liveSourcesTypes 
  : [];

// Add permission field based on type
this.TypesSources = sources.map(source => {
  return {
    ...source,
    permission: this.getPermissionByType(source.type)
  };
});
      this.getTypesSources(this.form.diffusion)

}

      if (this.isEditMode) {
        const response = await axios.get(`${window.process.env.API_HOST_LIVE}/live/get-moderators/${this.$route.params.id}`, {
          headers: {
            Authorization: `${window.ApiToken}`,
          },
        });
        const moderators = this.getWebtvUsers.filter((user)=> {
          return !!response.data.data.find((moderator)=> moderator.webtvSubscriptionUser.email === user.email)
        })
        this.moderators = moderators;
        const response1 = await axios.get(`${window.process.env.API_HOST_LIVE}/live/get-participants/${this.$route.params.id}`, {
          headers: {
            Authorization: `${window.ApiToken}`,
          },
        });
        const apiParticpants = response1.data.data || [];
        const existingUsers = this.getWebtvUsers;
        
        const normalizedParticipants = apiParticpants.map(c => {
  const user = c.webtvSubscriptionUser;

  const existingUser = existingUsers.find(
    u => u.email === user.email
  );

  if (existingUser) {
    // ✅ return SAME object reference
    return existingUser;
  }
  return {
    id: `custom-${c.id}`,
    name:   user.email,
    email: user.email,
    firstName: '' ,
    lastName: '',
    isCustom:true
  };
});
this.form.participants.splice(0, this.form.participants.length, ...normalizedParticipants);
normalizedParticipants.forEach(c => {
  const exists = this.localParticipantOptions.some(o => o.email === c.email);
  if (!exists) this.localParticipantOptions.push(c);
});




        const response2 = await axios.get(`${window.process.env.API_HOST_LIVE}/live/get-contributors/${this.$route.params.id}`, {
          headers: {
            Authorization: `${window.ApiToken}`,
          },
        });
        const apiContributors = response2.data.data || [];
        const contributors = this.getWebtvUsers.filter((user)=> {
          return !!apiContributors.find((c)=> c.webtvSubscriptionUser.email === user.email)
        })
this.form.contributors = contributors
      }
        
    } catch(error) {
      console.log("error while fetching the moderators for this live : ",error)
      // this.showToast("error",this.$t("toast.getModeratorsError") );
    }


    // this.$root.$on('setFormLang', lang => {
    //   this.$i18n.locale = lang;
    //   i18n.locale = lang;
    // });


    if(this.defaultThumbnail && this.defaultThumbnail!==null && this.defaultThumbnail!=='' && this.defaultThumbnail!==undefined){
      if(!this.isEditMode ){
        this.getDefaultThumb()
        this.getDefaultDiffusion()
      }
    }
    this.$nextTick(() => {
      if (this.$i18n.locale === 'fr') {
        Datepicker.fecha.i18n.monthNamesShort = [
          'Jan',
          'Fev',
          'Mar',
          'Avr',
          'Mai',
          'Juin',
          'Juil',
          'Aout',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
      }
    });
    const today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    this.pastDates = {
      to: yesterday,
    };
    this.setupParticipantBulkListener();
  },
  beforeDestroy() {
    this.bulkEmailListenerCleanup.forEach(cleanup => cleanup());
    this.bulkEmailListenerCleanup = [];
  },
};

</script>

<style lang="scss">
@import '~styles/theme';
@import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
@import 'vue2-dropzone/dist/vue2Dropzone.min.css';
@import 'vue-multiselect/dist/vue-multiselect.min.css';

%box-shadow {
  position: relative;
  padding: 1em;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin-bottom: 2em;
}
.image-preview-wrapper {
  display: inline-block;
  line-height: 0; /* prevents extra height */
}

.preview-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.logo-preview {
  max-width: 150px;
  max-height: 80px;
  display: block;
}

.logo-preview.is-loading {
  opacity: 0.5;
}
.applied-skin-message{
  font-weight: 600;
  font-style: italic;
}
.applied-skin-message span {
  transition: opacity 0.2s ease;
}
.hidden-file-input {
  display: none;
}

/* Custom styled button */
.btn-upload {
  background-color:#039be5;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
    border: 1px solid #039be5;}

.btn-upload:hover {
  background-color: white;
  color:#039be5
}
.btn-upload:focus{
  outline: none;
}

/* Optional wrapper for spacing */
.custom-file-wrapper {
  display: inline-block;
  position: relative;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
}

.error_message{
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}

.create-live-wrapper {
  padding: 1em 0;
  form {
    &.was-validated {
      .form-group {
        &.is-invalid {
          &__custom {
            .mx-input-append,
            .input-group-text,
            .clock-picker__input-container:after {
              color: var(--primary-color, #dc3545);
              border-color: var(--primary-color, #dc3545);
              background-color: #fce1e3;
            }
            .form-control {
              border-color: var(--primary-color, #dc3545);
            }
            .invalid-feedback {
              display: block;
            }
          }
        }
      }
    }
    &.not-ready {
      opacity: 0.4;
      pointer-events: none;
    }
    .tabs-wrapper {
      position: relative;
      padding: 1em 1.5em;
      background-color: #fff;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
        0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      .tabs {
        .nav-tabs {
                    .nav-item {
            position: relative;
            &.has-error {
              background-color: rgba(244, 67, 54, 0.05);
              .nav-link {
                padding-right: 2rem;
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
                &.active {
                  border-bottom: 3px solid #f44336 !important;
                  background-color: transparent;
                }
                &:after {
                  position: absolute;
                  top: 10px;
                  font-size: 0.8em;
                  color: #f44336;
                  content: '\E904';
                  font-family: 'live-icon';
                  right: 10px;
                }
              }
            }
            &:not(.has-error) {
              .nav-link {
                &:hover {
                  color: inherit;
                  border-color: transparent !important;
                }
                &.active {
                  border-bottom: 3px solid var(--primary-color, $primary-color) !important;
                  background-color: transparent;
                }
              }
            }
            .nav-link {
              color: inherit;
              border: none;
              font-weight: 500;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
      .buttons-wrapper {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0.6em 1.5em;
        .btn {
          padding: 0.375rem 2rem;
        }
        .btn-primary {
          color: #fff;
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
          box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
            0 1px 1px var(--primary-color, $primary-color) !important;
        }
      }
      @media (max-width: 767px) { 
  .tabs {
    .nav-tabs {
      display: flex;
      justify-content: center;
      
   
    }
  }
}

      .form-group {
        &.is-invalid {
          .form-control {
            &:focus {
              border-color: #dc3545;
            }
          }
        }
        label {
          &.custom-control-label {
            margin-bottom: 0.5rem;
          }
          &.primary {
            font-weight: 500;
          }
          &.required:after {
            content: ' *';
            font-size: 13px;
            vertical-align: top;
            color: #d50000;
          }
        }
        .form-control {
          box-shadow: none !important;
          &:disabled,
          &[readonly] {
            background-color: #ffffff;
          }
        }
        .primary label {
          font-weight: 500;
        }
        div > div.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
          color: #fff;
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
        }
        .custom-control-input:checked ~ .custom-control-label::before {
          color: #fff;
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
        }
      }
      .rm-tabs-wrapper {
        position: relative;
        padding: 1em;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        margin-bottom: 2em;
        .tab-pane {
          // max-height: 495px;
        }
        .chapters-wrapper {
          .chapter-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 5px;
            margin-bottom: 5px;
            &:not(:last-child) {
              border-bottom: 1px solid #cdd3d9;
            }
            .chapter-container {
              display: flex;
              align-items: center;
              justify-content: start;
              width: 100%;
              .form-group {
                flex-grow: 1;
                position: relative;
              }
              &.question {
                align-items: start;
                justify-content: start;
                flex-grow: 1;
                .question-form-wrapper {
                  flex-grow: 1;
                }
                &.is-open {
                  background-color: #f1f3f4;
                  .sort-handler {
                    padding-top: 0.8em;
                    line-height: 42px;
                  }
                  .index {
                    padding-top: 0.8em;
                    line-height: 38px;
                  }
                }
              }
              .sort-handler {
                padding: 2px 6px;
                border-radius: 2px;
                font-size: 0.8em;
                margin-right: 0.4em;
                cursor: grab;
                color: #9fa7ab;
              }
              .index {
                font-weight: 600;
              }
            }
            &:hover {
              .rm-actions-wrapper button {
                opacity: 1;
                visibility: visible;
              }
            }
            .rm-actions-wrapper {
              display: flex;
              flex-wrap: nowrap;
              vertical-align: baseline;
              button {
                border-radius: 50%;
                opacity: 0;
                visibility: hidden;
                transition: opacity 0.2s ease, visibility 0.2s ease;
                &:first-child {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .slides-wrapper {
          margin-right: -30px;
          margin-left: -30px;
          padding: 0 15px;
          .scroll-area {
            margin: 15px 0 0;
          }
          .slide-wrapper {
            position: relative;
            margin-top: 1em;
            &:hover {
              .more-btn-container {
                opacity: 1;
                visibility: visible;
              }
            }
            .img-fluid {
              height: 100%;
              cursor: grab;
            }
            .type-tag {
              position: absolute;
              top: 3px;
              left: 18px;
              background-color: var(--primary-color, $primary-color) !important;
              color: #ffffff;
              padding: 0.1em 0.4em;
              border-radius: 0.125em;
            }
            img,
            video {
              width: 100%;
              vertical-align: top;
              border: none;
              object-fit: cover;
              height: 100%;
              border-radius: 2px;
            }
            .more-btn-container {
              position: absolute;
              right: 8px;
              top: 0;
              opacity: 0;
              visibility: hidden;
              transition: opacity 0.2s ease, visibility 0.2s ease;
              button {
                color: #ffffff;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
                padding-top: 0.5em;
              }
              .dropdown-menu {
                transform: translate3d(-90px, 30px, 0px) !important;
                padding: 2px 0;
                min-width: 120px;
                .dropdown-item {
                  padding: 2px 8px;
                  &:active,
                  .active,
                  &:hover {
                    color: #fff;
                    background-color: var(--primary-color, $primary-color) !important;
                    border-color: var(--primary-color, $primary-color) !important;
                  }
                }
              }
            }
          }
        }
      }
      .sub-form-control {
        padding-left: 1.5em;
        padding-top: 0.5em;
      }
      .video-picker-wrapper {
        position: relative;
        padding: 1em;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        .video-slides-wrapper {
          figure {
            cursor: pointer;
            position: relative;
            border-radius: 3px;
            overflow: hidden;
            margin-bottom: 0.2em;
            &:hover {
              .video-overlay {
                opacity: 1;
                visibility: visible;
              }
            }
            .video-overlay {
              position: absolute;
              height: 100%;
              width: 100%;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              background: var(--primary-color, $primary-color) !important;
              opacity: 0;
              visibility: hidden;
              transition: all 0.2s ease;
              display: flex;
              align-items: center;
              justify-content: center;
              &.in {
                opacity: 1;
                visibility: visible;
              }
              .btn {
                border-radius: 0.2em;
                &.btn-outline-light:hover {
                  color: var(--primary-color, $primary-color) !important;
                }
                &.btn-light {
                  color: var(--primary-color, $primary-color) !important;
                  &:hover {
                    background-color: #ffffff;
                    border-color: #ffffff;
                  }
                }
              }
            }
            .img {
              width: 100%;
            }
          }
          .video-name {
            margin: 0 10px 0 0;
            font-size: 0.8em;
            word-wrap: break-word;
            line-height: 1.2em;
            height: 2.4em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            &.selected {
              color: var(--primary-color, $primary-color) !important;
            }
          }
        }
      }
      .start-date-picker {
        .vdp-datepicker {
          &__calendar {
            border-radius: 3px;
            margin-top: 1px;
            margin-bottom: 1px;
            bottom: 100%;
            header {
              span {
                border-radius: 3px;
                &.prev,
                &.next {
                  text-indent: initial;
                  color: transparent;
                  &:after {
                    color: #444444;
                    font-size: 0.8em;
                    font-family: 'live-icon', serif;
                    border: none;
                    margin: 0;
                  }
                }
                &.prev:after {
                  content: '\e908';
                }
                &.next:after {
                  content: '\e90a';
                }
              }
            }
            .cell {
              border-radius: 2px;
              &.selected,
              &.actived {
                background: var(--primary-color, $primary-color) !important;
                color: #ffffff;
              }
              &:not(.blank):not(.disabled) {
                &.day,
                &.month,
                &.year {
                  &:hover {
                    border-color: var(--primary-color, $primary-color) !important;
                  }
                }
              }
            }
          }
        }
      }
      .clock-picker {
        &__input-container {
          position: relative;
          &:after {
            font-family: 'live-icon', serif;
            content: '\e907';
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            padding: 0.375rem 0.75rem;
            margin-bottom: 0;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            text-align: center;
            white-space: nowrap;
            background-color: #e9ecef;
            border: 1px solid #ced4da;
            border-radius: 0.1em;
          }
          input.form-control {
            padding-left: 3em;
          }
        }
        &__dialog-header {
          padding: 1rem 1.5rem;
        }
        &__dialog-content {
          text-align: center;
        }
        &__dialog-actions {
          padding: 0;
        }
        &__dialog-action {
          padding: 0.5rem 1rem;
          &:nth-child(2):not(:disabled) {
            background-color: var(--primary-color, $primary-color) !important;
            color: #ffffff !important;
          }
        }
      }
      .vue-input-tag-wrapper {
        border-color: #ced4da;
        border-radius: 0.1em;
        .input-tag {
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
          border-radius: 15px;
          padding: 4px 4px 3px 15px;
          color: #fff;
          .remove {
            color: #f1f3f4;
            &:hover {
              &:before {
                background: var(--primary-color, $primary-color) !important;
              }
            }
            &:before {
              content: '\D7';
              font-size: 1.2em;
              line-height: 16px;
              vertical-align: middle;
              margin-left: 8px;
              padding: 3px;
              width: 22px;
              display: inline-block;
              text-align: center;
              border-radius: 50%;
              transition: all 0.2s ease;
            }
          }
        }
      }
      .multiselect {
        &__tag,
        &__option--highlight,
        &__option--highlight:after {
          background: var(--primary-color, $primary-color) !important;
        }
        &__tag {
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
          border-radius: 15px;
          padding: 8px 30px 8px 15px;
          color: #fff;
          margin-bottom: 0;
        }
        &__tag-icon {
          right: 4px;
          top: 4px;
          bottom: 4px;
          width: 22px;
          line-height: 22px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.4);
          &:focus,
          &:after {
            color: var(--primary-color, $primary-color) !important;
          }
        }
      }
      .vue-dropzone {
        border-style: dashed;
        border-radius: 0.4em;
        background-color: #f7f7f7;
        position: relative;
        .dz-message {
          font-size: 0.8em;
          display: block !important;
          .icon {
            display: block;
            font-size: 4em;
            color: #b6c0c3;
          }
        }
        .dz-preview {
          display: none;
        }
      }
      .attached-files-wrapper {
        display: flex;
        flex-wrap: wrap;
        margin: -15px -0.5em 10px;
        .attached-file {
          position: relative;
          flex: 0 0 0;
          padding: 0.2em;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0.5em;
          background-color: #f1f1f1;
          min-width: 100px;
          overflow: hidden;
          &:hover {
            .attached-file__btn-remove {
              opacity: 1;
              visibility: visible;
            }
          }
          &__icon {
            font-size: 3em;
            color: #859cab;
          }
          &__name {
            font-size: 0.8em;
            margin-bottom: 5px;
            line-height: 1.2em;
            height: 2.4em;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-weight: 600;
            text-align: center;
            width: 100%;
          }
          &__btn-remove {
            position: absolute;
            right: 0;
            top: 0;
            padding: 0.2em;
            border: none;
            color: $danger;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.2s ease, visibility 0.2s ease;
            &:hover {
              color: darken($danger, 10%);
            }
          }
        }
      }
      .btn-remove {
        color: $danger;
        &:hover {
          color: darken($danger, 10%);
        }
      }
      .nav{
      width: 80%;
      @media screen and (max-width: 1200px){
        width: 70%;

      }
      @media screen and (max-width: 992px){
        width: 100%;

      }
    }
    }
  }
  .scroll-area {
    max-height: 300px;
    min-height: 180px;
    padding: 0 15px;
    margin: 0 -15px;
    &.scroll-chapters {
      max-height: 440px;
    }
    &.scroll-questions {
      max-height: 450px;
    }
  }
  .inline-submit-btn {
    position: absolute;
    top: 0;
    right: 0;
    margin: 3px;
  }
  .add-item-wrapper {
    padding: 1em 1em 0;
    margin: 0 -1em;
    border-top: 1px solid #e8e8e8;
    button.btn.btn-link {
      box-shadow: none !important;
      text-decoration: none;
      color: var(--primary-color, $primary-color) !important;
    }
  }
  .before-live-video-container {
    figure {
      max-width: 100%;
      width: 360px;
      border-radius: 3px;
      overflow: hidden;
      position: relative;
      margin-bottom: 0.2em;
      .img {
        width: 100%;
      }
    }
    &__btn {
      position: absolute;
      top: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      margin: 0.5em;
      color: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.5);
    }
    &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 3em;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  .was-validated .form-control:invalid ~ .video-picker-wrapper {
    border-color: #dc3545;
  }
}
.filter-date {
  .custom-control-label {
    padding-left: 5px;
  }
  .mx-datepicker {
    width: 100%;
    .mx-datepicker-popup {
      .mx-calendar.mx-calendar-panel-date {
        .mx-calendar-content {
          .cell.actived:not(.today) {
            color: #fff !important;
            background-color: var(--primary-color, $primary-color) !important;
            border-color: var(--primary-color, $primary-color) !important;
            box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
              0 1px 1px var(--primary-color, $primary-color) !important;
          }
          .mx-panel-date td.today {
            color: var(--primary-color, $primary-color) !important;
            background-color: #fff !important;
            border-color: #fff !important;
            &.actived {
              color: #fff !important;
              background-color: var(--primary-color, $primary-color) !important;
              border-color: var(--primary-color, $primary-color) !important;
              box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
                0 1px 1px var(--primary-color, $primary-color) !important;
            }
          }
        }
      }
    }
  }
  .mx-datepicker.input-text {
    padding: 0 !important;
    border: 1px solid #dee2e6 !important;
    box-shadow: none;
    width: 100%;
  }
  input.mx-input {
    box-shadow: none;
    padding: 0 10px;
  }
  i.mx-input-icon.mx-clear-icon {
    font-size: 14px;
  }
}

.Image-upload-container {
  display: flex;
  align-items: center;
}

.image-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 180px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  background: #FAFAFA;
}
.clickable-text {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
}
.loading-icon{
    display: flex;
  align-items: center;

}

.upload-button {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8px;
}


.uploaded-image {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: contain;
}

.image-info {
  display: flex;
  align-items: flex-start;
  margin-left: 8px;
}

.trash-icon {
  cursor: pointer;
  margin-right: 8px;
}
.vdp-datepicker {
  &.input-text {
    input[type='text'] {
      font-size: 14px;
    }
  }
  .vdp-datepicker__clear-button {
    position: absolute;
    top: 10px;
    right: 0;
  }
}
.vdp-datepicker__calendar {
  font-size: 14px;
  .input-text {
    input[type='text'] {
      font-size: 14px;
    }
  }
}
.selectedDate {
  padding: 0 3.1em;
}
.mx-input-append {
  left: 0;
  background-color: #e9ecef;
  width: 42px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  //color: #495057;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ced4da;
  border-radius: 0.1em;
}
// new css
::v-deep .filter-date .mx-panel-date td.today {
  color: var(--primary-color, $primary-color) !important;
}

.screen-share-select option {
  &:hover,
  &:indeterminate {
    color: #fff;
    background-color: var(--primary-color, $primary-color) !important;
    border-color: var(--primary-color, $primary-color) !important;
  }
}
.btn-primary {
  color: #fff;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;
}
.conf-label[disabled='disabled'] {
  color: #6c757d;
}
.action-start-direct{
  display: flex;
  justify-content: center;
  margin-top: 1em;
  margin-bottom: 1em;
}
.action-choix{
  display: flex;
  justify-content: center;
  margin-bottom: -1em;
}


#modal-start-direct {
  .modal-dialog {
    justify-content: center;
    display: flex;
  }
  .modal-content{
    width: 85% !important;
  }
@media screen and (max-width: 990px){
  .action-choix , .desc{
    font-size: 14px!important;
  }
  .modal-content{
    width: 100% !important;
  }
  .subTitle{
    font-size: 20px;
  }
}
}
  .subTitle {
    display: flex;
    justify-content: center;
    font-size: 22px;
    margin-bottom: 0.5em;
  }
.bg-custom-secondary {
  background-color: #f2f2f2 !important;
}
  .webinar-type{
    margin-top: 25px;
    &__radio{
      padding-right: 0!important;
      .custom-radio{
        margin-right: 0 !important;
      }
    }
  }
  .error-message {
  color: red;
  font-size: 0.8em;
  margin-top: 5px;
}
.required-star{
  color: #d50000;
}
.intervenant{
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-items: flex-start;
    width: 80%;
    margin-left: 15px;
}
.speaker-btns{
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.collapse-content{
      padding: 16px 24px;

}
.collapsible-section {
  .section-header {
    background: #f3f4f6;
    padding: 16px 24px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  //  transition: background-color 0.2s ease;
    user-select: none;

    &:hover {
      background: #e5e7eb;
    }

    label {
      margin: 0;
      cursor: pointer;
      font-weight: 600;
      color: #374151;
    }

    i {
      color: #6b7280;
      // transition: transform 0.2s ease;
      font-size: 14px;
    }
  }

  .collapse-content {
    padding: 24px;
  }
}
.settings-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  // padding: 24px;
  margin-bottom: 24px;
}
.polls-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.presentation-upload-panel {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}
.presentation-upload-box {
  width: 82px;
  height: 56px;
  border: 1px dashed #b8bac8;
  border-radius: 10px;
  background: #fbfbfd;
  color: #7a00d1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.presentation-upload-box:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.presentation-upload-panel__meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  color: #374151;
}
.presentation-upload-panel__meta strong {
  font-size: 14px;
  color: #111827;
}
.presentation-upload-panel__meta span {
  font-size: 12px;
  color: #6b7280;
}
.presentation-upload-panel__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.presentation-empty-state {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
}
.presentation-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: 360px;
  overflow-y: auto;
  padding-right: 6px;
}
.presentation-list-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%);
  border: 1px solid #e2e5ee;
}
.presentation-list-item__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  flex-shrink: 0;
}
.presentation-list-item__icon--pdf {
  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);
}
.presentation-list-item__icon--ppt {
  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);
}
.presentation-list-item__icon--doc {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}
.presentation-list-item__icon--file {
  background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
}
.presentation-list-item__content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}
.presentation-list-item__title {
  font-size: 14px;
  color: #111827;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.presentation-list-item__meta {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.presentation-list-item__actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.presentation-action-button {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.poll-empty-state {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
}
.poll-tabs {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-bottom: 16px;
}
.poll-tab {
  min-width: 220px;
  max-width: 280px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8fafc;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #111827;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}
.poll-tab:hover {
  border-color: #93c5fd;
  background: #eff6ff;
}
.poll-tab , button:focus {
  outline : none !important;
}
.poll-tab--active {
  border-color: var(--primary-color);
  background: #eff6ff;
 // box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}
.poll-tab--add {
  justify-content: center;
  border-style: dashed;
  border-color: #93c5fd;
  background: #f8fbff;
  color: #1d4ed8;
}
.poll-tab--add:hover {
  border-color: var(--primary-color);
}
.poll-tab--add:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #94a3b8;
}
.poll-tab__eyebrow {
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.poll-tab__title {
  font-size: 14px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.poll-tab__meta {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
}
.poll-tab__warning {
  color: #b45309;
  font-weight: 600;
}
.poll-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  background: #ffffff;
}
.poll-card__subtitle {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}
.poll-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.poll-delete-actions {
  position: relative;
}
.poll-delete-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #dc2626;
}
.poll-delete-button:hover,
.poll-delete-button:focus {
  color: #b91c1c;
  background: #fee2e2;
}
.poll-option-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
  position: relative;
}
.poll-option-row__input {
  flex: 1;
}
.poll-option-row__delete {
  margin-bottom: 2px;
}
.confirm-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  min-width: 190px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
}
.confirm-tooltip--option {
  top: auto;
  bottom: calc(100% + 8px);
}
.confirm-tooltip__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
.poll-card__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}
.participant-import-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  margin-bottom: 12px;
  // border: 1px solid var(--primary-color, #2096f8) !important;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%);
}
.participant-import-card__content {
  min-width: 0;
}
.participant-import-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #16324f;
}
.participant-import-card__text {
  margin-top: 4px;
  font-size: 12px;
  color: #5b6b7f;
}
.participant-import-card__button {
  border: 0;
  border-radius: 999px;
  padding: 10px 16px;
  background: #2096f8;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 10px 20px rgba(32, 150, 248, 0.18);
}
.participant-import-card__button:hover,
.participant-import-card__button:focus {
  background: #127fda;
  outline: none;
}
.documents-share-panel {
  padding: 18px;
  border: 1px solid #d9e4f2;
  border-radius: 14px;
  background: #f8fbff;
  width: 100%;
}
.documents-share-panel__header,
.documents-share-panel__actions,
.documents-share-item,
.documents-share-item__controls {
  display: flex;
  gap: 12px;
}
.documents-share-panel__header,
.documents-share-item {
  justify-content: space-between;
  align-items: center;
}
.documents-share-panel__title {
  font-size: 16px;
  font-weight: 700;
}
.documents-share-panel__actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}
.documents-share-panel__hint,
.documents-share-panel__state {
  margin: 14px 0 0;
  font-size: 13px;
  color: #5b6b7f;
}
.documents-share-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.documents-share-item {
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e4ebf5;
}
.documents-share-item__main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.documents-share-item__name {
  font-weight: 600;
  color: #16324f;
  word-break: break-word;
}
.documents-share-item__status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  background: #d1d5db;
  border: 1px solid #cbd5e1;
  flex-shrink: 0;
}
.documents-share-item__status.is-public {
  background: #28a745;
  border-color: #28a745;
}
.documents-share-item__status.is-private {
  background: #ffc107;
  border-color: #ffc107;
}
.documents-share-item__status.is-pending {
  background: #6c757d;
  border-color: #6c757d;
}
.documents-share-item__controls {
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}
.documents-share-item__controls .btn {
  min-width: 40px;
}
.documents-share-item__controls .btn + .btn {
  margin-left: 8px;
}
.documents-share-item__icon--public {
  color: #28a745;
}
.documents-share-item__icon--private {
  color: #ffc107;
}
.documents-share-item__icon--pending {
  color: #6c757d;
}
.documents-share-panel .b-button {
  min-width: 100px;
}
@media (max-width: 767px) {
  .presentation-upload-panel,
  .polls-toolbar,
  .poll-card__header,
  .poll-option-row,
  .poll-card__actions,
  .documents-share-panel__header,
  .documents-share-item {
    flex-direction: column;
    align-items: stretch;
  }

  .poll-option-row__delete {
    margin-bottom: 0;
  }

  .poll-empty-state {
    align-items: stretch;
  }

  .presentation-empty-state,
  .presentation-upload-panel__actions,
  .presentation-list-item__actions,
  .documents-share-item__controls {
    align-items: stretch;
    justify-content: stretch;
    flex-direction: column;
  }

  .presentation-list-item {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .poll-tab {
    min-width: 190px;
  }

  .participant-import-card {
    flex-direction: column;
    align-items: stretch;
  }

  .confirm-tooltip,
  .confirm-tooltip--option {
    position: static;
    margin-top: 8px;
  }
}
// Override Bootstrap collapse to add padding
// .collapse {
//   &.show, &.collapsing {
//     padding: 24px;
//   }
// }
.documents-share-panel {
  max-width: 100%;
  padding: 0;
  border: none;
  border-radius: 12px;
  overflow: hidden;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.08);

    label {
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
    }
  }

  &__actions {
    display: flex;
    gap: 10px;
  }

  &__hint,
  &__state {
    color: #7a8aad;
    font-size: 13px;
    padding: 16px 20px;
  }
}

.documents-share-list {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.documents-share-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: 8px;
  &__main {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;

    &::before {
      content: '📎';
      font-size: 14px;
      flex-shrink: 0;
    }
  }

  &__name {
    font-weight: 500;
    color: #e2e8f0;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__meta {
    margin-top: 3px;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    color: #94a3b8;

    &.is-public {
      color: #4ade80;
    }

    &.is-pending {
      color: #fbbf24;
    }
  }

  &__controls {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }
}

// Override button styles inside dark panel
.documents-share-panel {
  .btn-outline-warning {
    color: #f59e0b;
    border-color: rgba(245, 158, 11, 0.4);
  }

  .btn-outline-danger {
    color: #ef4444;
    border-color: rgba(239, 68, 68, 0.4);
  }

  // .btn-light {
  //   background: rgba(255,255,255,0.08);
  //   border-color: rgba(255,255,255,0.12);
  //   color: #e2e8f0;

  //   &:hover {
  //     background: rgba(255,255,255,0.15);
  //   }
  // }

  .btn-primary {
    background: #7c3aed !important;
    border-color: #7c3aed !important;
    box-shadow: none !important;
  }

  .custom-checkbox .custom-control-label {
    color: #94a3b8;
    font-size: 13px;
  }
}

// Publish default checkbox at bottom
.documents-publish-default {
  padding: 14px 20px;
  border-top: 1px solid rgba(255,255,255,0.08);
  .custom-control-label {
    color: #94a3b8;
    font-size: 13px;
  }
}
.fp-files-section {
  .fp-toggle-row {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    width: fit-content;
    margin-bottom: 0;
  }
  .fp-toggle-label {
    font-size: 14px;
    font-weight: 400;
    color: inherit;
  }
  .fp-panel {
    margin-top: 12px;
    border: 0.5px solid #e2e8f0;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
  }
  .fp-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 0.5px solid #e2e8f0;
    i { font-size: 17px; color: #94a3b8; }
    background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%)
  }
  .fp-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .fp-title { font-size: 14px; font-weight: 500; margin: 0; }
  .fp-count {
    font-size: 12px;
    color: #64748b;
    background: #f1f5f9;
    padding: 2px 8px;
    border-radius: 999px;
    border: 0.5px solid #e2e8f0;
  }
  .fp-upload-btn {
    display: inline-flex !important;
    align-items: center;
    gap: 6px;
    padding: 6px 14px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--primary-color, $primary-color) !important;
    background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%) !important;
    border: 0.5px solid var(--primary-color, $primary-color) !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    text-decoration: none !important;
    i { font-size: 15px; }
    &:hover { opacity: 0.8; }
  }
  .fp-default-row {
    padding: 8px 16px;
    background: #f8fafc;
    border-bottom: 0.5px solid #e2e8f0;
    font-size: 13px;
    color: #64748b;
  }
  .fp-state, .fp-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 6px;
    padding: 32px 16px;
    color: #94a3b8;
    font-size: 13px;
    i { font-size: 26px; opacity: 0.4; }
  }
  .fp-save-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px 0;
    color: #64748b;
    font-size: 13px;
  }
  .fp-list {
    padding: 4px 0;
    max-height: 360px;
    overflow-y: auto;
  }
  .fp-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    transition: background 0.1s;
    &:not(:last-child) { border-bottom: 0.5px solid #f1f5f9; }
    &:hover { background: #f8fafc; }
  }
  .fp-item-icon {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    border-radius: 7px;
    background: #f1f5f9;
    border: 0.5px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    i { font-size: 16px; color: #64748b; }
    &.is-image {
      background: #ecfdf5;
      border-color: #bbf7d0;
      i { color: #16a34a; }
    }
    &.is-video {
      background: #eff6ff;
      border-color: #bfdbfe;
      i { color: #2563eb; }
    }
    &.is-audio {
      background: #f5f3ff;
      border-color: #ddd6fe;
      i { color: #7c3aed; }
    }
    &.is-pdf {
      background: #fef2f2;
      border-color: #fecaca;
      i { color: #dc2626; }
    }
    &.is-word {
      background: #eff6ff;
      border-color: #bfdbfe;
      i { color: #1d4ed8; }
    }
    &.is-powerpoint {
      background: #fff7ed;
      border-color: #fed7aa;
      i { color: #ea580c; }
    }
    &.is-excel {
      background: #f0fdf4;
      border-color: #bbf7d0;
      i { color: #15803d; }
    }
    &.is-archive {
      background: #fffbeb;
      border-color: #fde68a;
      i { color: #b45309; }
    }
  }
  .fp-item-info { flex: 1; min-width: 0; }
  .fp-item-name {
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .fp-item-owner {
    font-size: 11px;
    color: #64748b;
    margin-top: 2px;
  }
  .fp-item-meta { margin-top: 3px; }
  .fp-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 500;
    i { font-size: 11px; }
  }
  .fp-badge-public  { background: #dcfce7; color: #15803d; border: 0.5px solid #bbf7d0; }
  .fp-badge-private { background: #f1f5f9; color: #64748b; border: 0.5px solid #e2e8f0; }
  .fp-badge-pending { background: #fef9c3; color: #a16207; border: 0.5px solid #fde68a; }
  .fp-item-actions { display: flex; gap: 6px; flex-shrink: 0; }
  .fp-btn {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    border: 0.5px solid #e2e8f0;
    background: transparent;
    color: #64748b;
    cursor: pointer;
    transition: all 0.1s;
    i { font-size: 15px; }
    &:hover { background: #f1f5f9; color: #1e293b; }
    &:disabled { opacity: 0.4; cursor: not-allowed; }
  }
  .fp-btn-danger:hover {
    background: #fee2e2 !important;
    color: #dc2626 !important;
    border-color: #fecaca !important;
  }
  .fp-slide-enter-active, .fp-slide-leave-active {
    transition: opacity 0.15s ease;
  }
  .fp-slide-enter, .fp-slide-leave-to { opacity: 0; }
}
.fp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 0.5px solid #e5e7eb;
  flex-wrap: wrap;
  gap: 10px;
}

.fp-count {
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 6px;
}

.fp-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.fp-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: opacity 0.15s ease, background 0.15s ease;
  white-space: nowrap;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &--primary {
    background: #e0f0ff;
    color: #1a6fbf;
    border-color: #b3d4f5;

    &:hover:not(:disabled) {
      background: #cce4ff;
    }
  }

  &--toggle {
    background: #f3f4f6;
    color: #374151;
    border-color: #e5e7eb;
    margin-bottom: 0;

    &:hover:not(:disabled) {
      background: #e9eaec;
    }

    &.is-active {
      background: #ecfdf5;
      color: #065f46;
      border-color: #6ee7b7;
    }
  }

  &--danger {
    background: #fff1f1;
    color: #b91c1c;
    border-color: #fecaca;

    &:hover:not(:disabled) {
      background: #fee2e2;
    }
  }
}

.fp-icon-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: #f3f4f6;
    color: #111827;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &--danger {
    color: #dc2626;
    border-color: #fecaca;
    background: #fff1f1;

    &:hover:not(:disabled) {
      background: #fee2e2;
    }
  }
}
 .fp-upload-btn {
    display: inline-flex !important;
    align-items: center;
    gap: 6px;
    padding: 6px 14px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--primary-color, $primary-color) !important;
    background:linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%) !important;
    border: 0.5px solid var(--primary-color, $primary-color) !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    text-decoration: none !important;
    i { font-size: 15px; }
    &:hover { opacity: 0.8; }
  }
</style>



// WEBPACK FOOTER //
// src/components/LiveForm.vue